var _regeneratorRuntime = require("/home/deploy/fe/v9/tigo-home-activator-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

!function (e, n) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = n();else if ("function" == typeof define && define.amd) define([], n);else {
    var t = n();

    for (var r in t) {
      ("object" == typeof exports ? exports : e)[r] = t[r];
    }
  }
}(window, function () {
  return function (e) {
    var n = {};

    function t(r) {
      if (n[r]) return n[r].exports;
      var a = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(a.exports, a, a.exports, t), a.l = !0, a.exports;
    }

    return t.m = e, t.c = n, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        enumerable: !0,
        get: r
      });
    }, t.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.t = function (e, n) {
      if (1 & n && (e = t(e)), 8 & n) return e;
      if (4 & n && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (t.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & n && "string" != typeof e) for (var a in e) {
        t.d(r, a, function (n) {
          return e[n];
        }.bind(null, a));
      }
      return r;
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }, t.p = "", t(t.s = 51);
  }([function (e, n) {
    e.exports = require("react");
  }, function (e, n) {
    e.exports = require("styled-components");
  }, function (e, n) {
    e.exports = require("prop-types");
  }, function (e, n) {
    e.exports = require("@material-ui/core/styles");
  }, function (e, n) {
    e.exports = require("@material-ui/core");
  }, function (e, n) {
    e.exports = require("moment");
  }, function (e, n) {
    e.exports = require("@material-ui/core/Button");
  }, function (e, n) {
    e.exports = require("@material-ui/icons/Check");
  }, function (e, n) {
    e.exports = require("@material-ui/icons/ExpandMore");
  }, function (e, n) {
    e.exports = require("@material-ui/core/ListItem");
  }, function (e, n) {
    e.exports = require("@material-ui/core/Checkbox");
  }, function (e, n) {
    e.exports = require("@material-ui/core/ListItemText");
  }, function (e, n) {
    e.exports = require("@material-ui/core/TextField");
  }, function (e, n) {
    e.exports = require("@material-ui/core/CircularProgress");
  }, function (e, n) {
    e.exports = require("@material-ui/icons/CheckCircle");
  }, function (e, n) {
    e.exports = require("@material-ui/core/FormControlLabel");
  }, function (e, n) {
    e.exports = require("@material-ui/icons/ExpandMoreOutlined");
  }, function (e, n) {
    e.exports = require("clsx");
  }, function (e, n) {
    e.exports = require("@material-ui/icons/ExpandLess");
  }, function (e, n) {
    e.exports = require("@material-ui/core/List");
  }, function (e, n) {
    e.exports = require("@material-ui/core/Typography");
  }, function (e, n) {
    e.exports = require("exif-js");
  }, function (e, n) {
    e.exports = require("@material-ui/icons/Close");
  }, function (e, n) {
    e.exports = require("@material-ui/icons/HighlightOffSharp");
  }, function (e, n) {
    e.exports = require("@material-ui/icons/Warning");
  }, function (e, n) {
    e.exports = require("@material-ui/core/FormGroup");
  }, function (e, n) {
    e.exports = require("@material-ui/core/Select");
  }, function (e, n) {
    e.exports = require("@material-ui/core/InputLabel");
  }, function (e, n) {
    e.exports = require("@material-ui/core/FormControl");
  }, function (e, n) {
    e.exports = require("@material-ui/core/ExpansionPanel");
  }, function (e, n) {
    e.exports = require("@material-ui/core/ExpansionPanelSummary");
  }, function (e, n) {
    e.exports = require("@material-ui/core/ExpansionPanelDetails");
  }, function (e, n) {
    e.exports = require("@material-ui/core/Stepper");
  }, function (e, n) {
    e.exports = require("@material-ui/core/Step");
  }, function (e, n) {
    e.exports = require("@material-ui/core/StepLabel");
  }, function (e, n) {
    e.exports = require("@material-ui/pickers");
  }, function (e, n) {
    e.exports = require("@material-ui/core/styles/withStyles");
  }, function (e, n) {
    e.exports = require("@material-ui/pickers/views/Calendar/Day");
  }, function (e, n) {
    e.exports = require("browser-image-compression");
  }, function (e, n) {
    e.exports = require("compressorjs");
  }, function (e, n) {
    e.exports = require("@material-ui/core/Tabs");
  }, function (e, n) {
    e.exports = require("@material-ui/core/Tab");
  }, function (e, n) {
    e.exports = require("@material-ui/core/Collapse");
  }, function (e, n) {
    e.exports = require("react-signature-canvas");
  }, function (e, n) {
    e.exports = require("@material-ui/lab/Autocomplete");
  }, function (e, n) {
    e.exports = require("@material-ui/icons/Info");
  }, function (e, n) {
    e.exports = require("@material-ui/icons/Cancel");
  }, function (e, n) {
    e.exports = require("@material-ui/icons/Search");
  }, function (e, n) {
    e.exports = require("@material-ui/core/Radio");
  }, function (e, n) {
    e.exports = require("@material-ui/icons/SwapVert");
  }, function (e, n) {
    e.exports = require("@material-ui/icons");
  }, function (e, n, t) {
    "use strict";

    t.r(n), t.d(n, "Input", function () {
      return j;
    }), t.d(n, "Button", function () {
      return R;
    }), t.d(n, "Header", function () {
      return Q;
    }), t.d(n, "Layout", function () {
      return nn;
    }), t.d(n, "Label", function () {
      return me;
    }), t.d(n, "Card", function () {
      return un;
    }), t.d(n, "MenuItem", function () {
      return Cn;
    }), t.d(n, "Loader", function () {
      return te;
    }), t.d(n, "Radio", function () {
      return Nn;
    }), t.d(n, "Sidebar", function () {
      return Xn;
    }), t.d(n, "StatusMessage", function () {
      return Ve;
    }), t.d(n, "getIconColor", function () {
      return Ze;
    }), t.d(n, "PopUp", function () {
      return pt;
    }), t.d(n, "Checkbox", function () {
      return St;
    }), t.d(n, "ProductDetails", function () {
      return tr;
    }), t.d(n, "CartItem", function () {
      return cr;
    }), t.d(n, "Dropdown", function () {
      return $t;
    }), t.d(n, "Accordion", function () {
      return Pr;
    }), t.d(n, "Stepper", function () {
      return Dr;
    }), t.d(n, "Datepicker", function () {
      return ta;
    }), t.d(n, "CameraInstructions", function () {
      return ia;
    }), t.d(n, "DocumentImageThumbnail", function () {
      return ua;
    }), t.d(n, "Scanner", function () {
      return Ba;
    }), t.d(n, "NewScanner", function () {
      return Ja;
    }), t.d(n, "Icon", function () {
      return co;
    }), t.d(n, "SwipeableTabs", function () {
      return Io;
    }), t.d(n, "PackageItem", function () {
      return mi;
    }), t.d(n, "Signature", function () {
      return Mi;
    }), t.d(n, "AutoComplete", function () {
      return il;
    }), t.d(n, "AutoCompleteList", function () {
      return gl;
    }), t.d(n, "StyledRadio", function () {
      return Sl;
    }), t.d(n, "StyledPackagesCard", function () {
      return Wl;
    }), t.d(n, "StyledAddOnCard", function () {
      return ic;
    }), t.d(n, "StyledPopup", function () {
      return kc;
    }), t.d(n, "CollapsibleList", function () {
      return ni;
    }), t.d(n, "SalesReportFilter", function () {
      return Uc;
    }), t.d(n, "LoaderButton", function () {
      return ss;
    }), t.d(n, "LocationPopUp", function () {
      return Ws;
    }), t.d(n, "BackButton", function () {
      return Us;
    });
    var r,
        a,
        o = t(0),
        i = t.n(o),
        l = t(2),
        c = t.n(l),
        s = t(12),
        u = t.n(s),
        p = t(1),
        d = t.n(p);

    function f(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var m = d.a.div(r || (r = f(["\n  margin: 10px 0px;\n  width: 100%;\n"]))),
        h = d.a.div(a || (a = f(["\n  svg {\n    color: #b7b7b7 !important;\n  }\n"]))),
        g = t(3),
        b = function b() {
      return i.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "15.998",
        viewBox: "0 0 16 15.998"
      }, i.a.createElement("defs", null, i.a.createElement("style", null, ".a{fill:#b7b7b7;}")), i.a.createElement("path", {
        class: "a",
        d: "M3,15.665V19H6.333l9.83-9.83L12.83,5.835Zm2.6,1.555H4.778V16.4L12.83,8.351l.818.818ZM18.74,5.338l-2.08-2.08a.89.89,0,0,0-1.253,0L13.781,4.884l3.333,3.333L18.74,6.591a.885.885,0,0,0,0-1.253Z",
        transform: "translate(-3 -3)"
      }));
    };

    function y() {
      return (y = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function x(e, n) {
      var t = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        n && (r = r.filter(function (n) {
          return Object.getOwnPropertyDescriptor(e, n).enumerable;
        })), t.push.apply(t, r);
      }

      return t;
    }

    function v(e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2 ? x(Object(t), !0).forEach(function (n) {
          C(e, n, t[n]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : x(Object(t)).forEach(function (n) {
          Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
        });
      }

      return e;
    }

    function C(e, n, t) {
      return n in e ? Object.defineProperty(e, n, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = t, e;
    }

    function w(e, n) {
      if (null == e) return {};

      var t,
          r,
          a = function (e, n) {
        if (null == e) return {};
        var t,
            r,
            a = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || (a[t] = e[t]);
        }

        return a;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
        }
      }

      return a;
    }

    var E,
        O = Object(g.withStyles)({
      root: {
        width: "100%"
      }
    })(u.a),
        j = function j(e) {
      var n = e.disabled,
          t = e.id,
          r = e.label,
          a = e.color,
          o = e.name,
          l = e.onChange,
          c = e.value,
          s = e.variant,
          u = e.icon,
          p = void 0 === u ? null : u,
          d = e.showInputIcon,
          f = void 0 === d ? null : d,
          g = w(e, ["disabled", "id", "label", "color", "name", "onChange", "value", "variant", "icon", "showInputIcon"]),
          x = function x() {
        switch (p) {
          case "edit":
            return i.a.createElement(h, null, i.a.createElement(b, null), " ");

          default:
            return null;
        }
      };

      return i.a.createElement(m, null, i.a.createElement(O, y({
        disabled: n,
        id: t,
        label: r,
        name: o,
        onChange: l,
        value: c,
        variant: s,
        color: a
      }, g, {
        InputProps: f ? v(v({}, g.InputProps), {}, {
          endAdornment: x()
        }) : v({}, g.InputProps)
      })));
    };

    var k,
        P,
        S = d.a.button(E || (k = ["\n  min-height: ", ";\n  background-color: ", ";\n  color: ", ";\n  outline: none;\n  border: none;\n  margin: ", ";\n  border-radius: ", "\n  font-weight: 600;\n  padding: ", ";\n  border: ", "\n  box-shadow: ", ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: ", ";\n  cursor: pointer;\n  font-size: 14px;\n  svg {\n    position: absolute;\n    left: 20px;\n    max-height: 100%;\n  }\n"], P || (P = k.slice(0)), E = Object.freeze(Object.defineProperties(k, {
      raw: {
        value: Object.freeze(P)
      }
    }))), function (e) {
      return "transparent" === e.color ? "20px" : "40px";
    }, function (e) {
      return e.disabled ? "#00C8FF4D" : e.color ? e.color : "#00C8FF";
    }, function (e) {
      return e.textColor;
    }, function (e) {
      return "transparent" === e.color ? "".concat(e.marginTop, "px 0px") : "10px";
    }, function (e) {
      return "rounded" === e.variant ? "25px" : "0px";
    }, function (e) {
      return "transparent" === e.color ? "0px" : "0px 10px";
    }, function (e) {
      return e.borderColor ? "1px solid ".concat(e.borderColor) : "none";
    }, function (e) {
      return "transparent" !== e.color ? "0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)" : "none";
    }, function (e) {
      return "transparent" === e.color ? "20px" : "120px";
    }),
        F = {
      headerColor: "#00377B",
      phoneNumberInput: "#00377D",
      buttonTextPrimary: "#FFFFFF",
      fontSize: {
        xs: "12px",
        small: "14px",
        base: "16px",
        medium: "20px",
        large: "24px"
      },
      fontWeight: {
        bold: 500,
        medium: 500,
        xBold: 600
      },
      bgColorPrimary: "#FFFFFF",
      bgColorSecondary: "#00377B",
      bgInputBorder: "rgb(76, 197, 242)",
      textColor: "#00377B",
      textColorGrey: "#949494",
      textColorTeal: "#4cc5f2",
      errorRed: "#f01e46",
      textColorGreen: "#42c846",
      textColorWhite: "#FFFFFF",
      warning: "#FFAA32",
      grey: "#565656",
      disabledBlue: "#00C8FF4D",
      successGreen: "#37C846",
      errorBtnRed: "#F01E46",
      successIconBg: "#259B31",
      loaderIconBg: "#05b1e0",
      secondaryCyan: "#00C8FF",
      warningCloseGrey: "#CCCCCC"
    };

    function I() {
      return (I = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function L(e, n) {
      if (null == e) return {};

      var t,
          r,
          a = function (e, n) {
        if (null == e) return {};
        var t,
            r,
            a = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || (a[t] = e[t]);
        }

        return a;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
        }
      }

      return a;
    }

    var M = function M(e) {
      var n = e.onClick,
          t = e.text,
          r = e.textTransform,
          a = e.variant,
          o = e.disabled,
          l = e.color,
          c = e.BtnImage,
          s = L(e, ["onClick", "text", "textTransform", "variant", "disabled", "color", "BtnImage"]);
      return i.a.createElement(S, I({
        textColor: F.buttonTextPrimary,
        onClick: n,
        variant: a,
        color: l,
        disabled: o
      }, s), c && i.a.createElement(c, null), r ? t : t.toUpperCase());
    };

    M.defaultProps = {
      onClick: function onClick() {},
      text: "",
      variant: "normal",
      disabled: !1,
      color: "#00C8FF",
      marginTop: 5
    }, M.propTypes = {
      onClick: c.a.func,
      text: c.a.string,
      variant: c.a.oneOf(["rounded", "normal"])
    };
    var N,
        B,
        T,
        A,
        z,
        R = M;

    function D(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var Z = d.a.div(N || (N = D(["\n  min-height: 60px;\n  background-color: ", ";\n  outline: none;\n  border: none;\n  top: 0;\n  display: flex;\n  align-items: center;\n  padding: 0px 16px;\n  width: calc(100% - 32px);\n  position: ", ";\n  z-index: 200;\n  box-shadow: ", ";\n"])), function (e) {
      return e.color;
    }, function (e) {
      return e.fixed ? "fixed" : "relative";
    }, function (e) {
      return e.headerShadow ? "0 0px 5px black" : "none";
    }),
        q = d.a.img(B || (B = D(["\n  margin-right: 16px;\n  max-height: 29px;\n  z-index: 100;\n  cursor: pointer;\n  @media (min-width: 1224px) {\n    margin-left: ", ";\n  }\n  @media (min-width: 1440px) {\n    margin-left: ", ";\n  }\n  @media (min-width: 1824px) {\n    margin-left: ", ";\n  }\n"])), function (e) {
      return "responsive" === e.headerType ? "84px" : "0px";
    }, function (e) {
      return "responsive" === e.headerType ? "184px" : "0px";
    }, function (e) {
      return "responsive" === e.headerType ? "284px" : "0px";
    }),
        U = d()(q)(T || (T = D([";\n  display: block\n  @media (min-width: 1224px) {\n    display: none;\n  }\n"]))),
        H = d.a.div(A || (A = D(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex: 1;\n"]))),
        V = d.a.div(z || (z = D(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"])));

    function W() {
      return (W = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function _(e, n) {
      if (null == e) return {};

      var t,
          r,
          a = function (e, n) {
        if (null == e) return {};
        var t,
            r,
            a = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || (a[t] = e[t]);
        }

        return a;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
        }
      }

      return a;
    }

    var G = function G(e) {
      var n = e.showBack,
          t = e.onBackButtonClick,
          r = e.backButtonImage,
          a = e.logo,
          o = e.onLogoButtonClick,
          l = e.pageTitle,
          c = e.headerRight,
          s = e.fixed,
          u = e.headerType,
          p = _(e, ["showBack", "onBackButtonClick", "backButtonImage", "logo", "onLogoButtonClick", "pageTitle", "headerRight", "fixed", "headerType"]),
          d = "default" === u ? q : U;

      return i.a.createElement(Z, W({
        color: F.headerColor,
        fixed: s
      }, p), n && i.a.createElement(d, {
        "data-testid": "button-back",
        onClick: t,
        src: r
      }), a && i.a.createElement(q, {
        "data-testid": "tigo-logo",
        onClick: o,
        src: a,
        headerType: u
      }), l && i.a.createElement(V, {
        "data-testid": "header-text"
      }, l), c && i.a.createElement(H, {
        "data-testid": "header-right"
      }, " ", c, " "));
    };

    G.defaultProps = {
      headerRight: null,
      showBack: !1,
      pageTitle: null,
      fixed: !0,
      onLogoButtonClick: function onLogoButtonClick() {},
      onBackButtonClick: function onBackButtonClick() {},
      headerType: "default"
    }, G.propTypes = {};
    var Y,
        Q = G,
        $ = t(13),
        X = t.n($);
    var K = d.a.div(Y || (Y = function (e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }(["\nheight: 100%;\nwidth: 100%;\ndisplay: flex;\nalign-items: center;\njustify-content: center;\nz-index: 500;\nposition: fixed;\ntop: 0;\nbackground-color: rgba(0, 0, 0, 0.3);\n-webkit-tap-highlight-color: transparent;\n"])));

    function J(e, n) {
      if (null == e) return {};

      var t,
          r,
          a = function (e, n) {
        if (null == e) return {};
        var t,
            r,
            a = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || (a[t] = e[t]);
        }

        return a;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
        }
      }

      return a;
    }

    var ee = function ee(e) {
      var n = e.open,
          t = J(e, ["open"]);
      return n ? i.a.createElement(K, t, i.a.createElement(X.a, null)) : null;
    };

    ee.defaultProps = {
      open: !1
    };
    var ne,
        te = ee;
    var re = d.a.label(ne || (ne = function (e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-align: left;\n    width: ", "\n"])), function (e) {
      return e.color;
    }, function (e) {
      return e.fontSize;
    }, function (e) {
      return e.fontWeight;
    }, function (e) {
      return e.width ? e.width : "auto";
    });

    function ae() {
      return (ae = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function oe(e, n) {
      if (null == e) return {};

      var t,
          r,
          a = function (e, n) {
        if (null == e) return {};
        var t,
            r,
            a = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || (a[t] = e[t]);
        }

        return a;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
        }
      }

      return a;
    }

    var ie = function ie(e) {
      return F.fontSize[e];
    },
        le = function le(e) {
      return F.fontWeight[e];
    },
        ce = function ce(e) {
      var n = e.labelSize,
          t = e.fontColor,
          r = e.text,
          a = e.fontWeight,
          o = e.onClick,
          l = oe(e, ["labelSize", "fontColor", "text", "fontWeight", "onClick"]);
      return i.a.createElement(re, ae({
        fontSize: ie(n),
        color: t,
        fontWeight: le(a),
        onClick: o,
        className: "label-container"
      }, l), r);
    };

    ce.defaultProps = {
      labelSize: F.fontSize.base,
      fontColor: F.phoneNumberInput,
      fontWeight: "normal",
      text: "",
      onClick: function onClick() {}
    };
    var se,
        ue,
        pe,
        de,
        fe,
        me = ce;

    function he(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var ge = d.a.div(se || (se = he(["\n    background-color: ", "\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    border-bottom: ", ";\n    box-shadow: rgba(0, 0, 0, 0.35) 0px 4px 7px 1px;\n    padding: 10px 0;\n    min-height: auto;\n    width: 100%;\n    max-width: 600px;\n    justify-content: space-between;\n    position: fixed;\n    z-index: 200;\n    top: ", ";\n    @media (min-width: 1224px) {\n      max-width: ", ";\n      margin-left: 100px;\n      margin-right: 100px;\n    }\n    @media (min-width: 1440px) {\n      max-width: ", ";\n      margin-left: 200px;\n      margin-right: 200px;\n    }\n    @media (min-width: 1824px) {\n      max-width: ", ";\n      margin-left: 300px;\n      margin-right: 300px;\n    }\n    .errorWrapper {\n      display: flex;\n      margin: 0 10px 20px 10px;\n      flex: 1;\n    }\n    \n"])), function (e) {
      return e.color;
    }, function (e) {
      return e.borderBottomColor;
    }, function (e) {
      return e.headerPresent ? "60px" : "0px";
    }, function (e) {
      return e.headerType ? "calc(100% - 200px)" : "600px";
    }, function (e) {
      return e.headerType ? "calc(100% - 400px)" : "600px";
    }, function (e) {
      return e.headerType ? "calc(100% - 600px)" : "600px";
    }),
        be = d.a.div(ue || (ue = he(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;    \n  margin: 4px 0px 0px 10px;\n  width: 100%;\n  align-items: flex-start;\n  font-weight: 600\n    label {\n      word-break: break-word;\n      font-weight: normal;\n      font-size: 14px;\n    }\n"]))),
        ye = d.a.div(pe || (pe = he(["\n    height: 25px;\n    width: 25px;\n    color: white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    svg {\n      color: ", "\n    }\n"])), function (e) {
      return e.iconColor;
    }),
        xe = d.a.div(de || (de = he(["\n  display: ", ";\n  color: ", ";\n  height: 25px;\n  width: 25px;\n  font-size: 24px;\n  margin-right: 10px;\n  @media (min-width: 1224px) {\n    display: block;\n    padding: 3px 0 !important;\n  }\n"])), function (e) {
      return e.closeIcon ? "none" : "block";
    }, function (e) {
      return e.color;
    }),
        ve = d.a.div(fe || (fe = he(["\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    display: block;\n    padding: 11px 0 8px 0;\n    .button{\n        color: #00C8FF;\n        font-size: 14px;\n        font-weight: bold;\n        margin-right: 25px;\n        cursor: pointer;\n    }\n    @media (min-width: 1224px) {\n      position: relative;\n      padding: 3px 0 !important;\n    }\n}\n"]))),
        Ce = t(22),
        we = t.n(Ce),
        Ee = t(7),
        Oe = t.n(Ee),
        je = t(23),
        ke = t.n(je),
        Pe = t(14),
        Se = t.n(Pe),
        Fe = t(24),
        Ie = t.n(Fe),
        Le = function Le() {
      return i.a.createElement("svg", {
        width: "19px",
        height: "19px",
        viewBox: "0 0 19 19",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, i.a.createElement("g", {
        id: "Assisted---SV---1.1",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, i.a.createElement("g", {
        id: "Starting-Menu-error",
        transform: "translate(-15.000000, -11.000000)"
      }, i.a.createElement("g", {
        id: "ML-NOTIFICATION/ml-notification-alert--mobile"
      }, i.a.createElement("g", {
        id: "ML-NOTIFICATION/ml-notification-attention-"
      }, i.a.createElement("g", {
        id: "ML-NOTIFICATION/text-icon",
        transform: "translate(12.467532, 8.000000)"
      }, i.a.createElement("g", {
        id: "ML-NOTIFICATION/icon"
      }, i.a.createElement("g", {
        id: "Genericos/Notificaciones/notification/informacion,-info,-promo/Light-Mode",
        transform: "translate(-8.000000, -8.000000)"
      }, i.a.createElement("g", {
        id: "Genericos/Notificaciones/notification/error,-fallo,-fail/Light-Mode",
        transform: "translate(11.200000, 11.200000)"
      }, i.a.createElement("g", {
        id: "Genericos/Notificaciones/notification/error,-fallo,-fail"
      }, i.a.createElement("g", {
        id: "notification/error,-fallo,-fail"
      }, i.a.createElement("rect", {
        id: "Marco",
        x: "0",
        y: "0",
        width: "18",
        height: "18"
      }), i.a.createElement("path", {
        d: "M9,18 C13.9705627,18 18,13.9705627 18,9 C18,4.02943725 13.9705627,0 9,0 C4.02943725,0 0,4.02943725 0,9 C0,13.9705627 4.02943725,18 9,18 Z",
        id: "Path",
        fill: "#F01E46"
      }), i.a.createElement("path", {
        d: "M9.02842712,8.17989899 L11.4325902,5.77573593 C11.6669048,5.54142136 12.0468037,5.54142136 12.2811183,5.77573593 C12.5154329,6.01005051 12.5154329,6.38994949 12.2811183,6.62426407 L9.87695526,9.02842712 L12.2811183,11.4325902 C12.5154329,11.6669048 12.5154329,12.0468037 12.2811183,12.2811183 C12.0468037,12.5154329 11.6669048,12.5154329 11.4325902,12.2811183 L9.02842712,9.87695526 L6.62426407,12.2811183 C6.38994949,12.5154329 6.01005051,12.5154329 5.77573593,12.2811183 C5.54142136,12.0468037 5.54142136,11.6669048 5.77573593,11.4325902 L8.17989899,9.02842712 L5.77573593,6.62426407 C5.54142136,6.38994949 5.54142136,6.01005051 5.77573593,5.77573593 C6.01005051,5.54142136 6.38994949,5.54142136 6.62426407,5.77573593 L9.02842712,8.17989899 Z",
        id: "Path",
        fill: "#FFFFFF"
      }))))))))))));
    };

    function Me(e, n) {
      var t = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        n && (r = r.filter(function (n) {
          return Object.getOwnPropertyDescriptor(e, n).enumerable;
        })), t.push.apply(t, r);
      }

      return t;
    }

    function Ne(e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2 ? Me(Object(t), !0).forEach(function (n) {
          Be(e, n, t[n]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Me(Object(t)).forEach(function (n) {
          Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
        });
      }

      return e;
    }

    function Be(e, n, t) {
      return n in e ? Object.defineProperty(e, n, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = t, e;
    }

    function Te(e, n) {
      if (null == e) return {};

      var t,
          r,
          a = function (e, n) {
        if (null == e) return {};
        var t,
            r,
            a = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || (a[t] = e[t]);
        }

        return a;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
        }
      }

      return a;
    }

    var Ae = function Ae(e) {
      switch (e) {
        case "locationError":
        case "success":
        case "warning":
          return F.textColorWhite;

        default:
          return F.errorRed;
      }
    },
        ze = function ze(e) {
      switch (e) {
        case "locationError":
        case "success":
        case "warning":
          return F.grey;

        default:
          return F.textColorWhite;
      }
    },
        Re = function Re(e) {
      switch (e) {
        case "locationError":
        case "success":
          return F.textColorGrey;

        case "warning":
          return F.warningCloseGrey;

        default:
          return F.textColorWhite;
      }
    },
        De = function De(e, n) {
      switch (e) {
        case "locationError":
          return "3px solid red";

        case "success":
          return "3px solid ".concat(n || "green");

        case "warning":
          return "3px solid #FFAA32";

        default:
          return "none";
      }
    },
        Ze = function Ze(e, n) {
      switch (e) {
        case "locationError":
          return "red";

        case "success":
          return n || "green";

        case "warning":
          return "#FFAA32";

        default:
          return "white";
      }
    },
        qe = function qe(e) {
      e.color, e.title;
      var n = e.description,
          t = e.clearError,
          r = e.headerPresent,
          a = e.showMessage,
          l = e.type,
          c = e.maxWidth,
          s = e.closeIcon,
          u = void 0 !== s && s,
          p = e.customClickHandler,
          d = e.btnText,
          f = e.headerType,
          m = e.colorValue,
          h = void 0 === m ? null : m,
          g = e.cssSelector,
          b = void 0 === g ? "" : g,
          y = e.customIcon,
          x = void 0 === y ? null : y,
          v = e.customClose,
          C = void 0 === v ? null : v,
          w = e.autoCloseThreshold,
          E = void 0 === w ? 5e3 : w,
          O = e.autoClose,
          j = void 0 === O || O,
          k = Te(e, ["color", "title", "description", "clearError", "headerPresent", "showMessage", "type", "maxWidth", "closeIcon", "customClickHandler", "btnText", "headerType", "colorValue", "cssSelector", "customIcon", "customClose", "autoCloseThreshold", "autoClose"]);
      Object(o.useEffect)(function () {
        if (j) {
          var e = setTimeout(function () {
            t && t();
          }, E || 5e3);
          return function () {
            clearTimeout(e);
          };
        }
      }, []);
      return a ? i.a.createElement(ge, {
        className: b,
        color: Ae(l),
        headerPresent: r,
        type: l,
        borderBottomColor: De(l, h),
        style: Ne({}, k.style || {}),
        maxWidth: c,
        headerType: f
      }, i.a.createElement("div", {
        className: "errorWrapper"
      }, i.a.createElement(ye, {
        iconColor: Ze(l, h)
      }, x || function (e) {
        switch (e) {
          case "error":
            return i.a.createElement(ke.a, null);

          case "locationError":
            return i.a.createElement(Le, null);

          case "success":
            return i.a.createElement(Se.a, null);

          case "warning":
            return i.a.createElement(Ie.a, null);

          default:
            return i.a.createElement(Oe.a, null);
        }
      }(l)), i.a.createElement(be, null, i.a.createElement(me, {
        fontColor: ze(l),
        text: n
      }))), i.a.createElement(ve, {
        className: "toast-button-wrapper"
      }, i.a.createElement("span", {
        className: "button",
        onClick: p
      }, d)), i.a.createElement(xe, {
        color: Re(l),
        onClick: t,
        closeIcon: u
      }, C || i.a.createElement(we.a, null))) : null;
    };

    qe.defaultProps = {
      color: F.errorRed,
      title: "",
      description: "",
      type: "error",
      showMessage: !0,
      maxWidth: "600px",
      closeIcon: !1,
      customClickHandler: function customClickHandler() {}
    }, qe.propTypes = {
      color: c.a.string,
      title: c.a.string,
      description: c.a.string,
      type: c.a.string
    };
    var Ue,
        He,
        Ve = qe;

    function We(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var _e = d.a.section(Ue || (Ue = We(["\n    height: 100%;\n    width: 100%;\n    background-color: ", ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    position: relative;\n"])), function (e) {
      return e.bgColor;
    }),
        Ge = d.a.div(He || (He = We(["\n    width: ", ";\n    margin-top: ", ";\n    min-height: ", ";\n    max-width: ", ";\n    background-color: ", ";\n    position: relative;\n"])), function (e) {
      return e.fullWidth ? "100%" : "90%";
    }, function (e) {
      return e.showHeader ? "60px" : "0px";
    }, function (e) {
      return "responsive" === e.headerType ? "auto" : e.showHeader ? "calc(100% - 60px)" : "100%";
    }, function (e) {
      return e.maxWidth;
    }, function (e) {
      return e.bgColor;
    });

    function Ye(e, n) {
      var t = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        n && (r = r.filter(function (n) {
          return Object.getOwnPropertyDescriptor(e, n).enumerable;
        })), t.push.apply(t, r);
      }

      return t;
    }

    function Qe(e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2 ? Ye(Object(t), !0).forEach(function (n) {
          $e(e, n, t[n]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Ye(Object(t)).forEach(function (n) {
          Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
        });
      }

      return e;
    }

    function $e(e, n, t) {
      return n in e ? Object.defineProperty(e, n, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = t, e;
    }

    function Xe() {
      return (Xe = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function Ke(e, n) {
      if (null == e) return {};

      var t,
          r,
          a = function (e, n) {
        if (null == e) return {};
        var t,
            r,
            a = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || (a[t] = e[t]);
        }

        return a;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
        }
      }

      return a;
    }

    var Je = function Je(e) {
      var n = e.bgColor,
          t = e.showHeader,
          r = e.loading,
          a = e.clearError,
          l = e.maxWidth,
          c = (e.errorStyles, e.childrenStyles),
          s = e.loaderProps,
          u = Ke(e, ["bgColor", "showHeader", "loading", "clearError", "maxWidth", "errorStyles", "childrenStyles", "loaderProps"]);
      return Object(o.useEffect)(function () {
        return window.scrollTo(0, 0), function () {
          return a();
        };
      }, []), i.a.createElement(_e, {
        bgColor: n,
        className: "layout-container"
      }, t && i.a.createElement(Q, u), i.a.createElement(te, Xe({
        open: r
      }, s)), i.a.createElement(i.a.Fragment, null, u.error && i.a.createElement(Ve, {
        description: u.error ? u.error.description : "",
        clearError: a,
        headerPresent: t,
        showMessage: !!u.error,
        type: u.error ? u.error.type : "",
        maxWidth: l,
        closeIcon: u.closeIcon,
        btnText: u.btnText,
        headerType: u.headerType,
        customClickHandler: u.customClickHandler,
        colorValue: u.error.colorValue,
        cssSelector: u.error.cssSelector,
        customIcon: u.error.customIcon,
        customClose: u.error.customClose,
        autoCloseThreshold: u.error.autoCloseThreshold,
        autoClose: u.error.autoClose
      }), i.a.createElement(Ge, {
        fullWidth: u.fullWidth,
        showHeader: t,
        error: u.error,
        maxWidth: l,
        bgColor: n,
        style: Qe({}, c),
        headerType: u.headerType,
        className: "child-container"
      }, u.children)));
    };

    Je.defaultProps = {
      bgColor: "#FFFFFF",
      showHeader: !1,
      loading: !1,
      clearError: function clearError() {},
      error: null,
      errorStyles: {},
      maxWidth: "100%",
      childrenStyles: {},
      customClickHandler: function customClickHandler() {}
    }, Je.propTypes = {
      bgColor: c.a.string,
      showHeader: c.a.bool
    };
    var en,
        nn = Je;
    var tn = d.a.div(en || (en = function (e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }(["\n    background-color: ", ";\n    width: 100%;\n    display:flex;\n    flex-direction: column;\n    box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12);\n    margin: 5px 0px;\n"])), function (e) {
      return e.bgColor;
    });

    function rn(e, n) {
      if (null == e) return {};

      var t,
          r,
          a = function (e, n) {
        if (null == e) return {};
        var t,
            r,
            a = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || (a[t] = e[t]);
        }

        return a;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
        }
      }

      return a;
    }

    var an = function an(e) {
      var n = e.bgColor,
          t = rn(e, ["bgColor"]);
      return i.a.createElement(tn, {
        bgColor: n
      }, t.children);
    };

    an.defaultProps = {
      bgColor: F.bgColorPrimary
    }, an.propTypes = {
      bgcolor: c.a.string
    };
    var on,
        ln,
        cn,
        sn,
        un = an;

    function pn(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var dn = d.a.div(on || (on = pn(["\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 10px;\n\n"]))),
        fn = d.a.div(ln || (ln = pn(["\n    display: flex;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    min-width: 10%;\n    justify-content: center;\n"]))),
        mn = d.a.div(cn || (cn = pn(["\n    display: flex;\n    align-items: center;\n    width: 250px;\n    overflow: hidden;\n    flex: 1;\n    overflow: hidden;\n    min-width: 50%;\n    padding: 0px 10px;\n    text-align: left\n"]))),
        hn = d.a.div(sn || (sn = pn(["\n    display: flex;\n    align-items: center;\n    height: 40px;\n    min-width: 10%;\n    justify-content: flex-end\n"])));

    function gn(e, n) {
      if (null == e) return {};

      var t,
          r,
          a = function (e, n) {
        if (null == e) return {};
        var t,
            r,
            a = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || (a[t] = e[t]);
        }

        return a;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
        }
      }

      return a;
    }

    var bn = function bn(e) {
      var n = e.onClick,
          t = gn(e, ["onClick"]);
      return i.a.createElement(dn, {
        onClick: n
      }, t.left && i.a.createElement(fn, null, t.left), t.center && i.a.createElement(mn, null, t.center), t.right && i.a.createElement(hn, null, t.right));
    };

    bn.defaultProps = {
      onClick: function onClick() {}
    }, bn.propTypes = {
      onClick: c.a.func
    };
    var yn,
        xn,
        vn,
        Cn = bn;

    function wn(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var En = d.a.label(yn || (yn = wn(["\n  position: absolute;\n  top: 25%;\n  left: 4px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: white;\n  border: 2px solid #bebebe;\n"]))),
        On = d.a.input(xn || (xn = wn(['\n  opacity: 0;\n  z-index: 1;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n  left: 4px;\n  position: absolute;\n  background: #bebebe;\n    &::after {\n      content: "";\n      display: block;\n      border-radius: 50%;\n      width: 12px;\n      height: 12px;\n      background: #eeeeee;\n    }\n  \n  &:checked + ', ' {\n    background: white;\n    border: 2px solid #00c8ff;\n    &::after {\n      content: "";\n      display: block;\n      border-radius: 50%;\n      width: 12px;\n      height: 12px;\n      margin: 4px;\n      background: #00c8ff;\n    }\n  }\n'])), En),
        jn = d.a.div(vn || (vn = wn(["\n  position: relative;\n"])));

    function kn(e, n) {
      if (null == e) return {};

      var t,
          r,
          a = function (e, n) {
        if (null == e) return {};
        var t,
            r,
            a = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || (a[t] = e[t]);
        }

        return a;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
        }
      }

      return a;
    }

    var Pn = function Pn(e) {
      var n = e.name,
          t = e.value,
          r = e.checked,
          a = e.onChange,
          o = e.text,
          l = kn(e, ["name", "value", "checked", "onChange", "text"]);
      return i.a.createElement(jn, null, i.a.createElement(On, {
        type: "radio",
        name: n,
        value: t,
        checked: r,
        onChange: a
      }), i.a.createElement(En, null), o ? i.a.createElement("label", null, o) : l.children);
    };

    Pn.defaultProps = {
      name: "radio",
      value: "",
      checked: !1,
      onChange: function onChange() {}
    }, Pn.propTypes = {
      name: c.a.string,
      value: c.a.string,
      checked: c.a.bool,
      onChange: c.a.func
    };
    var Sn,
        Fn,
        In,
        Ln,
        Mn,
        Nn = Pn;

    function Bn(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var Tn = d.a.section(Sn || (Sn = Bn(["\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    background-color: rgb(0, 0, 0, 0.25);\n    z-index: 200;\n    top: 0;\n    display: flex;\n    flex-wrap: nowrap;\n"]))),
        An = d.a.div(Fn || (Fn = Bn(["\n    width: 80%;\n    height: 100%\n    background-color: ", "\n    @media (min-width: 768px) {\n        width: 20%;\n    }\n"])), function (e) {
      return e.color;
    }),
        zn = d.a.div(In || (In = Bn(["\n    width: 20%;\n    height: 100%;\n    opacity: 0.5;\n    background-color: rgba(0, 0, 0, 0.5);\n    @media (min-width: 768px) {\n        width: 80%;\n    }\n"]))),
        Rn = d.a.div(Ln || (Ln = Bn(["\n    height: 110px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    border-bottom: 2px solid white;\n    align-items: flex-start;\n    justify-content: center;\n    label {\n        padding-left: 20px;\n    }\n"]))),
        Dn = d.a.div(Mn || (Mn = Bn(["\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    flex-direction: column;\n"])));

    function Zn(e, n) {
      var t = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        n && (r = r.filter(function (n) {
          return Object.getOwnPropertyDescriptor(e, n).enumerable;
        })), t.push.apply(t, r);
      }

      return t;
    }

    function qn(e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2 ? Zn(Object(t), !0).forEach(function (n) {
          Un(e, n, t[n]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Zn(Object(t)).forEach(function (n) {
          Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
        });
      }

      return e;
    }

    function Un(e, n, t) {
      return n in e ? Object.defineProperty(e, n, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = t, e;
    }

    function Hn(e, n) {
      if (null == e) return {};

      var t,
          r,
          a = function (e, n) {
        if (null == e) return {};
        var t,
            r,
            a = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || (a[t] = e[t]);
        }

        return a;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
        }
      }

      return a;
    }

    var Vn = function Vn(e) {
      var n = e.color,
          t = e.handleClose,
          r = e.styles,
          a = e.panelStyle,
          o = void 0 === a ? {} : a,
          l = e.profileStyle,
          c = void 0 === l ? {} : l,
          s = e.menuStyle,
          u = void 0 === s ? {} : s,
          p = Hn(e, ["color", "handleClose", "styles", "panelStyle", "profileStyle", "menuStyle"]);
      return i.a.createElement(Tn, {
        style: qn({}, r)
      }, i.a.createElement(An, {
        color: n,
        style: qn({}, o)
      }, i.a.createElement(Rn, {
        style: qn({}, c)
      }, p.userDetails ? p.userDetails : null), i.a.createElement(Dn, {
        style: qn({}, u)
      }, p.children)), i.a.createElement(zn, {
        onClick: t
      }));
    };

    Vn.defaultProps = {
      color: F.bgColorSecondary,
      handleClose: function handleClose() {},
      styles: {}
    }, Vn.propTypes = {
      color: c.a.string,
      handleClose: c.a.func
    };

    var Wn,
        _n,
        Gn,
        Yn,
        Qn,
        $n,
        Xn = Vn;

    function Kn(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var Jn = {};
    Jn.Header = d.a.div(Wn || (Wn = Kn(["\n    color: #20508e;\n    font-size: 25px;\n    margin: 10px 0px;\n    @media screen and (max-width: 700px) {\n        font-size: 18px;\n    }"]))), Jn.Modal = d.a.div(_n || (_n = Kn(["\n    position: fixed;\n    display: ", ";\n    background: #0000008c;\n    height: 100%;\n    width: 100%;\n    z-index: 300;\n    left: 0;\n    top: 0;\n    align-items: center;\n"])), function (e) {
      return e.isOpen ? "flex" : "none";
    }), Jn.Content = d.a.div(Gn || (Gn = Kn(["\n    margin: 9% auto; \n    padding: 20px;\n    width: 56%; \n    background: #fff;\n    text-align: left;\n    z-index: 3;\n    border-radius: 5px;\n    word-break: break-word;\n    width: 85%;\n"]))), Jn.CloseSection = d.a.div(Yn || (Yn = Kn(["\n    display: flex;\n    justify-content: flex-end;\n"]))), Jn.Close = d.a.span(Qn || (Qn = Kn(["\n    color: ", ";\n    float: right;\n    font-size: 30px;\n    &:hover, &:focus {\n        color: black;\n        text-decoration: none;\n        cursor: pointer;\n    }\n"])), function (e) {
      return e.darkCloseBtn ? "#A0A0A0" : "#1ecfff";
    }), Jn.ButtonSection = d.a.div($n || ($n = Kn(["\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 20px;\n"])));
    var et = Jn;

    function nt(e) {
      return (nt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function tt(e, n) {
      if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
    }

    function rt(e, n) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function at(e, n) {
      return (at = Object.setPrototypeOf || function (e, n) {
        return e.__proto__ = n, e;
      })(e, n);
    }

    function ot(e) {
      var n = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var t,
            r = ct(e);

        if (n) {
          var a = ct(this).constructor;
          t = Reflect.construct(r, arguments, a);
        } else t = r.apply(this, arguments);

        return it(this, t);
      };
    }

    function it(e, n) {
      return !n || "object" !== nt(n) && "function" != typeof n ? lt(e) : n;
    }

    function lt(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function ct(e) {
      return (ct = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function st(e, n, t) {
      return n in e ? Object.defineProperty(e, n, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = t, e;
    }

    var ut = function (e) {
      !function (e, n) {
        if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(n && n.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), n && at(e, n);
      }(o, e);
      var n,
          t,
          r,
          a = ot(o);

      function o() {
        var e;
        tt(this, o);

        for (var n = arguments.length, t = new Array(n), r = 0; r < n; r++) {
          t[r] = arguments[r];
        }

        return st(lt(e = a.call.apply(a, [this].concat(t))), "onOk", function () {
          e.props.onOk();
        }), st(lt(e), "onCancel", function () {
          e.props.onCancel();
        }), st(lt(e), "onClose", function () {
          e.props.onClose && e.props.onClose();
        }), st(lt(e), "closeModal", function () {
          "Modal_Background" === event.target.getAttribute("name") && e.props.onClose && e.props.onClose();
        }), e;
      }

      return n = o, (t = [{
        key: "componentDidMount",
        value: function value() {
          this.props.onOpen && this.props.onOpen();
        }
      }, {
        key: "render",
        value: function value() {
          return i.a.createElement(et.Modal, {
            isOpen: this.props.visibility,
            name: "Modal_Background",
            onClick: this.closeModal
          }, i.a.createElement(et.Content, {
            style: this.props.style ? this.props.style : {}
          }, this.props.showClose && i.a.createElement(et.CloseSection, null, i.a.createElement(et.Close, {
            darkCloseBtn: this.props.darkCloseBtn,
            onClick: this.onClose
          }, "×")), this.props.heading && i.a.createElement(et.Header, null, this.props.heading), this.props.children, this.props.footer ? this.props.footer : i.a.createElement(et.ButtonSection, null, this.props.cancelBtn && i.a.createElement(R, {
            text: this.props.cancelBtn,
            onClick: this.onCancel,
            style: this.props.cancelBtnStyles,
            color: "transparent"
          }), this.props.okBtn && i.a.createElement(R, {
            text: this.props.okBtn,
            onClick: this.onOk,
            style: this.props.okBtnStyles,
            variant: "rounded"
          }))));
        }
      }]) && rt(n.prototype, t), r && rt(n, r), o;
    }(o.Component);

    ut.propTypes = {
      children: c.a.node.isRequired,
      heading: c.a.string,
      okBtn: c.a.string,
      cancelBtn: c.a.string,
      okBtnStyles: c.a.object,
      cancelBtnStyles: c.a.object,
      onOk: c.a.func,
      onCancel: c.a.func,
      onClose: c.a.func,
      footer: c.a.node
    }, ut.defaultProps = {
      visibility: !1,
      showClose: !0,
      heading: "",
      footer: !0,
      okBtn: "",
      cancelBtn: ""
    };
    var pt = ut,
        dt = t(10),
        ft = t.n(dt),
        mt = t(25),
        ht = t.n(mt),
        gt = t(15),
        bt = t.n(gt);

    function yt() {
      return (yt = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var xt,
        vt,
        Ct,
        wt,
        Et,
        Ot,
        jt,
        kt,
        Pt = Object(g.withStyles)({
      root: {
        color: "#CDCDCD",
        "&$checked": {
          color: "#4cc5f2"
        }
      },
      checked: {}
    })(function (e) {
      return i.a.createElement(ft.a, yt({
        color: "default"
      }, e));
    }),
        St = function St(e) {
      var n = yt({}, e);
      return i.a.createElement(ht.a, {
        row: !0
      }, i.a.createElement(bt.a, {
        control: i.a.createElement(Pt, yt({
          checked: n.checked,
          onChange: n.onChange,
          value: n.value
        }, n)),
        label: n.label
      }));
    };

    function Ft(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var It = d.a.div(xt || (xt = Ft(["\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding-bottom: 10px;\n"]))),
        Lt = d.a.div(vt || (vt = Ft(["\n  position: relative;\n  margin-right: 10px;\n  svg {\n    position: absolute;\n    right: 10px;\n  }\n"]))),
        Mt = d.a.div(Ct || (Ct = Ft(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n"]))),
        Nt = d.a.div(wt || (wt = Ft(["\n    display:flex;\n    flex: 1;\n    flex-direction:row;\n    justify-content: space-between;\n"]))),
        Bt = d.a.div(Et || (Et = Ft(["\n    display:flex;\n    width: 75%;\n    margin: 5px 0px;\n    text-align: start;\n    flex-wrap: wrap;\n    flex-direction: column;\n"]))),
        Tt = d.a.div(Ot || (Ot = Ft(["\n    display: flex;\n"]))),
        At = d.a.div(jt || (jt = Ft(["\n  display: flex;\n  justify-content: flex-start;\n  margin-right: 15px;\n  label {\n    color: ", " !important;\n  }\n"])), F.textColor),
        zt = d.a.div(kt || (kt = Ft(["\n  label {\n    color: ", " !important;\n  }\n"])), F.phoneNumberInput),
        Rt = t(26),
        Dt = t.n(Rt),
        Zt = t(27),
        qt = t.n(Zt),
        Ut = t(28),
        Ht = t.n(Ut),
        Vt = t(16),
        Wt = t.n(Vt);

    function _t() {
      return (_t = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function Gt(e, n) {
      if (null == e) return {};

      var t,
          r,
          a = function (e, n) {
        if (null == e) return {};
        var t,
            r,
            a = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || (a[t] = e[t]);
        }

        return a;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
        }
      }

      return a;
    }

    var Yt = Object(g.makeStyles)(function (e) {
      return {
        formControl: {
          margin: "10px 0px",
          minWidth: "100%"
        }
      };
    }),
        Qt = function Qt(e) {
      var n = e.onChange,
          t = e.options,
          r = e.label,
          a = e.native,
          o = Gt(e, ["onChange", "options", "label", "native"]),
          l = Yt();
      return i.a.createElement(Ht.a, {
        variant: "outlined",
        className: l.formControl
      }, i.a.createElement(qt.a, {
        id: "select-".concat(r)
      }, r), i.a.createElement(Dt.a, _t({
        native: a,
        onChange: n
      }, o, {
        IconComponent: Wt.a
      }), t.map(function (e, n) {
        return i.a.createElement("option", {
          key: n,
          value: e
        }, e);
      })));
    };

    Qt.defaultProps = {
      native: !0
    };
    var $t = Qt;

    function Xt() {
      return (Xt = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var Kt = function Kt(e) {
      var n = e.productName,
          t = e.productPrice,
          r = e.productCurrency,
          a = e.productDescription,
          o = e.buttonName,
          l = e.onClick,
          c = e.priceLabelSize,
          s = e.titleStyles,
          u = e.showQuantity,
          p = e.quantityOptions,
          d = e.onQuantitySelection,
          f = e.selectedQuantity;
      return i.a.createElement(It, null, u && i.a.createElement(Lt, null, i.a.createElement($t, {
        options: p || [],
        onChange: d,
        value: f || 0
      })), i.a.createElement(Mt, null, i.a.createElement(Nt, {
        className: "prod-heading-wrap"
      }, i.a.createElement(At, {
        className: "productName"
      }, i.a.createElement(me, Xt({
        text: n,
        style: {
          fontSize: "18px"
        }
      }, s))), t && i.a.createElement(zt, {
        className: "productPrice"
      }, i.a.createElement(me, {
        text: "".concat(r).concat(t),
        labelSize: c,
        fontWeight: "bold"
      }))), a && i.a.createElement(Bt, {
        className: "prod-desc-wrap"
      }, "string" == typeof a ? i.a.createElement(me, {
        fontColor: F.grey,
        text: a
      }) : a.map(function (e, n) {
        return i.a.createElement(me, {
          key: n,
          fontColor: F.grey,
          text: e
        });
      })), o && i.a.createElement(Tt, null, i.a.createElement(R, {
        onClick: l,
        text: o,
        textColor: F.textColorTeal,
        color: "transparent"
      }))));
    };

    Kt.defaultProps = {
      productName: "",
      productPrice: "",
      productCurrency: "$",
      productDescription: "",
      butttonName: "",
      onClick: function onClick() {},
      labelSize: F.fontSize.xs,
      priceLabelSize: "medium",
      titleStyles: {},
      showQuantity: !1,
      quantityOptions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      onQuantitySelection: function onQuantitySelection() {},
      selectedQuantity: 0
    }, Kt.propTypes = {
      onClick: c.a.func,
      productName: c.a.string,
      productPrice: c.a.string,
      productCurrency: c.a.string,
      productDescription: c.a.oneOfType([c.a.string, c.a.array]),
      butttonName: c.a.string,
      titleStyles: c.a.object,
      showQuantity: c.a.bool,
      quantityOptions: c.a.array,
      onQuantitySelection: c.a.func,
      selectedQuantity: c.a.number
    };
    var Jt,
        er,
        nr,
        tr = Kt;

    function rr(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var ar = d.a.div(Jt || (Jt = rr(["\nposition: absolute;\nright: 0;\ntop: -5px;\nheight: 16px;\nwidth: 16px;\nbackground: white;\nborder-radius: 100%;\nfont-size: 10px;\ncolor: #4cc5f2;\ndisplay: flex;\nalign-items: center;\njustify-content: center;\n"]))),
        or = d.a.div(er || (er = rr(["\n    position: relative;\n    height: 30px;\n    width: 30px;\n    z-index: 100;\n"]))),
        ir = d.a.img(nr || (nr = rr(["\n    height: 100%;\n    width: 100%\n"]))),
        lr = function lr(e) {
      var n = e.count,
          t = e.icon,
          r = e.onClick;
      return i.a.createElement(or, {
        onClick: r
      }, i.a.createElement(ir, {
        src: t
      }), n > 0 ? i.a.createElement(ar, null, n) : null);
    };

    lr.propTypes = {
      count: c.a.number.isRequired,
      icon: c.a.string.isRequired
    }, lr.defaultProps = {
      count: 0
    };
    var cr = lr,
        sr = t(29),
        ur = t.n(sr),
        pr = t(30),
        dr = t.n(pr),
        fr = t(31),
        mr = t.n(fr),
        hr = t(20),
        gr = t.n(hr),
        br = t(8),
        yr = t.n(br);

    function xr() {
      return (xr = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function vr(e, n) {
      var t = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        n && (r = r.filter(function (n) {
          return Object.getOwnPropertyDescriptor(e, n).enumerable;
        })), t.push.apply(t, r);
      }

      return t;
    }

    function Cr(e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2 ? vr(Object(t), !0).forEach(function (n) {
          wr(e, n, t[n]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : vr(Object(t)).forEach(function (n) {
          Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
        });
      }

      return e;
    }

    function wr(e, n, t) {
      return n in e ? Object.defineProperty(e, n, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = t, e;
    }

    function Er(e, n) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, n) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var t = [],
            r = !0,
            a = !1,
            o = void 0;

        try {
          for (var i, l = e[Symbol.iterator](); !(r = (i = l.next()).done) && (t.push(i.value), !n || t.length !== n); r = !0) {
            ;
          }
        } catch (e) {
          a = !0, o = e;
        } finally {
          try {
            r || null == l.return || l.return();
          } finally {
            if (a) throw o;
          }
        }

        return t;
      }(e, n) || function (e, n) {
        if (!e) return;
        if ("string" == typeof e) return Or(e, n);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === t && e.constructor && (t = e.constructor.name);
        if ("Map" === t || "Set" === t) return Array.from(e);
        if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Or(e, n);
      }(e, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Or(e, n) {
      (null == n || n > e.length) && (n = e.length);

      for (var t = 0, r = new Array(n); t < n; t++) {
        r[t] = e[t];
      }

      return r;
    }

    function jr(e, n) {
      if (null == e) return {};

      var t,
          r,
          a = function (e, n) {
        if (null == e) return {};
        var t,
            r,
            a = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || (a[t] = e[t]);
        }

        return a;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
        }
      }

      return a;
    }

    var kr = function kr(e) {
      var n = e.title,
          t = e.content,
          r = e.type,
          a = e.id,
          l = e.onChange,
          c = e.onCheck,
          s = e.checkboxStyles,
          u = e.checkboxProps,
          p = e.headerComponent,
          d = e.bodyComponent,
          f = jr(e, ["title", "content", "type", "id", "onChange", "onCheck", "checkboxStyles", "checkboxProps", "headerComponent", "bodyComponent"]),
          m = Er(Object(o.useState)(!1), 2),
          h = m[0],
          g = m[1];
      return i.a.createElement(ur.a, xr({
        onChange: l
      }, f), i.a.createElement(dr.a, xr({
        expandIcon: i.a.createElement(yr.a, {
          onClick: function onClick() {
            null == f || f.accordionClickHandler(h), g(!h);
          }
        }),
        "aria-controls": "panel-".concat(a, "-content"),
        id: a
      }, f), p, "authorization" === r ? i.a.createElement(bt.a, {
        "aria-label": "Acknowledge",
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        onFocus: function onFocus(e) {
          return e.stopPropagation();
        },
        control: i.a.createElement(St, xr({
          onChange: c,
          style: Cr({}, s)
        }, u)),
        label: n
      }) : i.a.createElement(gr.a, null, n)), i.a.createElement(mr.a, null, i.a.createElement(gr.a, null, t), d));
    };

    kr.defaultProps = {
      onChange: function onChange() {},
      onCheck: function onCheck() {},
      checkboxStyles: {},
      checkboxProps: {},
      headerComponent: null,
      bodyComponent: null
    };
    var Pr = kr,
        Sr = t(17),
        Fr = t.n(Sr),
        Ir = t(32),
        Lr = t.n(Ir),
        Mr = t(33),
        Nr = t.n(Mr),
        Br = t(34),
        Tr = t.n(Br);

    function Ar() {
      return (Ar = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var zr = function zr(e) {
      var n = e.steps,
          t = e.styles,
          r = e.stepperProps,
          a = void 0 === r ? {} : r,
          o = Object(g.makeStyles)(t);
      return i.a.createElement(Lr.a, Ar({
        className: o().rootStepper || ""
      }, a, {
        alternativeLabel: !0
      }), function (e) {
        return e.map(function (e, n) {
          return i.a.createElement(Nr.a, Ar({
            key: n
          }, e), i.a.createElement(Tr.a, {
            StepIconComponent: function StepIconComponent(e) {
              return n = e, l = o(), i.a.createElement("div", {
                className: Fr()(l.root, (t = {}, r = l.active, a = n.active, r in t ? Object.defineProperty(t, r, {
                  value: a,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0
                }) : t[r] = a, t))
              }, n.completed ? i.a.createElement(Oe.a, {
                className: l.completed
              }) : n.active ? i.a.createElement("div", {
                className: l.circle
              }) : i.a.createElement("div", {
                className: l.disabled
              }));
              var n, t, r, a, l;
            }
          }, e.text));
        });
      }(n));
    };

    zr.defaultProps = {
      styles: {
        root: {
          color: "#949494",
          display: "flex",
          height: 22,
          alignItems: "center"
        },
        active: {
          color: "#949494"
        },
        circle: {
          borderRadius: "50%",
          backgroundColor: "#FFF",
          height: 16,
          width: 16,
          border: "2px solid #37C846"
        },
        disabled: {
          borderRadius: "50%",
          backgroundColor: "#E4E4E4",
          height: 16,
          width: 16,
          border: "2px solid #E4E4E4"
        },
        completed: {
          color: "#00C8FF",
          height: 16,
          width: 16,
          background: "#37C846",
          borderRadius: "100%",
          padding: "2px"
        }
      },
      steps: [{
        text: "Step1",
        active: !0
      }]
    }, zr.propTypes = {
      styles: c.a.object.isRequired,
      steps: c.a.array.isRequired,
      stepperProps: c.a.object
    };
    var Rr,
        Dr = zr,
        Zr = t(35),
        qr = t(36),
        Ur = t.n(qr),
        Hr = t(37);

    var Vr = d.a.div(Rr || (Rr = function (e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }(["\n  width: 100%;\n  margin: 10px 0px;\n  .MuiFormControl-root {\n    height: 100%;\n    width: 100%;\n  }\n  .MuiInputBase-root {\n    height: 100%;\n  }\n  .MuiInputBase-input {\n    padding: 18.5px 14px;\n    color: #00377B;\n  }\n  .MuiInput-underline {\n    &:before {\n      border-bottom: none;\n    }\n    &:after {\n        border-bottom: none;\n    }\n  }\n  .MuiSvgIcon-root {\n      color: #4cc5f2;\n  }\n  .MuiInput-underline:hover:not(.Mui-disabled):before {\n    border-bottom: none!important;\n  }\n  .MuiInputAdornment-positionEnd {\n    margin-right: 0px;\n  }\n"]))),
        Wr = t(5),
        _r = t.n(Wr),
        Gr = t(21),
        Yr = t.n(Gr),
        Qr = function Qr(e) {
      return new Promise(function (n, t) {
        Yr.a.getData(e, function () {
          switch (Yr.a.getTag(this, "Orientation")) {
            case 3:
              n(3);
              break;

            case 4:
              n(4);
              break;

            case 5:
              n(5);
              break;

            case 6:
              n(6);
              break;

            case 7:
              n(7);
              break;

            case 8:
              n(8);
              break;

            default:
              n(9);
          }
        });
      });
    },
        $r = function $r(e, n) {
      var t = new Image();
      return t.src = window.URL.createObjectURL(e), new Promise(function (r) {
        t.onload = function () {
          var a = document.createElement("canvas"),
              o = t.width,
              i = t.height,
              l = a.getContext("2d");

          switch (a.width = o, a.height = i, n) {
            case 2:
              l.translate(i, 0), l.scale(-1, 1);
              break;

            case 3:
              l.translate(o, i), l.rotate(180 * Math.PI / 180);
              break;

            case 4:
              l.translate(0, i), l.scale(1, -1);
              break;

            case 5:
              a.width = i, a.height = o, l.rotate(90 * Math.PI / 180), l.scale(1, -1);
              break;

            case 6:
              a.width = i, a.height = o, l.rotate(90 * Math.PI / 180), l.translate(0, -i);
              break;

            case 7:
              a.width = i, a.height = o, l.rotate(-90 * Math.PI / 180), l.translate(-o, i), l.scale(1, -1);
              break;

            case 8:
              a.width = i, a.height = o, l.translate(0, o), l.rotate(-90 * Math.PI / 180);
          }

          l.drawImage(t, 0, 0, o, i), a.toBlob(function (e) {
            r(e);
          }, e.type);
        };
      });
    };

    function Xr() {
      return (Xr = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function Kr(e, n) {
      if (null == e) return {};

      var t,
          r,
          a = function (e, n) {
        if (null == e) return {};
        var t,
            r,
            a = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || (a[t] = e[t]);
        }

        return a;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
        }
      }

      return a;
    }

    function Jr(e, n, t) {
      return n in e ? Object.defineProperty(e, n, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = t, e;
    }

    var ea = Object(o.forwardRef)(function (e, n) {
      var t = e.placeholder,
          r = e.value,
          a = e.onChange,
          o = e.format,
          l = e.classes,
          c = (e.multiSelected, e.onClick),
          s = e.availableDays,
          u = e.selectFromAvailable,
          p = e.invokeAPIonDateClick,
          d = Kr(e, ["placeholder", "value", "onChange", "format", "classes", "multiSelected", "onClick", "availableDays", "selectFromAvailable", "invokeAPIonDateClick"]),
          f = Object(Hr.useStyles)();
      return i.a.createElement(Vr, {
        onClick: c
      }, i.a.createElement(Zr.KeyboardDatePicker, Xr({
        ref: n,
        placeholder: t,
        onChange: function onChange(e) {
          (!u || null != s && s.length) && a(e);
        },
        format: o,
        value: r,
        renderDay: u && s.length || u && !p ? function (e, n, t, r) {
          return s.includes(_r()(n).format("DD/MM/YYYY")) || (n = _r()(function (e, n) {
            if (e) {
              var t = e.split(n),
                  r = Number(t[2]),
                  a = Number(t[1] - 1),
                  o = Number(t[0]);
              return _r()(new Date(r, a, o));
            }

            return null;
          }(s[0], "/"))), i.a.cloneElement(r, {
            className: Fr()(l.day, [_r()(e).format("DD/MM/YYYY") === _r()(n).format("DD/MM/YYYY") && s.includes(_r()(n).format("DD/MM/YYYY")) && [f.daySelected, l.daySelected], s.includes(_r()(e).format("DD/MM/YYYY")) ? [f.dayHighlighted, l.dayHighlighted] : [f.dayDisabled, l.dayDisabled], !t && [f.nonCurrentMonthDay, l.nonCurrentMonthDay], !s.includes(_r()(e).format("DD/MM/YYYY")) && [f.dayDisabled, l.dayDisabled]])
          });
        } : null,
        inputVariant: "outlined"
      }, d)));
    });
    ea.defaultProps = {
      format: "DD/MM/YYYY",
      label: "Fecha de nacimiento",
      value: null,
      onChange: function onChange() {},
      selectFromAvailable: !0,
      availableDays: [],
      inputVariant: "outlined",
      okLabel: "Guardar",
      cancelLabel: "Cancelar",
      onClick: function onClick() {},
      invokeAPIonDateClick: !0
    };
    var na,
        ta = Ur()(function (e) {
      var n;
      return {
        day: (n = {
          margin: 0,
          width: "36px",
          height: "36px"
        }, Jr(n, "margin", "0px 2px"), Jr(n, "padding", "0px"), Jr(n, "borderRadius", "0"), Jr(n, "transition", "none"), n),
        dayHighlighted: {
          borderRadius: "100%",
          background: "white",
          color: "#4cc5f2",
          border: "2px solid #4cc5f2"
        },
        daySelected: {
          borderRadius: "100%",
          background: "#4cc5f2",
          color: "white"
        },
        endCap: {
          borderTopRightRadius: "50%",
          borderBottomRightRadius: "50%"
        },
        nonCurrentMonthDay: {
          visibility: "hidden"
        },
        dayDisabled: {
          pointerEvents: "none"
        }
      };
    }, {
      name: "DatePicker"
    })(ea);

    var ra = {
      Content: d.a.div(na || (na = function (e, n) {
        return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
          raw: {
            value: Object.freeze(n)
          }
        }));
      }(["\n  text-align: center;\n  margin: 0 15px;\n  .instructionContainer {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    section {\n        display: flex;\n        align-items: center;\n        width: 250px;\n        margin: 15px 0px;\n        span {\n          margin-left: 15px;\n          text-align: left;\n          color: #00377B;\n          font-size: 20px;\n        }\n    }\n  }\n"])))
    },
        aa = function aa(e) {
      var n = e.instructions;
      return i.a.createElement(ra.Content, null, i.a.createElement("div", {
        className: "instructionContainer"
      }, n.map(function (e, n) {
        return i.a.createElement("section", {
          key: n,
          style: e.description ? {
            justifyContent: "flex-start"
          } : {
            justifyContent: "center"
          }
        }, i.a.createElement("img", {
          src: e.src,
          alt: ""
        }), i.a.createElement("span", null, e.description));
      })));
    };

    aa.defaultProps = {
      instructions: [{
        src: "/images/TurnPhone.svg",
        description: "Coloca tu cámara horizontalmente"
      }, {
        src: "/images/AvoidMovement.svg",
        description: "Evita movimientos mientras enfocas"
      }, {
        src: "/images/AvoidGlare.svg",
        description: "Evita los brillos y reflejos"
      }, {
        src: "/images/NoObstructions.svg",
        description: "No obstruyas la imagen"
      }, {
        src: "/images/AvoidInclinations.svg",
        description: "Evita inclinaciones"
      }]
    }, aa.propTypes = {
      instructions: c.a.arrayOf(c.a.shape({
        src: c.a.string,
        description: c.a.string
      })).isRequired
    };
    var oa,
        ia = aa;

    var la = {
      ImageWrapper: d.a.section(oa || (oa = function (e, n) {
        return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
          raw: {
            value: Object.freeze(n)
          }
        }));
      }(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 35px 0 0;\n  .imageWrapper section {\n    align-items: center;\n    width: 145px;\n    height: 103px;\n    border: 1px solid #00377B;\n    display: flex;\n    justify-content: center;\n    margin: 10px;\n    border-radius: 5px;\n  }\n  .imageWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n  .capturedImg {\n    width: 100%;\n    height: 100%;\n    border-radius: 4px;\n  }\n  .camIcon {\n    width: 50px;\n  }\n  .disabledState {\n    opacity: 0.3;\n  }\n"])))
    },
        ca = function ca(e) {
      var n = e.images;
      return i.a.createElement(la.ImageWrapper, {
        style: {
          margin: "0",
          marginBottom: "15px"
        }
      }, n.filter(function (e) {
        return e.src;
      }).map(function (e, n) {
        return i.a.createElement("div", {
          className: "imageWrapper",
          key: n
        }, i.a.createElement("span", null, e.description), i.a.createElement("section", null, i.a.createElement("img", {
          className: "capturedImg",
          src: e.src,
          alt: ""
        })));
      }));
    };

    ca.propTypes = {
      images: c.a.arrayOf(c.a.shape({
        src: c.a.string,
        description: c.a.string
      })).isRequired
    };

    var sa,
        ua = ca,
        pa = t(6),
        da = t.n(pa),
        fa = t(38),
        ma = t.n(fa),
        ha = function ha() {
      return i.a.createElement("svg", {
        width: "20px",
        height: "20px",
        viewBox: "0 0 40 40",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, i.a.createElement("g", {
        id: "Unassisted---CO---1.0",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, i.a.createElement("g", {
        id: "Genericos/Navegacion/-subir,-upload/Ligh-Mode",
        transform: "translate(-30.000000, -30.000000)"
      }, i.a.createElement("g", {
        id: "Genericos/Navegacion/-descargar,-download/Dark-Mode"
      }, i.a.createElement("g", {
        id: "Genericos/Navegacion/-descargar,-downloadDark-Mode"
      }, i.a.createElement("g", {
        id: "Genericos/descargar,-download"
      }, i.a.createElement("g", {
        id: "B2C/descargar,-download"
      }, i.a.createElement("g", {
        id: "Primary",
        transform: "translate(30.000000, 30.000000)",
        fillRule: "nonzero"
      }, i.a.createElement("path", {
        d: "M38.15,39.56 L1.85,39.56 C1.18173545,39.56 0.64,39.0182645 0.64,38.35 C0.64,37.6817355 1.18173545,37.14 1.85,37.14 L38.15,37.14 C38.8182645,37.14 39.36,37.6817355 39.36,38.35 C39.36,39.0182645 38.8182645,39.56 38.15,39.56 Z",
        id: "Path",
        fill: "#00C8FF"
      }), i.a.createElement("path", {
        d: "M19.83,0.48 C20.4982645,0.48 21.04,1.02173545 21.04,1.69 L21.0393392,27.302 L27.76,17.87 C28.0100859,17.5127344 28.4317737,17.3160266 28.8662178,17.3539746 C29.3006618,17.3919226 29.6818597,17.658761 29.8662178,18.0539746 C30.0505759,18.4491881 30.0100859,18.9127344 29.76,19.27 L20.82,31.79 C20.5913647,32.1094849 20.2228667,32.2993172 19.83,32.3 C19.4323886,32.3077753 19.0571739,32.1164158 18.83,31.79 L9.93,19.28 C9.67991409,18.9227344 9.6394241,18.4591881 9.82378222,18.0639746 C10.0081403,17.668761 10.3893382,17.4019226 10.8237822,17.3639746 C11.2582263,17.3260266 11.6799141,17.5227344 11.93,17.88 L18.6193392,27.297 L18.62,1.69 C18.62,1.02173545 19.1617355,0.48 19.83,0.48 Z",
        id: "Combined-Shape",
        fill: "#00377D",
        transform: "translate(19.845000, 16.390114) scale(1, -1) translate(-19.845000, -16.390114) "
      })), i.a.createElement("g", {
        id: "Marco"
      }, i.a.createElement("rect", {
        id: "Rectangle",
        x: "0",
        y: "0",
        width: "100",
        height: "100"
      })))))))));
    };

    var ga = {
      Container: d.a.div(sa || (sa = function (e, n) {
        return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
          raw: {
            value: Object.freeze(n)
          }
        }));
      }(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding: 0.3rem 0 0 0;\n  border-bottom: ", ";\n  .MuiButton-root {\n    min-width: 250px;\n    letter-spacing: 0px;\n  }\n  width: ", '\n    label.cameraButton {\n    color: white;\n  }\n  label.cameraButton input[accept="image/*"] {\n    display: none;\n    width: 100%;\n  }\n  .btnContainerTransparent {\n    .MuiButton-containedSecondary {\n      background-color: transparent;\n      box-shadow: none;\n      margin-bottom: 15px;\n    }\n    label.cameraButton {\n      color: #4cc5f2;\n      flex: 1;\n      text-align: left;\n    }\n  }\n  .btnContainer {\n    padding: 1.6rem;\n    padding-bottom: 1rem;\n  }\n  .btnStyle {\n    border-radius: 30px;\n  }\n  .btnContainer-upload {\n    padding: 0px 33px;\n    position: relative;\n    input[type=file] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      z-index: 500;\n      opacity: 0;\n      height: 100%;\n    }\n    label.cameraButton {\n      color: #565656;\n      flex: 1;\n      text-align: left;\n      word-break: break-all;\n      text-align: left;\n      margin-right: 50px;\n    }\n  }\n  .btnStyle-upload {\n    border: none;\n    width: 100%;\n    padding: 5px 0px;\n    .MuiButton-label {\n      justify-content: space-between;\n      .MuiButton-endIcon {\n        display: flex;\n        margin-left: 0px;\n        margin-right: 0px;\n      }\n    }\n    .cameraButton {\n      text-transform: none;\n      font-size: 16px;\n      font-weight: normal;\n      input {\n        width: 100vw;\n      }\n    }\n    .secondary-cyan {\n      color: #00C8FF !important;\n    }\n  }\n  .highlightedLabel {\n    display: flex;\n    padding-left: 13;\n    padding: 13px 0px 16px 33px;\n    color: #00C8FF;\n    word-break: break-all;\n    text-align: left;\n    margin-right: 50px;\n  }\n  .inputBtn-container {\n    padding: 0px 33px;\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    .MuiOutlinedInput-root {\n      width: 100%;\n      max-width: 234px;\n      border-radius: 2px;\n    }\n    .actions {\n      display: flex;\n      justify-content: space-between;\n      width: 30%;\n      .MuiIconButton-root {\n        padding: 0;\n        &:hover {\n          background-color: transparent !important;\n        }\n      }\n    }\n    input[type=file] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      z-index: 500;\n      opacity: 0;\n      height: 100%;\n    }\n  }\n'])), function (e) {
        return "upload" === e.type ? "1px solid rgb(0, 0, 0, 0.1)" : "none";
      }, function (e) {
        return "upload" === e.type ? "100%" : "auto";
      })
    },
        ba = t(4);

    function ya(e, n, t, r, a, o, i) {
      try {
        var l = e[o](i),
            c = l.value;
      } catch (e) {
        return void t(e);
      }

      l.done ? n(c) : Promise.resolve(c).then(r, a);
    }

    function xa(e) {
      return function () {
        var n = this,
            t = arguments;
        return new Promise(function (r, a) {
          var o = e.apply(n, t);

          function i(e) {
            ya(o, r, a, i, l, "next", e);
          }

          function l(e) {
            ya(o, r, a, i, l, "throw", e);
          }

          i(void 0);
        });
      };
    }

    function va(e, n) {
      var t = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        n && (r = r.filter(function (n) {
          return Object.getOwnPropertyDescriptor(e, n).enumerable;
        })), t.push.apply(t, r);
      }

      return t;
    }

    function Ca(e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2 ? va(Object(t), !0).forEach(function (n) {
          wa(e, n, t[n]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : va(Object(t)).forEach(function (n) {
          Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
        });
      }

      return e;
    }

    function wa(e, n, t) {
      return n in e ? Object.defineProperty(e, n, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = t, e;
    }

    function Ea() {
      return (Ea = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function Oa(e, n) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, n) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var t = [],
            r = !0,
            a = !1,
            o = void 0;

        try {
          for (var i, l = e[Symbol.iterator](); !(r = (i = l.next()).done) && (t.push(i.value), !n || t.length !== n); r = !0) {
            ;
          }
        } catch (e) {
          a = !0, o = e;
        } finally {
          try {
            r || null == l.return || l.return();
          } finally {
            if (a) throw o;
          }
        }

        return t;
      }(e, n) || function (e, n) {
        if (!e) return;
        if ("string" == typeof e) return ja(e, n);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === t && e.constructor && (t = e.constructor.name);
        if ("Map" === t || "Set" === t) return Array.from(e);
        if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return ja(e, n);
      }(e, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function ja(e, n) {
      (null == n || n > e.length) && (n = e.length);

      for (var t = 0, r = new Array(n); t < n; t++) {
        r[t] = e[t];
      }

      return r;
    }

    function ka(e, n) {
      if (null == e) return {};

      var t,
          r,
          a = function (e, n) {
        if (null == e) return {};
        var t,
            r,
            a = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || (a[t] = e[t]);
        }

        return a;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
        }
      }

      return a;
    }

    var Pa = ["dui_front", "dui_back", "recibo_luz_recibo_agua", "other_document", "buro-consulta", "buro-compartir", "medios-solucion", "aceptacion-cliente", "aceptacion-vendedo"],
        Sa = function Sa(e) {
      return e ? e.toLowerCase() : e;
    },
        Fa = function Fa(e) {
      var n;
      return e ? null == e || null === (n = e.trim()) || void 0 === n ? void 0 : n.replace(/ +/g, "_") : e;
    },
        Ia = function Ia(e) {
      return e ? e.replace(/\s/g, "") : e;
    },
        La = /^[a-zA-ZñáéíóúÁÉÍÑÓÚ1234567890_-\s]*$/,
        Ma = function Ma(e) {
      var n = e.btnText,
          t = e.field,
          r = e.fileName,
          a = e.filePath,
          o = e.getImage,
          l = e.type,
          c = e.upload,
          s = e.selfie,
          u = e.showInput,
          p = e.secondaryText,
          d = e.customInputUpload,
          f = e.customInputUploadProps,
          m = (e.inputError, ka(e, ["btnText", "field", "fileName", "filePath", "getImage", "type", "upload", "selfie", "showInput", "secondaryText", "customInputUpload", "customInputUploadProps", "inputError"])),
          h = Oa(i.a.useState({}), 2),
          g = h[0],
          b = h[1],
          y = Oa(i.a.useState(""), 2),
          x = y[0],
          v = y[1],
          C = function () {
        var e = xa(_regeneratorRuntime.mark(function e(n) {
          var i, l, c, s, u, p, f, h;
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (i = n.target.files[0], l = i.name, c = i.size, s = l.split(".").pop(), !(c > 5e6)) {
                    e.next = 6;
                    break;
                  }

                  return null != m && m.onPdfSizeMax && m.onPdfSizeMax(), e.abrupt("return");

                case 6:
                  return u = m.count && g[m.count] ? "".concat(t, "-").concat(m.count) : t, p = m.count && g[m.count] ? Fa(g[m.count]) : d ? Fa(x) : r, localStorage.setItem("".concat(u, "-localName"), l), f = m.customUpload ? "true" : "false", h = m.customDoc ? "true" : "false", m.loaderFunc && m.loaderFunc(), e.prev = 12, e.next = 15, m.convertDataToFile(u, a, URL.createObjectURL(i), p, o, f, s, h, d, i);

                case 15:
                  e.next = 20;
                  break;

                case 17:
                  e.prev = 17, e.t0 = e.catch(12), console.log(e.t0);

                case 20:
                case "end":
                  return e.stop();
              }
            }
          }, e, null, [[12, 17]]);
        }));
        return function (n) {
          return e.apply(this, arguments);
        };
      }(),
          w = function () {
        var e = xa(_regeneratorRuntime.mark(function e(n) {
          var i, l, c, s;
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  i = n.target.files[0], l = i.name, c = i.type, (s = l.split(".").pop()) && "pdf" === s.toLowerCase() ? C(n) : c.startsWith("image") && (m.loaderFunc && m.loaderFunc(), Qr(i).then(function (e) {
                    $r(i, e).then(function () {
                      var e = xa(_regeneratorRuntime.mark(function e(n) {
                        var c, u, p, f, h, b;
                        return _regeneratorRuntime.wrap(function (e) {
                          for (;;) {
                            switch (e.prev = e.next) {
                              case 0:
                                return c = URL.createObjectURL(n), u = m.count && g[m.count] ? "".concat(t, "-").concat(m.count) : t, !m.customUpload && localStorage.setItem(u, c), localStorage.setItem("".concat(u, "-localName"), l), p = m.count && g[m.count] ? Fa(g[m.count]) : d ? Fa(x) : r, f = m.customUpload ? "true" : "false", h = m.customDoc ? "true" : "false", e.prev = 7, e.next = 10, ma()(n, m.compressionConfig);

                              case 10:
                                return b = e.sent, e.next = 13, m.convertDataToFile(u, a, URL.createObjectURL(b), p, o, f, s, h, d, i);

                              case 13:
                                e.next = 18;
                                break;

                              case 15:
                                e.prev = 15, e.t0 = e.catch(7), console.log(e.t0);

                              case 18:
                              case "end":
                                return e.stop();
                            }
                          }
                        }, e, null, [[7, 15]]);
                      }));
                      return function (n) {
                        return e.apply(this, arguments);
                      };
                    }());
                  }));

                case 4:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }));
        return function (n) {
          return e.apply(this, arguments);
        };
      }();

      return i.a.createElement(ga.Container, {
        type: l,
        className: "scanner-container"
      }, "upload" === l ? function () {
        var e = "image/*";

        if (m.allowPdf && (e += ",application/pdf"), e = m.fileAccept || e, d) {
          var t,
              r,
              a = f.inputProps,
              o = void 0 === a ? {} : a,
              l = f.inValidNames,
              c = void 0 === l ? [] : l,
              s = ka(f, ["inputProps", "inValidNames"]);
          return i.a.createElement(i.a.Fragment, null, i.a.createElement("div", {
            style: {
              position: "relative",
              width: "100%"
            },
            disabled: m.disabled
          }, i.a.createElement("div", {
            className: "inputBtn-container"
          }, i.a.createElement(j, Ea({
            onChange: function onChange(e) {
              La.test(e.target.value) && v(e.target.value.toLowerCase());
            },
            error: x && !Ia(x) || c.includes(Fa(Sa(x))),
            variant: "outlined",
            inputProps: {
              maxLength: 32
            },
            value: x,
            label: "Nombre de documento"
          }, o)), i.a.createElement("div", {
            className: "actions"
          }, i.a.createElement(ba.IconButton, {
            component: "span",
            disableRipple: !0,
            disableFocusRipple: !0
          }, i.a.createElement("input", {
            type: "file",
            disabled: !(Ia(x) && !c.includes(Fa(Sa(x)))) || m.disabled || !1,
            accept: e,
            value: "",
            onChange: w
          }), null !== (t = s.uploadIcon) && void 0 !== t ? t : i.a.createElement(ha, null)), s.deleteIcon && i.a.createElement(ba.IconButton, {
            component: "span",
            disableRipple: !0,
            disableFocusRipple: !0,
            onClick: s.onRemove
          }, s.deleteIcon)))), null === (r = m.customElement) || void 0 === r ? void 0 : r.call(m, {
            error: x && !Ia(x) || c.includes(Fa(Sa(x))),
            value: x
          }));
        }

        return i.a.createElement("div", {
          style: {
            position: "relative",
            width: "100%"
          },
          disabled: m.disabled
        }, i.a.createElement("div", {
          className: "btnContainer-upload"
        }, m.filled ? i.a.createElement(i.a.Fragment, null) : i.a.createElement("input", {
          type: "file",
          disabled: !(!m.customUpload || g[m.count] && !Pa.includes(Fa(Sa(g[m.count])))) || m.disabled || !1,
          accept: e,
          value: "",
          onChange: w
        }), i.a.createElement(da.a, {
          variant: "outlined",
          className: "btnStyle-upload",
          endIcon: m.icon || i.a.createElement(ha, null),
          onClick: function onClick() {
            m.filled && m.filled(), m.filled && b(Ca(Ca({}, g), {}, wa({}, m.count, "")));
          }
        }, i.a.createElement("label", {
          className: m.filled && !p ? "cameraButton secondary-cyan" : "cameraButton"
        }, n))), u && i.a.createElement("div", {
          style: {
            marginLeft: "33px",
            maxWidth: "200px"
          }
        }, i.a.createElement(j, {
          onChange: function onChange(e) {
            La.test(e.target.value) && b(Ca(Ca({}, g), {}, wa({}, m.count, e.target.value.toLowerCase())));
          },
          error: Pa.includes(Fa(Sa(g[m.count]))) || !g[m.count],
          variant: "outlined",
          inputProps: {
            maxLength: 32
          },
          value: g[m.count] || "",
          label: "Nombre de documento"
        })), p && i.a.createElement("label", {
          className: "highlightedLabel"
        }, p));
      }() : c ? i.a.createElement("div", {
        className: m.transparentButton ? "btnContainerTransparent" : "btnContainer"
      }, i.a.createElement(da.a, {
        variant: "contained",
        color: "secondary",
        className: "btnStyle"
      }, i.a.createElement("label", {
        className: "cameraButton"
      }, n, i.a.createElement("input", {
        type: "file",
        accept: m.fileAccept || "image/*",
        onChange: w
      })))) : i.a.createElement("div", {
        className: m.transparentButton ? "btnContainerTransparent" : "btnContainer"
      }, i.a.createElement(da.a, {
        variant: "contained",
        color: "secondary",
        className: "btnStyle"
      }, i.a.createElement("label", {
        className: "cameraButton"
      }, n, i.a.createElement("input", {
        type: "file",
        accept: m.fileAccept || "image/*",
        onChange: w,
        capture: s ? "user" : "camera"
      })))));
    };

    Ma.defaultProps = {
      type: "capture",
      upload: !1,
      selfie: !1,
      showInput: !1,
      disabled: !1,
      customInputUpload: !1,
      customInputUploadProps: {}
    };
    var Na,
        Ba = Ma;
    var Ta = {
      Container: d.a.div(Na || (Na = function (e, n) {
        return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
          raw: {
            value: Object.freeze(n)
          }
        }));
      }(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding: 0.3rem 0 0 0;\n  border-bottom: ", ";\n  .MuiButton-root {\n    min-width: 250px;\n    letter-spacing: 0px;\n  }\n  width: ", '\n    label.cameraButton {\n    color: white;\n  }\n  label.cameraButton input[accept="image/*"] {\n    display: none;\n    width: 100%;\n  }\n  .btnContainerTransparent {\n    .MuiButton-containedSecondary {\n      background-color: transparent;\n      box-shadow: none;\n      margin-bottom: 15px;\n    }\n    label.cameraButton {\n      color: #4cc5f2;\n      flex: 1;\n      text-align: left;\n    }\n  }\n  .btnContainer {\n    padding: 1.6rem;\n    padding-bottom: 1rem;\n  }\n  .btnStyle {\n    border-radius: 30px;\n  }\n  .btnContainer-upload {\n    padding: 0px 33px;\n    position: relative;\n    input[type=file] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      z-index: 500;\n      opacity: 0;\n      height: 100%;\n    }\n    label.cameraButton {\n      color: #565656;\n      flex: 1;\n      text-align: left;\n      word-break: break-all;\n      text-align: left;\n      margin-right: 50px;\n    }\n  }\n  .btnStyle-upload {\n    border: none;\n    width: 100%;\n    padding: 5px 0px;\n    .MuiButton-label {\n      justify-content: space-between;\n      .MuiButton-endIcon {\n        display: flex;\n        margin-left: 0px;\n        margin-right: 0px;\n      }\n    }\n    .cameraButton {\n      text-transform: none;\n      font-size: 16px;\n      font-weight: normal;\n      input {\n        width: 100vw;\n      }\n    }\n    .secondary-cyan {\n      color: #00C8FF !important;\n    }\n  }\n  .highlightedLabel {\n    display: flex;\n    padding-left: 13;\n    padding: 13px 0px 16px 33px;\n    color: #00C8FF;\n    word-break: break-all;\n    text-align: left;\n    margin-right: 50px;\n  }\n  .inputBtn-container {\n    padding: 0px 33px;\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    .MuiOutlinedInput-root {\n      width: 100%;\n      max-width: 234px;\n      border-radius: 2px;\n    }\n    .actions {\n      display: flex;\n      justify-content: space-between;\n      width: 30%;\n      .MuiIconButton-root {\n        padding: 0;\n        &:hover {\n          background-color: transparent !important;\n        }\n      }\n    }\n    input[type=file] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      z-index: 500;\n      opacity: 0;\n      height: 100%;\n    }\n  }\n'])), function (e) {
        return "upload" === e.type ? "1px solid rgb(0, 0, 0, 0.1)" : "none";
      }, function (e) {
        return "upload" === e.type ? "100%" : "auto";
      })
    },
        Aa = t(39),
        za = t.n(Aa);

    function Ra(e, n, t, r, a, o, i) {
      try {
        var l = e[o](i),
            c = l.value;
      } catch (e) {
        return void t(e);
      }

      l.done ? n(c) : Promise.resolve(c).then(r, a);
    }

    function Da(e) {
      return function () {
        var n = this,
            t = arguments;
        return new Promise(function (r, a) {
          var o = e.apply(n, t);

          function i(e) {
            Ra(o, r, a, i, l, "next", e);
          }

          function l(e) {
            Ra(o, r, a, i, l, "throw", e);
          }

          i(void 0);
        });
      };
    }

    function Za(e, n) {
      var t = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        n && (r = r.filter(function (n) {
          return Object.getOwnPropertyDescriptor(e, n).enumerable;
        })), t.push.apply(t, r);
      }

      return t;
    }

    function qa(e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2 ? Za(Object(t), !0).forEach(function (n) {
          Ua(e, n, t[n]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Za(Object(t)).forEach(function (n) {
          Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
        });
      }

      return e;
    }

    function Ua(e, n, t) {
      return n in e ? Object.defineProperty(e, n, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = t, e;
    }

    function Ha() {
      return (Ha = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function Va(e, n) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, n) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var t = [],
            r = !0,
            a = !1,
            o = void 0;

        try {
          for (var i, l = e[Symbol.iterator](); !(r = (i = l.next()).done) && (t.push(i.value), !n || t.length !== n); r = !0) {
            ;
          }
        } catch (e) {
          a = !0, o = e;
        } finally {
          try {
            r || null == l.return || l.return();
          } finally {
            if (a) throw o;
          }
        }

        return t;
      }(e, n) || function (e, n) {
        if (!e) return;
        if ("string" == typeof e) return Wa(e, n);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === t && e.constructor && (t = e.constructor.name);
        if ("Map" === t || "Set" === t) return Array.from(e);
        if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Wa(e, n);
      }(e, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Wa(e, n) {
      (null == n || n > e.length) && (n = e.length);

      for (var t = 0, r = new Array(n); t < n; t++) {
        r[t] = e[t];
      }

      return r;
    }

    function _a(e, n) {
      if (null == e) return {};

      var t,
          r,
          a = function (e, n) {
        if (null == e) return {};
        var t,
            r,
            a = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || (a[t] = e[t]);
        }

        return a;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
        }
      }

      return a;
    }

    var Ga = ["dui_front", "dui_back", "recibo_luz_recibo_agua", "other_document", "buro-consulta", "buro-compartir", "medios-solucion", "aceptacion-cliente", "aceptacion-vendedo"],
        Ya = function Ya(e) {
      return e ? e.toLowerCase() : e;
    },
        Qa = function Qa(e) {
      var n;
      return e ? null == e || null === (n = e.trim()) || void 0 === n ? void 0 : n.replace(/ +/g, "_") : e;
    },
        $a = function $a(e) {
      return e ? e.replace(/\s/g, "") : e;
    },
        Xa = /^[a-zA-ZñáéíóúÁÉÍÑÓÚ1234567890_-\s]*$/,
        Ka = function Ka(e) {
      var n = e.btnText,
          t = e.field,
          r = e.fileName,
          a = e.filePath,
          o = e.getImage,
          l = e.type,
          c = e.upload,
          s = e.selfie,
          u = e.showInput,
          p = e.secondaryText,
          d = e.customInputUpload,
          f = e.customInputUploadProps,
          m = (e.inputError, _a(e, ["btnText", "field", "fileName", "filePath", "getImage", "type", "upload", "selfie", "showInput", "secondaryText", "customInputUpload", "customInputUploadProps", "inputError"])),
          h = Va(i.a.useState({}), 2),
          g = h[0],
          b = h[1],
          y = Va(i.a.useState(""), 2),
          x = y[0],
          v = y[1],
          C = function () {
        var e = Da(_regeneratorRuntime.mark(function e(n) {
          var i, l, c, s, u, p, f, h;
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (i = n.target.files[0], l = i.name, c = i.size, s = l.split(".").pop(), !(c > 5e6)) {
                    e.next = 6;
                    break;
                  }

                  return null != m && m.onPdfSizeMax && m.onPdfSizeMax(), e.abrupt("return");

                case 6:
                  return u = m.count && g[m.count] ? "".concat(t, "-").concat(m.count) : t, p = m.count && g[m.count] ? Qa(g[m.count]) : d ? Qa(x) : r, localStorage.setItem("".concat(u, "-localName"), l), f = m.customUpload ? "true" : "false", h = m.customDoc ? "true" : "false", m.loaderFunc && m.loaderFunc(), e.prev = 12, e.next = 15, m.convertDataToFile(u, a, URL.createObjectURL(i), p, o, f, s, h, d);

                case 15:
                  e.next = 20;
                  break;

                case 17:
                  e.prev = 17, e.t0 = e.catch(12), console.log(e.t0);

                case 20:
                case "end":
                  return e.stop();
              }
            }
          }, e, null, [[12, 17]]);
        }));
        return function (n) {
          return e.apply(this, arguments);
        };
      }(),
          w = function w(e) {
        return new Promise(function (n) {
          new za.a(e, qa(qa({
            quality: .6
          }, m.compressionConfig), {}, {
            success: function success(e) {
              n(e);
            },
            error: function error(e) {
              console.log(e);
            }
          }));
        });
      },
          E = function () {
        var e = Da(_regeneratorRuntime.mark(function e(n) {
          var i, l, c, s;
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  i = n.target.files[0], l = i.name, c = i.type, (s = l.split(".").pop()) && "pdf" === s.toLowerCase() ? C(n) : c.startsWith("image") && (m.loaderFunc && m.loaderFunc(), Qr(i).then(function (e) {
                    $r(i, e).then(function () {
                      var e = Da(_regeneratorRuntime.mark(function e(n) {
                        var i, c, u, p, f, h;
                        return _regeneratorRuntime.wrap(function (e) {
                          for (;;) {
                            switch (e.prev = e.next) {
                              case 0:
                                return i = URL.createObjectURL(n), c = m.count && g[m.count] ? "".concat(t, "-").concat(m.count) : t, !m.customUpload && localStorage.setItem(c, i), localStorage.setItem("".concat(c, "-localName"), l), u = m.count && g[m.count] ? Qa(g[m.count]) : d ? Qa(x) : r, p = m.customUpload ? "true" : "false", f = m.customDoc ? "true" : "false", e.prev = 7, e.next = 10, w(n);

                              case 10:
                                return h = e.sent, e.next = 13, m.convertDataToFile(c, a, URL.createObjectURL(h), u, o, p, s, f, d);

                              case 13:
                                e.next = 18;
                                break;

                              case 15:
                                e.prev = 15, e.t0 = e.catch(7), console.log(e.t0);

                              case 18:
                              case "end":
                                return e.stop();
                            }
                          }
                        }, e, null, [[7, 15]]);
                      }));
                      return function (n) {
                        return e.apply(this, arguments);
                      };
                    }());
                  }));

                case 4:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }));
        return function (n) {
          return e.apply(this, arguments);
        };
      }();

      return i.a.createElement(Ta.Container, {
        type: l
      }, "upload" === l ? function () {
        var e = "image/*";

        if (m.allowPdf && (e += ",application/pdf"), e = m.fileAccept || e, d) {
          var t,
              r = f.inputProps,
              a = void 0 === r ? {} : r,
              o = f.inValidNames,
              l = void 0 === o ? [] : o,
              c = _a(f, ["inputProps", "inValidNames"]);

          return i.a.createElement("div", {
            style: {
              position: "relative",
              width: "100%"
            },
            disabled: m.disabled
          }, i.a.createElement("div", {
            className: "inputBtn-container"
          }, i.a.createElement(j, Ha({
            onChange: function onChange(e) {
              Xa.test(e.target.value) && v(e.target.value.toLowerCase());
            },
            error: x && !$a(x) || l.includes(Qa(Ya(x))),
            variant: "outlined",
            inputProps: {
              maxLength: 32
            },
            value: x,
            label: "Nombre de documento"
          }, a)), i.a.createElement("div", {
            className: "actions"
          }, i.a.createElement(ba.IconButton, {
            component: "span",
            disableRipple: !0,
            disableFocusRipple: !0
          }, i.a.createElement("input", {
            type: "file",
            disabled: !($a(x) && !l.includes(Qa(Ya(x)))) || m.disabled || !1,
            accept: e,
            value: "",
            onChange: E
          }), null !== (t = c.uploadIcon) && void 0 !== t ? t : i.a.createElement(ha, null)), c.deleteIcon && i.a.createElement(ba.IconButton, {
            component: "span",
            disableRipple: !0,
            disableFocusRipple: !0,
            onClick: c.onRemove
          }, c.deleteIcon))));
        }

        return i.a.createElement("div", {
          style: {
            position: "relative",
            width: "100%"
          },
          disabled: m.disabled
        }, i.a.createElement("div", {
          className: "btnContainer-upload"
        }, m.filled ? i.a.createElement(i.a.Fragment, null) : i.a.createElement("input", {
          type: "file",
          disabled: !(!m.customUpload || g[m.count] && !Ga.includes(Qa(Ya(g[m.count])))) || m.disabled || !1,
          accept: e,
          value: "",
          onChange: E
        }), i.a.createElement(da.a, {
          variant: "outlined",
          className: "btnStyle-upload",
          endIcon: m.icon || i.a.createElement(ha, null),
          onClick: function onClick() {
            m.filled && m.filled(), m.filled && b(qa(qa({}, g), {}, Ua({}, m.count, "")));
          }
        }, i.a.createElement("label", {
          className: m.filled && !p ? "cameraButton secondary-cyan" : "cameraButton"
        }, n))), u && i.a.createElement("div", {
          style: {
            marginLeft: "33px",
            maxWidth: "200px"
          }
        }, i.a.createElement(j, {
          onChange: function onChange(e) {
            Xa.test(e.target.value) && b(qa(qa({}, g), {}, Ua({}, m.count, e.target.value.toLowerCase())));
          },
          error: Ga.includes(Qa(Ya(g[m.count]))) || !g[m.count],
          variant: "outlined",
          inputProps: {
            maxLength: 32
          },
          value: g[m.count] || "",
          label: "Nombre de documento"
        })), p && i.a.createElement("label", {
          className: "highlightedLabel"
        }, p));
      }() : c ? i.a.createElement("div", {
        className: m.transparentButton ? "btnContainerTransparent" : "btnContainer"
      }, i.a.createElement(da.a, {
        variant: "contained",
        color: "secondary",
        className: "btnStyle"
      }, i.a.createElement("label", {
        className: "cameraButton"
      }, n, i.a.createElement("input", {
        type: "file",
        accept: "image/*",
        onChange: E
      })))) : i.a.createElement("div", {
        className: m.transparentButton ? "btnContainerTransparent" : "btnContainer"
      }, i.a.createElement(da.a, {
        variant: "contained",
        color: "secondary",
        className: "btnStyle"
      }, i.a.createElement("label", {
        className: "cameraButton"
      }, n, i.a.createElement("input", {
        type: "file",
        accept: "image/*",
        onChange: E,
        capture: s ? "user" : "camera"
      })))));
    };

    Ka.defaultProps = {
      type: "capture",
      upload: !1,
      selfie: !1,
      showInput: !1,
      disabled: !1,
      customInputUpload: !1,
      customInputUploadProps: {}
    };

    var Ja = Ka,
        eo = function eo() {
      return i.a.createElement("svg", {
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, i.a.createElement("g", {
        id: "Assisted---SV---1.1",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, i.a.createElement("g", {
        id: "CerrarSesion",
        fillRule: "nonzero"
      }, i.a.createElement("g", {
        id: "Genericos/Usuario/-Usuario-Salir/Dark-Mode"
      }, i.a.createElement("g", {
        id: "Genericos/Usuario/-Usuario-SalirDark-Mode"
      }, i.a.createElement("g", {
        id: "Genericos/-Usuario-Salir"
      }, i.a.createElement("g", {
        id: "Nuevos"
      }, i.a.createElement("g", {
        id: "Logos_internationals",
        transform: "translate(0.200000, 0.200000)"
      }, i.a.createElement("path", {
        d: "M7.648,10.884 C5.78063842,10.884 4.09722482,9.75891371 3.38299073,8.0335416 C2.66875664,6.30816949 3.0644157,4.32243213 4.38541196,3.00258058 C5.70640823,1.68272902 7.69248785,1.2887916 9.41724012,2.0045212 C11.1419924,2.72025079 12.2656182,4.40463912 12.2640017,6.272 C12.2617922,8.81978417 10.1957851,10.884 7.648,10.884 Z M7.648,2.456 C5.54048139,2.456 3.832,4.16448139 3.832,6.272 C3.832,8.37951861 5.54048139,10.088 7.648,10.088 C9.75551861,10.088 11.464,8.37951861 11.464,6.272 C11.464,5.25993387 11.0619583,4.28931934 10.3463195,3.57368052 C9.63068066,2.8580417 8.66006613,2.456 7.648,2.456 L7.648,2.456 Z",
        id: "Shape",
        fill: "#FFFFFF"
      }), i.a.createElement("path", {
        d: "M13.2,18.42 L2.08,18.42 C1.45048539,18.42 0.857708764,18.1236117 0.48,17.62 C0.105615675,17.130505 -0.0173086054,16.4936683 0.148,15.9 C1.09979794,12.5442527 4.16388313,10.2283759 7.652,10.2283759 C11.1401169,10.2283759 14.2042021,12.5442527 15.156,15.9 C15.3213086,16.4936683 15.1983843,17.130505 14.824,17.62 C14.4412505,18.1304276 13.8379463,18.4276218 13.2,18.42 Z M7.648,11.0279894 C4.51995658,11.0315073 1.77299677,13.1076409 0.916,16.116 C0.815655921,16.4678337 0.888402695,16.8464139 1.112,17.136 C1.33946588,17.4419381 1.69877003,17.6215901 2.08,17.6200105 L13.2,17.6200105 C13.58123,17.6215901 13.9405341,17.4419381 14.168,17.136 C14.4041391,16.8527337 14.4903882,16.4735352 14.4,16.116 C13.5409738,13.1005066 10.783458,11.0225681 7.648,11.0279894 Z",
        id: "Shape",
        fill: "#FFFFFF"
      }), i.a.createElement("path", {
        d: "M20.92,18.42 L12.4,18.42 C12.1790861,18.42 12,18.2409139 12,18.02 C12,17.7990861 12.1790861,17.62 12.4,17.62 L20.92,17.62 C21.2204429,17.62 21.464,17.3764429 21.464,17.076 L21.464,1.6 C21.4618023,1.30112037 21.2188877,1.05999192 20.92,1.06 L14.16,1.06 C14.0136618,1.05569057 13.8717636,1.11054642 13.7663772,1.21216897 C13.6609909,1.31379153 13.601013,1.45360191 13.6,1.6 L13.6,13.152 C13.6,13.3729139 13.4209139,13.552 13.2,13.552 C12.9790861,13.552 12.8,13.3729139 12.8,13.152 L12.8,1.6 C12.8022045,0.859291872 13.4032886,0.26 14.144,0.26 L20.92,0.26 C21.6607114,0.26 22.2617955,0.859291872 22.264,1.6 L22.264,17.076 C22.2618034,17.8173589 21.6613589,18.4178034 20.92,18.42 L20.92,18.42 Z",
        id: "Path",
        fill: "#FFFFFF"
      }), i.a.createElement("path", {
        d: "M19.916,9.2 L15.42,9.2 C15.1990861,9.2 15.02,9.0209139 15.02,8.8 C15.02,8.5790861 15.1990861,8.4 15.42,8.4 L19.916,8.4 C20.1369139,8.4 20.316,8.5790861 20.316,8.8 C20.316,9.0209139 20.1369139,9.2 19.916,9.2 Z",
        id: "Path",
        fill: "#00C8FF"
      }), i.a.createElement("path", {
        d: "M17.62,11.232 C17.4537473,11.2317612 17.3049748,11.1287102 17.2463073,10.9731527 C17.1876399,10.8175951 17.2313102,10.6419658 17.356,10.532 L19.312,8.8 L17.356,7.076 C17.1905182,6.93009688 17.1744116,6.67775867 17.32,6.512 C17.4659031,6.34651825 17.7182413,6.33041156 17.884,6.476 L20.18,8.5 C20.2661002,8.57593322 20.3154249,8.68519977 20.3154249,8.8 C20.3154249,8.91480023 20.2661002,9.02406678 20.18,9.1 L17.884,11.124 C17.8122618,11.1912189 17.7182817,11.2296653 17.62,11.232 Z",
        id: "Path",
        fill: "#00C8FF"
      })))))))));
    },
        no = function no() {
      return i.a.createElement("svg", {
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, i.a.createElement("g", {
        id: "Assisted---SV---1.1",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, i.a.createElement("g", {
        id: "NuevoCliente",
        fillRule: "nonzero"
      }, i.a.createElement("g", {
        id: "Genericos/Usuario/-Usuario-Agregar/Dark-Mode"
      }, i.a.createElement("g", {
        id: "Genericos/Usuario/-Usuario-AgregarDark-Mode"
      }, i.a.createElement("g", {
        id: "Genericos/-Usuario-Agregar"
      }, i.a.createElement("g", {
        id: "Nuevos"
      }, i.a.createElement("g", {
        id: "Logos_internationals"
      }, i.a.createElement("path", {
        d: "M15.028,10.52 C14.8070861,10.52 14.628,10.3409139 14.628,10.12 L14.628,6 C14.628,5.7790861 14.8070861,5.6 15.028,5.6 C15.2489139,5.6 15.428,5.7790861 15.428,6 L15.428,10.12 C15.428,10.3409139 15.2489139,10.52 15.028,10.52 Z",
        id: "Path",
        fill: "#00C8FF"
      }), i.a.createElement("path", {
        d: "M17.096,8.448 L12.956,8.448 C12.7350861,8.448 12.556,8.2689139 12.556,8.048 C12.556,7.8270861 12.7350861,7.648 12.956,7.648 L17.096,7.648 C17.3169139,7.648 17.496,7.8270861 17.496,8.048 C17.496,8.2689139 17.3169139,8.448 17.096,8.448 Z",
        id: "Path",
        fill: "#00C8FF"
      }), i.a.createElement("path", {
        d: "M7.852,9.62000174 C5.98427526,9.62161778 4.29963408,8.49755885 3.58413925,6.77231525 C2.86864441,5.04707165 3.2633155,3.06067816 4.58399683,1.73999683 C5.90467816,0.419315503 7.89107165,0.0246444121 9.61631525,0.740139245 C11.3415588,1.45563408 12.4656178,3.14027526 12.4640017,5.008 C12.4595963,7.55331098 10.397311,9.61559634 7.852,9.62000174 Z M7.852,1.19199789 C6.3082091,1.19038177 4.91552987,2.11909363 4.32362504,3.54490625 C3.73172022,4.97071888 4.05721291,6.61270416 5.14826594,7.70490205 C6.23931897,8.79709995 7.88096198,9.12431452 9.3073946,8.53390536 C10.7338272,7.94349621 11.664,6.55179175 11.664,5.008 C11.6574017,2.90607829 9.95392748,1.2043916 7.852,1.2 L7.852,1.19199789 Z",
        id: "Shape",
        fill: "#FFFFFF"
      }), i.a.createElement("path", {
        d: "M13.42,17.156016 L2.284,17.156016 C1.65448539,17.156016 1.06170876,16.8596117 0.684,16.356 C0.30673732,15.8693459 0.183476169,15.2322491 0.352,14.64 C1.30107535,11.2827262 4.36515615,8.96475741 7.854,8.96475741 C11.3428439,8.96475741 14.4069246,11.2827262 15.356,14.64 C15.5243291,15.231678 15.4026794,15.8681138 15.028,16.356 C14.648605,16.8618705 14.0523283,17.1585256 13.42,17.156016 L13.42,17.156016 Z M7.852,9.76399886 C4.7223839,9.76666899 1.97434326,11.8452523 1.12,14.856 C1.02031205,15.2078623 1.0930015,15.5861441 1.316,15.876 C1.54430949,16.1804302 1.90347857,16.3585306 2.284,16.356 L13.42,16.356 C13.8047305,16.3623735 14.1691828,16.1838662 14.4,15.876 C14.6243832,15.5868343 14.6985684,15.2084895 14.6,14.856 C13.7416838,11.8411557 10.9866435,9.76221888 7.852,9.76399886 L7.852,9.76399886 Z",
        id: "Shape",
        fill: "#FFFFFF"
      })))))))));
    },
        to = function to() {
      return i.a.createElement("svg", {
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, i.a.createElement("g", {
        id: "Assisted---SV---1.1",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, i.a.createElement("g", {
        id: "ReporteDeVentas",
        fillRule: "nonzero"
      }, i.a.createElement("g", {
        id: "Genericos/Files/reporte,-report/Dark-Mode"
      }, i.a.createElement("g", {
        id: "Genericos/Files/reporte,-reportDark-Mode"
      }, i.a.createElement("g", {
        id: "Genericos/reporte,-report"
      }, i.a.createElement("g", {
        id: "B2C/reporte,-report"
      }, i.a.createElement("g", {
        id: "Primary",
        transform: "translate(0.400000, 0.400000)"
      }, i.a.createElement("path", {
        d: "M13.776,19.456 L1.424,19.456 C0.746705801,19.4538045 0.19819546,18.9052942 0.196,18.228 L0.196,6.196 C0.196,6.02308345 0.288249866,5.86330196 0.437999992,5.77684368 C0.587750117,5.6903854 0.772249883,5.6903854 0.922000008,5.77684368 C1.07175013,5.86330196 1.16400001,6.02308345 1.164,6.196 L1.164,18.228 C1.164,18.371594 1.28040597,18.488 1.424,18.488 L13.776,18.488 C13.8449563,18.488 13.9110883,18.4606072 13.9598478,18.4118478 C14.0086072,18.3630883 14.036,18.2969563 14.036,18.228 L14.036,1.464 C14.0338147,1.32197048 13.9180463,1.20798319 13.776,1.208 L6.28,1.208 C6.01269418,1.208 5.796,0.991305819 5.796,0.724 C5.796,0.456694181 6.01269418,0.24 6.28,0.24 L13.776,0.24 C14.4526466,0.24 15.0017959,0.787356948 15.004,1.464 L15.004,18.228 C15.0018045,18.9052942 14.4532942,19.4538045 13.776,19.456 Z",
        id: "Path",
        fill: "#FFFFFF"
      }), i.a.createElement("path", {
        d: "M4.472,4.564 L0.72,4.564 C0.581889307,4.5734511 0.453361289,4.49302244 0.401477841,4.36467917 C0.349594392,4.2363359 0.386121313,4.0891829 0.492,4 L4.244,0.244 C4.3366211,0.152258127 4.47520564,0.1249634 4.59569771,0.174731863 C4.71618978,0.224500326 4.79511779,0.341637198 4.796,0.472 L4.796,4.228 C4.80042918,4.31630524 4.76812481,4.40250773 4.70675194,4.46615366 C4.64537908,4.52979959 4.56040788,4.56521621 4.472,4.564 L4.472,4.564 Z",
        id: "Path",
        fill: "#00C8FF"
      }), i.a.createElement("path", {
        d: "M7.572,16.8640004 C5.65306162,16.8648764 4.0073033,15.4950641 3.65988853,13.6078364 C3.31247377,11.7206088 4.36254513,9.85452832 6.156,9.172 C6.40232582,9.08928471 6.67001295,9.21583347 6.76242635,9.45868732 C6.85483976,9.70154116 6.73900021,9.9740337 6.5,10.076 C5.21354698,10.5759581 4.43240004,11.8872526 4.60531534,13.2565662 C4.77823064,14.6258798 5.86083499,15.701822 7.23118989,15.8662815 C8.60154478,16.030741 9.90799243,15.2415146 10.4,13.952 C10.5019663,13.7129998 10.7744588,13.5971602 11.0173127,13.6895736 C11.2601665,13.7819871 11.3867153,14.0496742 11.304,14.296 C10.711308,15.8418374 9.22756511,16.8628052 7.572,16.8640004 L7.572,16.8640004 Z",
        id: "Path",
        fill: "#FFFFFF"
      }), i.a.createElement("path", {
        d: "M7.904,12.612 L11.104,12.612 C11.104,10.8446888 9.6713112,9.412 7.904,9.412 L7.904,12.612 Z",
        id: "Path",
        fill: "#00C8FF"
      }), i.a.createElement("path", {
        d: "M11.12,12.94 L7.92,12.94 C7.73819227,12.9400132 7.59019045,12.7937945 7.588,12.612 L7.588,9.412 C7.588,9.22864146 7.73664146,9.08 7.92,9.08 C9.87794401,9.08220738 11.464,10.6700547 11.464,12.628 C11.4598585,12.7150278 11.4212621,12.7968319 11.3567261,12.8553646 C11.29219,12.9138974 11.2070177,12.9443485 11.12,12.94 L11.12,12.94 Z M8.232,12.28 L10.772,12.28 C10.6157894,10.9479687 9.56427588,9.89811103 8.232,9.744 L8.232,12.28 Z",
        id: "Shape",
        fill: "#00C8FF"
      }), i.a.createElement("path", {
        d: "M11.548,7.408 L3.308,7.408 C3.04069418,7.408 2.824,7.19130582 2.824,6.924 C2.824,6.65669418 3.04069418,6.44 3.308,6.44 L11.548,6.44 C11.8153058,6.44 12.032,6.65669418 12.032,6.924 C12.032,7.19130582 11.8153058,7.408 11.548,7.408 L11.548,7.408 Z",
        id: "Path",
        fill: "#FFFFFF"
      }), i.a.createElement("path", {
        d: "M11.548,4.476 L7.708,4.476 C7.44069418,4.476 7.224,4.25930582 7.224,3.992 C7.224,3.72469418 7.44069418,3.508 7.708,3.508 L11.548,3.508 C11.8153058,3.508 12.032,3.72469418 12.032,3.992 C12.032,4.25930582 11.8153058,4.476 11.548,4.476 L11.548,4.476 Z",
        id: "Path",
        fill: "#FFFFFF"
      })))))))));
    },
        ro = function ro() {
      return i.a.createElement("svg", {
        width: "45px",
        height: "45px",
        viewBox: "0 0 45 45",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, i.a.createElement("g", {
        id: "Assisted---SV---1.2",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, i.a.createElement("g", {
        id: "400-Error",
        transform: "translate(-138.000000, -78.000000)"
      }, i.a.createElement("g", {
        id: "notification/ok,-confirmacion,-confirmation,-chulo,-listo",
        transform: "translate(138.000000, 78.000000)"
      }, i.a.createElement("g", {
        id: "notification/error,-fallo,-fail"
      }, i.a.createElement("rect", {
        id: "Marco",
        x: "0",
        y: "0",
        width: "45",
        height: "45"
      }), i.a.createElement("path", {
        d: "M22.5,45 C34.9264069,45 45,34.9264069 45,22.5 C45,10.0735931 34.9264069,0 22.5,0 C10.0735931,0 0,10.0735931 0,22.5 C0,34.9264069 10.0735931,45 22.5,45 Z",
        id: "Path",
        fill: "#F01E46"
      }), i.a.createElement("path", {
        d: "M22.5710678,20.4497475 L28.5814755,14.4393398 C29.1672619,13.8535534 30.1170094,13.8535534 30.7027958,14.4393398 C31.2885822,15.0251263 31.2885822,15.9748737 30.7027958,16.5606602 L24.6923882,22.5710678 L30.7027958,28.5814755 C31.2885822,29.1672619 31.2885822,30.1170094 30.7027958,30.7027958 C30.1170094,31.2885822 29.1672619,31.2885822 28.5814755,30.7027958 L22.5710678,24.6923882 L16.5606602,30.7027958 C15.9748737,31.2885822 15.0251263,31.2885822 14.4393398,30.7027958 C13.8535534,30.1170094 13.8535534,29.1672619 14.4393398,28.5814755 L20.4497475,22.5710678 L14.4393398,16.5606602 C13.8535534,15.9748737 13.8535534,15.0251263 14.4393398,14.4393398 C15.0251263,13.8535534 15.9748737,13.8535534 16.5606602,14.4393398 L22.5710678,20.4497475 Z",
        id: "Path",
        fill: "#FFFFFF"
      }))))));
    },
        ao = function ao() {
      return i.a.createElement("svg", {
        width: "46px",
        height: "46px",
        viewBox: "0 0 46 46",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsxlink: "http://www.w3.org/1999/xlink"
      }, i.a.createElement("title", null, "18920BD8-7364-41EE-92E8-A7AA6AA66048"), i.a.createElement("g", {
        id: "HN-1.0---Mac-298",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, i.a.createElement("g", {
        id: "Solicitud-deposito",
        transform: "translate(-137.000000, -77.000000)"
      }, i.a.createElement("g", {
        id: "solicitud-ayuda",
        transform: "translate(137.000000, 77.000000)"
      }, i.a.createElement("g", {
        id: "notification/ok,-confirmacion,-confirmation,-chulo,-listo"
      }, i.a.createElement("g", {
        id: "Genericos/Notificaciones/notification/informacion,-info,-promo/Light-Mode",
        transform: "translate(1.000000, 1.000000)"
      }, i.a.createElement("g", {
        id: "Genericos/Notificaciones/notification/informacion,-info,-promo"
      }, i.a.createElement("g", {
        id: "notification/informacion,-info,-promo"
      }, i.a.createElement("path", {
        d: "M22.5,45 C34.9264069,45 45,34.9264069 45,22.5 C45,10.0735931 34.9264069,0 22.5,0 C10.0735931,0 0,10.0735931 0,22.5 C0,34.9264069 10.0735931,45 22.5,45 Z",
        id: "Path",
        fill: "#0078FF"
      }), i.a.createElement("path", {
        d: "M22.5,18 C23.3284271,18 24,18.6715729 24,19.5 L24,32.5 C24,33.3284271 23.3284271,34 22.5,34 C21.6715729,34 21,33.3284271 21,32.5 L21,19.5 C21,18.6715729 21.6715729,18 22.5,18 Z M21.4323384,11.4386147 C22.0216679,10.8537951 22.9697357,10.8537951 23.5590652,11.4386147 C23.8428387,11.7207094 24.0017288,12.1055671 24,12.5065628 C24.002455,12.9094315 23.8398959,13.2956041 23.55042,13.5745109 C23.2682913,13.850193 22.8893216,14.0030584 22.4957018,13.9999536 C22.0998345,14.0022651 21.7193906,13.8459472 21.4386552,13.5656312 C21.1579198,13.2853152 21.0000702,12.9041436 21.0000769,12.5065628 C20.9960328,12.1068239 21.1517352,11.7221445 21.4323384,11.4386147 Z",
        id: "Combined-Shape",
        fill: "#FFFFFF"
      })))))))));
    },
        oo = function oo(e) {
      return function (e) {
        switch (e.type) {
          case "New User":
            return i.a.createElement(no, null);

          case "Logout":
            return i.a.createElement(eo, null);

          case "Sales Report":
            return i.a.createElement(to, null);

          case "Activation error":
            return i.a.createElement(ro, null);

          case "Activation alert":
            return i.a.createElement(ao, null);

          default:
            return i.a.createElement(no, null);
        }
      }(e);
    };

    oo.propTypes = {
      type: c.a.string.isRequired
    };
    var io,
        lo,
        co = oo,
        so = t(40),
        uo = t.n(so),
        po = t(41),
        fo = t.n(po);

    function mo(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var ho = d.a.div(io || (io = mo(["\n    width: 100%;\n    margin: 20px 0px;\n    label {\n        text-align: center;\n    }\n"]))),
        go = d.a.div(lo || (lo = mo(["\n    margin: -12px 17px 10px 17px;\n"]))),
        bo = function bo() {
      return i.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "21.613",
        height: "18.689",
        viewBox: "0 0 21.613 18.689"
      }, i.a.createElement("defs", null, i.a.createElement("style", null, ".tavTva{fill:#00c8ff;}")), i.a.createElement("path", {
        className: "tavTva",
        d: "M19044.139,17466.688a.5.5,0,0,1,0-.994h13.793a.5.5,0,0,1,0,.994Zm5.889-2.07a.609.609,0,0,1-.607-.607v-.5a.686.686,0,0,1,.014-.129h-8.055a1.436,1.436,0,0,1-1.377-1.488v-12.4a1.44,1.44,0,0,1,1.377-1.492h18.854a1.441,1.441,0,0,1,1.383,1.492v12.4a1.441,1.441,0,0,1-1.383,1.488h-7.639a.686.686,0,0,1,.014.129v.5a.61.61,0,0,1-.609.607Zm-9.1-15.127v12.4a.494.494,0,0,0,.465.5h18.844a.483.483,0,0,0,.453-.5v-12.4a.478.478,0,0,0-.459-.5h-18.848A.482.482,0,0,0,19040.924,17449.49Z",
        transform: "translate(-19040.002 -17447.998)"
      }));
    },
        yo = function yo() {
      return i.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "17",
        viewBox: "0 0 17 17"
      }, i.a.createElement("defs", null, i.a.createElement("style", null, ".tabPackageA,.tabPackageC{fill:none;}.tabPackageA{stroke:#00c8ff;}.tabPackageB{stroke:none;}")), i.a.createElement("g", {
        transform: "translate(-48 -122)"
      }, i.a.createElement("g", {
        className: "tabPackageA",
        transform: "translate(57 122)"
      }, i.a.createElement("rect", {
        className: "tabPackageB",
        width: "8",
        height: "8",
        rx: "2"
      }), i.a.createElement("rect", {
        className: "tabPackageC",
        x: "0.5",
        y: "0.5",
        width: "7",
        height: "7",
        rx: "1.5"
      })), i.a.createElement("g", {
        className: "tabPackageA",
        transform: "translate(57 131)"
      }, i.a.createElement("rect", {
        className: "tabPackageB",
        width: "8",
        height: "8",
        rx: "2"
      }), i.a.createElement("rect", {
        className: "tabPackageC",
        x: "0.5",
        y: "0.5",
        width: "7",
        height: "7",
        rx: "1.5"
      })), i.a.createElement("g", {
        className: "tabPackageA",
        transform: "translate(48 122)"
      }, i.a.createElement("rect", {
        className: "tabPackageB",
        width: "8",
        height: "8",
        rx: "2"
      }), i.a.createElement("rect", {
        className: "tabPackageC",
        x: "0.5",
        y: "0.5",
        width: "7",
        height: "7",
        rx: "1.5"
      })), i.a.createElement("g", {
        className: "tabPackageA",
        transform: "translate(48 131)"
      }, i.a.createElement("rect", {
        className: "tabPackageB",
        width: "8",
        height: "8",
        rx: "2"
      }), i.a.createElement("rect", {
        className: "tabPackageC",
        x: "0.5",
        y: "0.5",
        width: "7",
        height: "7",
        rx: "1.5"
      }))));
    },
        xo = function xo() {
      return i.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25.463",
        height: "18.828",
        viewBox: "0 0 25.463 18.828"
      }, i.a.createElement("defs", null, i.a.createElement("style", null, ".tabInternetA{fill:#00c8ff;}")), i.a.createElement("path", {
        className: "tabInternetA",
        d: "M19051.266,17465.8a1.667,1.667,0,1,1,1.547,1.023h-.01A1.67,1.67,0,0,1,19051.266,17465.8Zm-5.115-5.316a.791.791,0,0,1-.439-1.326,9.115,9.115,0,0,1,14.043,0,.8.8,0,0,1-.084,1.123.834.834,0,0,1-.521.189.762.762,0,0,1-.594-.277,7.54,7.54,0,0,0-11.643,0,.783.783,0,0,1-.619.3A.878.878,0,0,1,19046.15,17460.488Zm-5.492-5.207a.792.792,0,0,1-.451-1.316,16.135,16.135,0,0,1,25.053,0,.825.825,0,0,1,.2.6.8.8,0,0,1-.293.555.814.814,0,0,1-.514.158.824.824,0,0,1-.6-.279,14.548,14.548,0,0,0-22.637,0,.8.8,0,0,1-.621.295A.618.618,0,0,1,19040.658,17455.281Z",
        transform: "translate(-19040 -17448)"
      }));
    },
        vo = function vo() {
      return i.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "17",
        viewBox: "0 0 17 17"
      }, i.a.createElement("defs", null, i.a.createElement("style", null, ".package-disabled-a,.package-disabled-c{fill:none;}.package-disabled-a{stroke:#777;}.package-disabled-b{stroke:none;}")), i.a.createElement("g", {
        transform: "translate(-48 -122)"
      }, i.a.createElement("g", {
        className: "package-disabled-a",
        transform: "translate(57 122)"
      }, i.a.createElement("rect", {
        className: "package-disabled-b",
        width: "8",
        height: "8",
        rx: "2"
      }), i.a.createElement("rect", {
        className: "package-disabled-c",
        x: "0.5",
        y: "0.5",
        width: "7",
        height: "7",
        rx: "1.5"
      })), i.a.createElement("g", {
        className: "package-disabled-a",
        transform: "translate(57 131)"
      }, i.a.createElement("rect", {
        className: "package-disabled-b",
        width: "8",
        height: "8",
        rx: "2"
      }), i.a.createElement("rect", {
        className: "package-disabled-c",
        x: "0.5",
        y: "0.5",
        width: "7",
        height: "7",
        rx: "1.5"
      })), i.a.createElement("g", {
        className: "package-disabled-a",
        transform: "translate(48 122)"
      }, i.a.createElement("rect", {
        className: "package-disabled-b",
        width: "8",
        height: "8",
        rx: "2"
      }), i.a.createElement("rect", {
        className: "package-disabled-c",
        x: "0.5",
        y: "0.5",
        width: "7",
        height: "7",
        rx: "1.5"
      })), i.a.createElement("g", {
        className: "package-disabled-a",
        transform: "translate(48 131)"
      }, i.a.createElement("rect", {
        className: "package-disabled-b",
        width: "8",
        height: "8",
        rx: "2"
      }), i.a.createElement("rect", {
        className: "package-disabled-c",
        x: "0.5",
        y: "0.5",
        width: "7",
        height: "7",
        rx: "1.5"
      }))));
    },
        Co = function Co() {
      return i.a.createElement("svg", {
        width: "25.463",
        height: "18.828",
        viewBox: "0 0 24 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, i.a.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M13.6335 12.1602H20.9997C21.1728 12.1602 21.3131 12.0182 21.3131 11.8431V1.80283C21.3113 1.24553 20.8643 0.794675 20.3135 0.794678H4.88415C4.33382 0.794678 3.8877 1.24604 3.8877 1.80283V4.31687C3.8877 4.49196 4.02799 4.6339 4.20104 4.6339C4.3741 4.6339 4.51439 4.49196 4.51439 4.31687V1.80283C4.51439 1.59622 4.67994 1.42874 4.88415 1.42874H20.3135C20.4121 1.42789 20.5069 1.46693 20.5769 1.53718C20.647 1.60743 20.6864 1.70306 20.6864 1.80283V11.5261H10.1484C9.97536 11.5261 9.83507 11.668 9.83507 11.8431C9.83507 12.0182 9.97536 12.1602 10.1484 12.1602H11.5264C11.3786 12.2694 11.2827 12.445 11.2827 12.643V12.7555C11.2827 13.0869 11.5513 13.3555 11.8827 13.3555H13.2772C13.6086 13.3555 13.8772 13.0869 13.8772 12.7555V12.643C13.8772 12.445 13.7813 12.2694 13.6335 12.1602ZM18.1923 14.7946H7.00573C6.83267 14.7946 6.69238 14.6527 6.69238 14.4776C6.69238 14.3025 6.83267 14.1606 7.00573 14.1606H18.1923C18.3654 14.1606 18.5057 14.3025 18.5057 14.4776C18.5057 14.6527 18.3654 14.7946 18.1923 14.7946Z",
        fill: "#565656"
      }), i.a.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4.46939 14.7945H9.57803C9.77499 14.7945 9.96388 14.7153 10.1032 14.5744C10.2424 14.4335 10.3207 14.2424 10.3207 14.0431V4.83345C10.3189 4.41973 9.98696 4.08526 9.57803 4.08527H3.33924C2.93032 4.08526 2.59833 4.41973 2.59661 4.83345V6.28229H0.844999C0.512216 6.28229 0.241959 6.5543 0.240234 6.89099V14.1827C0.241959 14.5211 0.513619 14.7945 0.848132 14.7945H4.46732L4.46939 14.7945ZM4.44515 14.1604H3.57426C3.56873 14.1604 3.56324 14.1606 3.55779 14.1609H0.866699V6.90091H4.44515V14.1604ZM5.07208 14.1604H9.57803C9.64206 14.1604 9.69397 14.1079 9.69397 14.0431V4.83345C9.69398 4.80263 9.68167 4.77311 9.65983 4.75161C9.63799 4.73011 9.60849 4.71847 9.57803 4.71932H3.33924C3.27642 4.7193 3.225 4.76991 3.2233 4.83345V6.28229H4.46732C4.8001 6.28229 5.07036 6.5543 5.07208 6.89099V14.1604ZM7.03386 13.5199H5.88073C5.70767 13.5199 5.56738 13.3779 5.56738 13.2029C5.56738 13.0278 5.70767 12.8858 5.88073 12.8858H7.04013C7.21318 12.8858 7.35348 13.0278 7.35348 13.2029C7.35348 13.3779 7.21318 13.5199 7.04013 13.5199H7.03386ZM22.9894 14.7948H15.4252C14.9994 14.7948 14.6543 14.4456 14.6543 14.0149V12.3061C14.6543 11.8766 14.9975 11.5279 15.422 11.5262H22.9894C23.4151 11.5262 23.7603 11.8754 23.7603 12.3061V14.0149C23.7603 14.2217 23.679 14.4201 23.5345 14.5663C23.3899 14.7126 23.1939 14.7948 22.9894 14.7948ZM15.4252 12.1605C15.3468 12.1622 15.2842 12.227 15.2842 12.3063V14.0151C15.2842 14.0944 15.3468 14.1592 15.4252 14.1609H22.9895C23.0684 14.1592 23.132 14.0949 23.1336 14.0151V12.3063C23.132 12.2265 23.0684 12.1621 22.9895 12.1605H15.4252Z",
        fill: "#565656"
      }));
    },
        wo = function wo() {
      return i.a.createElement("svg", {
        width: "25.463",
        height: "18.828",
        viewBox: "0 0 24 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, i.a.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M13.6335 12.1602H20.9997C21.1728 12.1602 21.3131 12.0182 21.3131 11.8431V1.80283C21.3113 1.24553 20.8643 0.794675 20.3135 0.794678H4.88415C4.33382 0.794678 3.8877 1.24604 3.8877 1.80283V4.31687C3.8877 4.49196 4.02799 4.6339 4.20104 4.6339C4.3741 4.6339 4.51439 4.49196 4.51439 4.31687V1.80283C4.51439 1.59622 4.67994 1.42874 4.88415 1.42874H20.3135C20.4121 1.42789 20.5069 1.46693 20.5769 1.53718C20.647 1.60743 20.6864 1.70306 20.6864 1.80283V11.5261H10.1484C9.97536 11.5261 9.83507 11.668 9.83507 11.8431C9.83507 12.0182 9.97536 12.1602 10.1484 12.1602H11.5264C11.3786 12.2694 11.2827 12.445 11.2827 12.643V12.7555C11.2827 13.0869 11.5513 13.3555 11.8827 13.3555H13.2772C13.6086 13.3555 13.8772 13.0869 13.8772 12.7555V12.643C13.8772 12.445 13.7813 12.2694 13.6335 12.1602ZM18.1923 14.7946H7.00573C6.83267 14.7946 6.69238 14.6527 6.69238 14.4776C6.69238 14.3025 6.83267 14.1606 7.00573 14.1606H18.1923C18.3654 14.1606 18.5057 14.3025 18.5057 14.4776C18.5057 14.6527 18.3654 14.7946 18.1923 14.7946Z",
        fill: "#777"
      }), i.a.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4.46939 14.7945H9.57803C9.77499 14.7945 9.96388 14.7153 10.1032 14.5744C10.2424 14.4335 10.3207 14.2424 10.3207 14.0431V4.83345C10.3189 4.41973 9.98696 4.08526 9.57803 4.08527H3.33924C2.93032 4.08526 2.59833 4.41973 2.59661 4.83345V6.28229H0.844999C0.512216 6.28229 0.241959 6.5543 0.240234 6.89099V14.1827C0.241959 14.5211 0.513619 14.7945 0.848132 14.7945H4.46732L4.46939 14.7945ZM4.44515 14.1604H3.57426C3.56873 14.1604 3.56324 14.1606 3.55779 14.1609H0.866699V6.90091H4.44515V14.1604ZM5.07208 14.1604H9.57803C9.64206 14.1604 9.69397 14.1079 9.69397 14.0431V4.83345C9.69398 4.80263 9.68167 4.77311 9.65983 4.75161C9.63799 4.73011 9.60849 4.71847 9.57803 4.71932H3.33924C3.27642 4.7193 3.225 4.76991 3.2233 4.83345V6.28229H4.46732C4.8001 6.28229 5.07036 6.5543 5.07208 6.89099V14.1604ZM7.03386 13.5199H5.88073C5.70767 13.5199 5.56738 13.3779 5.56738 13.2029C5.56738 13.0278 5.70767 12.8858 5.88073 12.8858H7.04013C7.21318 12.8858 7.35348 13.0278 7.35348 13.2029C7.35348 13.3779 7.21318 13.5199 7.04013 13.5199H7.03386ZM22.9894 14.7948H15.4252C14.9994 14.7948 14.6543 14.4456 14.6543 14.0149V12.3061C14.6543 11.8766 14.9975 11.5279 15.422 11.5262H22.9894C23.4151 11.5262 23.7603 11.8754 23.7603 12.3061V14.0149C23.7603 14.2217 23.679 14.4201 23.5345 14.5663C23.3899 14.7126 23.1939 14.7948 22.9894 14.7948ZM15.4252 12.1605C15.3468 12.1622 15.2842 12.227 15.2842 12.3063V14.0151C15.2842 14.0944 15.3468 14.1592 15.4252 14.1609H22.9895C23.0684 14.1592 23.132 14.0949 23.1336 14.0151V12.3063C23.132 12.2265 23.0684 12.1621 22.9895 12.1605H15.4252Z",
        fill: "#777"
      }));
    },
        Eo = function Eo() {
      return i.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "21.613",
        height: "18.689",
        viewBox: "0 0 21.613 18.689"
      }, i.a.createElement("defs", null, i.a.createElement("style", null, ".tv-disabled{fill:#777;}")), i.a.createElement("path", {
        className: "tv-disabled",
        d: "M19044.139,17466.688a.5.5,0,0,1,0-.994h13.793a.5.5,0,0,1,0,.994Zm5.889-2.07a.609.609,0,0,1-.607-.607v-.5a.686.686,0,0,1,.014-.129h-8.055a1.436,1.436,0,0,1-1.377-1.488v-12.4a1.44,1.44,0,0,1,1.377-1.492h18.854a1.441,1.441,0,0,1,1.383,1.492v12.4a1.441,1.441,0,0,1-1.383,1.488h-7.639a.686.686,0,0,1,.014.129v.5a.61.61,0,0,1-.609.607Zm-9.1-15.127v12.4a.494.494,0,0,0,.465.5h18.844a.483.483,0,0,0,.453-.5v-12.4a.478.478,0,0,0-.459-.5h-18.848A.482.482,0,0,0,19040.924,17449.49Z",
        transform: "translate(-19040.002 -17447.998)"
      }));
    },
        Oo = function Oo() {
      return i.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25.463",
        height: "18.828",
        viewBox: "0 0 25.463 18.828"
      }, i.a.createElement("defs", null, i.a.createElement("style", null, ".tab-internet-disabled{fill:#777;}")), i.a.createElement("path", {
        className: "tab-internet-disabled",
        d: "M19051.266,17465.8a1.667,1.667,0,1,1,1.547,1.023h-.01A1.67,1.67,0,0,1,19051.266,17465.8Zm-5.115-5.316a.791.791,0,0,1-.439-1.326,9.115,9.115,0,0,1,14.043,0,.8.8,0,0,1-.084,1.123.834.834,0,0,1-.521.189.762.762,0,0,1-.594-.277,7.54,7.54,0,0,0-11.643,0,.783.783,0,0,1-.619.3A.878.878,0,0,1,19046.15,17460.488Zm-5.492-5.207a.792.792,0,0,1-.451-1.316,16.135,16.135,0,0,1,25.053,0,.825.825,0,0,1,.2.6.8.8,0,0,1-.293.555.814.814,0,0,1-.514.158.824.824,0,0,1-.6-.279,14.548,14.548,0,0,0-22.637,0,.8.8,0,0,1-.621.295A.618.618,0,0,1,19040.658,17455.281Z",
        transform: "translate(-19040 -17448)"
      }));
    };

    function jo() {
      return (jo = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function ko(e, n) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, n) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var t = [],
            r = !0,
            a = !1,
            o = void 0;

        try {
          for (var i, l = e[Symbol.iterator](); !(r = (i = l.next()).done) && (t.push(i.value), !n || t.length !== n); r = !0) {
            ;
          }
        } catch (e) {
          a = !0, o = e;
        } finally {
          try {
            r || null == l.return || l.return();
          } finally {
            if (a) throw o;
          }
        }

        return t;
      }(e, n) || function (e, n) {
        if (!e) return;
        if ("string" == typeof e) return Po(e, n);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === t && e.constructor && (t = e.constructor.name);
        if ("Map" === t || "Set" === t) return Array.from(e);
        if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Po(e, n);
      }(e, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Po(e, n) {
      (null == n || n > e.length) && (n = e.length);

      for (var t = 0, r = new Array(n); t < n; t++) {
        r[t] = e[t];
      }

      return r;
    }

    var So = function So(e, n, t) {
      switch (e.toUpperCase()) {
        case "PAQUETE":
        case "INTERNET + TV":
        case "DOBLE PACK":
          return n === t ? i.a.createElement(yo, null) : i.a.createElement(vo, null);

        case "TV":
          return n === t ? i.a.createElement(bo, null) : i.a.createElement(Eo, null);

        case "INTERNET":
          return n === t ? i.a.createElement(xo, null) : i.a.createElement(Oo, null);

        case "CONVERGENTE":
          return n === t ? i.a.createElement(Co, null) : i.a.createElement(wo, null);
      }
    },
        Fo = function Fo(e) {
      var n = e.variant,
          t = e.tabItems,
          r = e.tabContents,
          a = e.indicatorColor,
          l = e.textColor,
          c = e.ariaLabel,
          s = e.headerComponent,
          u = e.title,
          p = e.tabName,
          d = e.showIcon,
          f = e.onTabChange,
          m = e.showFilterOption,
          h = e.filterLabel,
          g = e.filterOptions,
          b = e.selectedFilterOption,
          y = e.onFilterOptionsChange,
          x = e.tabValue,
          v = void 0 === x ? 0 : x,
          C = e.disabledTabs,
          w = void 0 === C ? [] : C,
          E = ko(i.a.useState(v), 2),
          O = E[0],
          j = E[1];
      Object(o.useEffect)(function () {
        f(O);
      }, [O]);
      return i.a.createElement(i.a.Fragment, null, i.a.createElement(uo.a, {
        value: O,
        onChange: function onChange(e, n) {
          j(n), p(n);
        },
        indicatorColor: a,
        textColor: l,
        variant: n,
        "aria-label": c
      }, t.map(function (e, n) {
        return i.a.createElement(fo.a, jo({
          key: n,
          label: e,
          disabled: w.includes(n),
          icon: d ? So(e, n, O) : null
        }, function (e) {
          return {
            id: "full-width-tab-".concat(e),
            "aria-controls": "full-width-tabpanel-".concat(e)
          };
        }(n)));
      })), s && s(), u ? i.a.createElement(ho, null, i.a.createElement(me, {
        text: u,
        labelSize: "large"
      }), " ") : null, m && i.a.createElement(go, null, i.a.createElement($t, {
        label: h,
        options: g,
        onChange: y,
        value: b
      })), r[O]);
    };

    Fo.propTypes = {
      tabItems: c.a.array,
      tabContents: c.a.array,
      variant: c.a.string,
      ariaLabel: c.a.string,
      indicatorColor: c.a.string,
      textColor: c.a.string,
      showIcon: c.a.bool,
      onTabChange: c.a.func,
      tabName: c.a.func,
      showFilterOption: c.a.bool,
      filterLabel: c.a.string,
      filterOptions: c.a.array,
      selectedFilterOption: c.a.string,
      onFilterOptionsChange: c.a.func,
      tabValue: c.a.number,
      disabledTabs: c.a.array
    }, Fo.defaultProps = {
      tabItems: [],
      tabContents: [],
      variant: "fullWidth",
      ariaLabel: "fullwidth-tab",
      indicatorColor: "primary",
      textColor: "primary",
      showIcon: !1,
      onTabChange: function onTabChange() {},
      tabName: function tabName() {},
      showFilterOption: !1,
      filterLabel: "",
      filterOptions: [],
      selectedFilterOption: "",
      onFilterOptionsChange: function onFilterOptionsChange() {},
      tabValue: 0,
      disabledTabs: []
    };

    var Io = Fo,
        Lo = function Lo() {
      return i.a.createElement("svg", {
        width: "15px",
        height: "13px",
        viewBox: "0 0 15 13",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, i.a.createElement("g", {
        id: "Assisted---SV---1.2",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, i.a.createElement("g", {
        id: "2.2-Bundles---Paquete",
        transform: "translate(-29.000000, -166.000000)",
        fill: "#FFFFFF"
      }, i.a.createElement("g", {
        id: "Group-2-Copy-2",
        transform: "translate(18.000000, 163.000000)"
      }, i.a.createElement("g", {
        id: "Group",
        transform: "translate(11.000000, 2.000000)"
      }, i.a.createElement("g", {
        id: "Genericos/Navegacion/favoritos,-favorites,-estrella,-star/Dark-Mode"
      }, i.a.createElement("g", {
        transform: "translate(0.681818, 1.000000)",
        id: "Shape"
      }, i.a.createElement("path", {
        d: "M6.81818182,1.09991744 C7.07586256,1.09785901 7.31135138,1.24225667 7.42159091,1.47 L8.74090909,4.07666667 C8.8403572,4.27022923 9.0297854,4.4044817 9.24886364,4.43666667 L12.1909091,4.85666667 C12.4412598,4.89770746 12.6475655,5.07133889 12.726333,5.30729136 C12.8051005,5.54324383 12.7432871,5.80244703 12.5659091,5.98 L10.4352273,8 C10.2691458,8.15155358 10.1911705,8.37403182 10.2272727,8.59333333 L10.7284091,11.46 C10.7666267,11.7060792 10.6614639,11.9524817 10.4556875,12.0990028 C10.249911,12.2455239 9.97779456,12.2677594 9.75,12.1566667 L7.11818182,10.8033333 C6.92150412,10.7037057 6.68758679,10.7037057 6.49090909,10.8033333 L3.85909091,12.1566667 C3.63129635,12.2677594 3.35917988,12.2455239 3.15340343,12.0990028 C2.94762698,11.9524817 2.84246422,11.7060792 2.88068182,11.46 L3.40909091,8.59333333 C3.44519314,8.37403182 3.36721781,8.15155358 3.20113636,8 L1.07045455,5.97 C0.893076513,5.79244703 0.831263151,5.53324383 0.910030668,5.29729136 C0.988798184,5.06133889 1.19510382,4.88770746 1.44545455,4.84666667 L4.3875,4.42666667 C4.60657823,4.3944817 4.79600644,4.26022923 4.89545455,4.06666667 L6.21477273,1.46 C6.32795222,1.236151 6.56282922,1.09602099 6.81818182,1.09991744 L6.81818182,1.09991744 Z M6.81818182,0.293317016 C6.24719215,0.290695289 5.7251318,0.608112694 5.475,1.11 L4.19318182,3.66666667 L1.32613636,4.07333333 C0.76079169,4.15259839 0.290873531,4.53956666 0.114837527,5.07081386 C-0.0611984765,5.60206106 0.0873419485,6.18495701 0.497727273,6.57333333 L2.57045455,8.55 L2.07954545,11.3333333 C2.00596273,11.7598628 2.1309758,12.1962418 2.42045455,12.5233333 C2.8712004,13.0543908 3.64120997,13.2033005 4.26477273,12.88 L6.82840909,11.5466667 L9.39204545,12.88 C10.0156082,13.2033005 10.7856178,13.0543908 11.2363636,12.5233333 C11.5258424,12.1962418 11.6508555,11.7598628 11.5772727,11.3333333 L11.0659091,8.53333333 L13.1386364,6.55666667 C13.5490217,6.16829034 13.6975621,5.5853944 13.5215261,5.0541472 C13.3454901,4.5229 12.8755719,4.13593173 12.3102273,4.05666667 L9.44318182,3.66666667 L8.16136364,1.12666667 C7.91612185,0.618288068 7.3930499,0.293765145 6.81818182,0.293317016 Z",
        fillRule: "nonzero"
      }))))))));
    },
        Mo = function Mo() {
      return i.a.createElement("svg", {
        width: "14px",
        height: "14px",
        viewBox: "0 0 14 14",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, i.a.createElement("g", {
        id: "Assisted---SV---1.2",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, i.a.createElement("g", {
        id: "2.2-Bundles---Paquete",
        transform: "translate(-30.000000, -325.000000)"
      }, i.a.createElement("g", {
        id: "Genericos/Files/descuento,-discount/Dark-Mode",
        transform: "translate(27.000000, 322.000000)"
      }, i.a.createElement("g", {
        id: "Genericos/Files/descuento,-discountDark-Mode"
      }, i.a.createElement("g", null, i.a.createElement("g", {
        id: "Genericos/descuento,-discount"
      }, i.a.createElement("g", {
        id: "B2C/descuento,-discount"
      }, i.a.createElement("g", {
        id: "Primary",
        transform: "translate(3.600000, 3.600000)",
        fillRule: "nonzero"
      }, i.a.createElement("path", {
        d: "M6.4,12.8 C6.018,12.8 5.716,12.508 5.448,12.25 C5.3081529,12.0852082 5.13412877,11.9528133 4.938,11.862 C4.71348515,11.8402863 4.48693269,11.8675818 4.274,11.942 C3.904,12.034 3.52,12.128 3.2,11.942 C2.88,11.756 2.762,11.354 2.662,11.002 C2.61889381,10.7848523 2.52953531,10.5795324 2.4,10.4 C2.22054489,10.2728548 2.01596779,10.1855686 1.8,10.144 C1.448,10.044 1.048,9.93 0.86,9.606 C0.672,9.282 0.77,8.902 0.86,8.532 C0.935437309,8.31930508 0.962760099,8.09252593 0.94,7.868 C0.849186652,7.67187123 0.716791824,7.4978471 0.552,7.358 C0.296,7.084 0,6.782 0,6.4 C0,6.018 0.292,5.716 0.55,5.448 C0.714791824,5.3081529 0.847186652,5.13412877 0.938,4.938 C0.960760099,4.71347407 0.933437309,4.48669492 0.858,4.274 C0.766,3.904 0.672,3.52 0.858,3.2 C1.044,2.88 1.446,2.762 1.798,2.662 C2.01514772,2.61889381 2.22046762,2.52953531 2.4,2.4 C2.52714519,2.22054489 2.61443142,2.01596779 2.656,1.8 C2.756,1.448 2.87,1.048 3.194,0.86 C3.518,0.672 3.896,0.77 4.268,0.86 C4.48093269,0.934418191 4.70748515,0.961713669 4.932,0.94 C5.12812877,0.849186652 5.3021529,0.716791824 5.442,0.552 C5.716,0.296 6.018,0 6.4,0 C6.782,0 7.084,0.292 7.352,0.55 C7.4918471,0.714791824 7.66587123,0.847186652 7.862,0.938 C8.08651485,0.959713669 8.31306731,0.932418191 8.526,0.858 C8.896,0.766 9.28,0.672 9.6,0.858 C9.92,1.044 10.038,1.446 10.138,1.798 C10.1811062,2.01514772 10.2704647,2.22046762 10.4,2.4 C10.5794551,2.52714519 10.7840322,2.61443142 11,2.656 C11.352,2.756 11.752,2.87 11.94,3.194 C12.128,3.518 12.03,3.898 11.94,4.268 C11.8645627,4.48069492 11.8372399,4.70747407 11.86,4.932 C11.9508133,5.12812877 12.0832082,5.3021529 12.248,5.442 C12.504,5.716 12.8,6.018 12.8,6.4 C12.8,6.782 12.508,7.084 12.25,7.352 C12.0852082,7.4918471 11.9528133,7.66587123 11.862,7.862 C11.8392399,8.08652593 11.8665627,8.31330508 11.942,8.526 C12.034,8.896 12.128,9.28 11.942,9.6 C11.756,9.92 11.354,10.038 11.002,10.138 C10.7848523,10.1811062 10.5795324,10.2704647 10.4,10.4 C10.2728548,10.5794551 10.1855686,10.7840322 10.144,11 C10.044,11.352 9.93,11.752 9.606,11.94 C9.282,12.128 8.904,12.03 8.532,11.94 C8.31906731,11.8655818 8.09251485,11.8382863 7.868,11.86 C7.67187123,11.9508133 7.4978471,12.0832082 7.358,12.248 C7.084,12.504 6.782,12.8 6.4,12.8 Z M4.8,11.362 C4.88570029,11.3615374 4.97109243,11.3722954 5.054,11.394 C5.33382654,11.5004848 5.58267153,11.6750888 5.778,11.902 C5.978,12.102 6.206,12.316 6.392,12.316 C6.578,12.316 6.792,12.116 7.006,11.902 C7.20427106,11.6761876 7.4559217,11.5036075 7.738,11.4 C8.04181448,11.3509733 8.35303568,11.3777672 8.644,11.478 C8.92,11.546 9.206,11.618 9.356,11.532 C9.506,11.446 9.594,11.154 9.672,10.876 C9.72978589,10.5775413 9.86030878,10.2979476 10.052,10.062 C10.2879476,9.87030878 10.5675413,9.73978589 10.866,9.682 C11.144,9.604 11.432,9.522 11.522,9.366 C11.612,9.21 11.536,8.93 11.468,8.654 C11.3694484,8.35908523 11.3460751,8.04423399 11.4,7.738 C11.5064848,7.45817346 11.6810888,7.20932847 11.908,7.014 C12.108,6.814 12.322,6.586 12.322,6.4 C12.322,6.214 12.122,6 11.908,5.786 C11.6810888,5.59067153 11.5064848,5.34182654 11.4,5.062 C11.3509733,4.75818552 11.3777672,4.44696432 11.478,4.156 C11.546,3.88 11.618,3.592 11.532,3.444 C11.446,3.296 11.144,3.2 10.866,3.128 C10.5675413,3.07021411 10.2879476,2.93969122 10.052,2.748 C9.86030878,2.51205242 9.72978589,2.23245866 9.672,1.934 C9.594,1.656 9.512,1.368 9.356,1.278 C9.2,1.188 8.92,1.264 8.644,1.332 C8.35303568,1.43223282 8.04181448,1.4590267 7.738,1.41 C7.45817346,1.30351516 7.20932847,1.12891121 7.014,0.902 C6.814,0.702 6.586,0.488 6.4,0.488 C6.214,0.488 6,0.688 5.786,0.902 C5.59067153,1.12891121 5.34182654,1.30351516 5.062,1.41 C4.75822389,1.46003948 4.44675341,1.43322414 4.156,1.332 C3.88,1.264 3.592,1.192 3.444,1.278 C3.296,1.364 3.2,1.656 3.128,1.934 C3.07021411,2.23245866 2.93969122,2.51205242 2.748,2.748 C2.51205242,2.93969122 2.23245866,3.07021411 1.934,3.128 C1.656,3.206 1.368,3.288 1.278,3.444 C1.188,3.6 1.264,3.88 1.332,4.156 C1.43223282,4.44696432 1.4590267,4.75818552 1.41,5.062 C1.30351516,5.34182654 1.12891121,5.59067153 0.902,5.786 C0.702,5.986 0.488,6.214 0.488,6.4 C0.488,6.586 0.688,6.8 0.902,7.014 C1.12891121,7.20932847 1.30351516,7.45817346 1.41,7.738 C1.4590267,8.04181448 1.43223282,8.35303568 1.332,8.644 C1.264,8.92 1.192,9.208 1.278,9.356 C1.364,9.504 1.656,9.594 1.934,9.672 C2.23245866,9.72978589 2.51205242,9.86030878 2.748,10.052 C2.93969122,10.2879476 3.07021411,10.5675413 3.128,10.866 C3.206,11.144 3.288,11.432 3.444,11.522 C3.6,11.612 3.88,11.536 4.156,11.468 C4.3655631,11.4060027 4.58173952,11.3690781 4.8,11.358 L4.8,11.362 Z",
        id: "Shape",
        fill: "#00C8FF"
      }), i.a.createElement("path", {
        d: "M3.944,4.8 C3.93165517,4.49847824 4.03791244,4.2041169 4.24,3.98 C4.42731943,3.77273486 4.69363034,3.65446132 4.973,3.65446132 C5.25236966,3.65446132 5.51868057,3.77273486 5.706,3.98 C5.90563238,4.2094175 6.0107133,4.50607451 6,4.81 L6,5.084 C6.00736752,5.37764549 5.90382283,5.66328601 5.71,5.884 C5.52861946,6.09650053 5.26131512,6.2162 4.982,6.21 C4.70075297,6.21573118 4.43108867,6.09807277 4.244,5.888 C4.04045832,5.65984852 3.93359687,5.36149709 3.946,5.056 L3.944,4.8 Z M4.144,5.092 C4.13766454,5.33199628 4.21788273,5.56626177 4.37,5.752 C4.51815859,5.92860826 4.73964374,6.02680001 4.97,6.018 C5.19519216,6.02523459 5.41123126,5.92864373 5.556,5.756 C5.72120897,5.5640787 5.80829438,5.31709877 5.8,5.064 L5.8,4.8 C5.80926612,4.55591617 5.72887637,4.31688115 5.574,4.128 C5.42542529,3.95238215 5.20379998,3.85560577 4.974,3.866 C4.74459512,3.85771095 4.52385025,3.95410288 4.374,4.128 C4.21377591,4.3242851 4.13184911,4.57291512 4.144,4.826 L4.144,5.092 Z M5.1,8.752 L4.93,8.634 L7.628,4.324 L7.798,4.44 L5.1,8.752 Z M6.8,7.888 C6.79293311,7.59368755 6.89803429,7.30769796 7.094,7.088 C7.28322218,6.88409818 7.54882562,6.76822864 7.827,6.76822864 C8.10517438,6.76822864 8.37077782,6.88409818 8.56,7.088 C8.76155956,7.31945739 8.86677165,7.61934765 8.854,7.926 L8.854,8.194 C8.8614712,8.48837925 8.75631707,8.77451294 8.56,8.994 C8.37799816,9.20428628 8.11206531,9.32296705 7.834,9.318 C7.55456168,9.3246478 7.28626586,9.20841065 7.1,9 C6.89437746,8.77137402 6.7866599,8.47120109 6.8,8.164 L6.8,7.888 Z M7,8.184 C6.99040817,8.42691349 7.07089339,8.66480784 7.226,8.852 C7.37567198,9.0261386 7.59653918,9.12258394 7.826,9.114 C8.05654636,9.12611446 8.27917371,9.02815842 8.426,8.85 C8.58009602,8.65624909 8.65894269,8.4133161 8.648,8.166 L8.648,7.888 C8.66161388,7.6421608 8.58238037,7.40017737 8.426,7.21 C8.26969633,7.04564274 8.05281302,6.95259968 7.826,6.95259968 C7.59918698,6.95259968 7.38230367,7.04564274 7.226,7.21 C7.07018451,7.40515255 6.99121391,7.65060173 7.004,7.9 L7,8.184 Z",
        id: "Shape",
        fill: "#FFFFFF"
      }), i.a.createElement("path", {
        d: "M3.944,4.8 C3.93165517,4.49847824 4.03791244,4.2041169 4.24,3.98 C4.42731943,3.77273486 4.69363034,3.65446132 4.973,3.65446132 C5.25236966,3.65446132 5.51868057,3.77273486 5.706,3.98 C5.90563238,4.2094175 6.0107133,4.50607451 6,4.81 L6,5.084 C6.00736752,5.37764549 5.90382283,5.66328601 5.71,5.884 C5.52861946,6.09650053 5.26131512,6.2162 4.982,6.21 C4.70075297,6.21573118 4.43108867,6.09807277 4.244,5.888 C4.04045832,5.65984852 3.93359687,5.36149709 3.946,5.056 L3.944,4.8 Z M4.144,5.092 C4.13766454,5.33199628 4.21788273,5.56626177 4.37,5.752 C4.51815859,5.92860826 4.73964374,6.02680001 4.97,6.018 C5.19519216,6.02523459 5.41123126,5.92864373 5.556,5.756 C5.72120897,5.5640787 5.80829438,5.31709877 5.8,5.064 L5.8,4.8 C5.80926612,4.55591617 5.72887637,4.31688115 5.574,4.128 C5.42542529,3.95238215 5.20379998,3.85560577 4.974,3.866 C4.74459512,3.85771095 4.52385025,3.95410288 4.374,4.128 C4.21377591,4.3242851 4.13184911,4.57291512 4.144,4.826 L4.144,5.092 Z M5.1,8.752 L4.93,8.634 L7.628,4.324 L7.798,4.44 L5.1,8.752 Z M6.8,7.888 C6.79293311,7.59368755 6.89803429,7.30769796 7.094,7.088 C7.28322218,6.88409818 7.54882562,6.76822864 7.827,6.76822864 C8.10517438,6.76822864 8.37077782,6.88409818 8.56,7.088 C8.76155956,7.31945739 8.86677165,7.61934765 8.854,7.926 L8.854,8.194 C8.8614712,8.48837925 8.75631707,8.77451294 8.56,8.994 C8.37799816,9.20428628 8.11206531,9.32296705 7.834,9.318 C7.55456168,9.3246478 7.28626586,9.20841065 7.1,9 C6.89437746,8.77137402 6.7866599,8.47120109 6.8,8.164 L6.8,7.888 Z M7,8.184 C6.99040817,8.42691349 7.07089339,8.66480784 7.226,8.852 C7.37567198,9.0261386 7.59653918,9.12258394 7.826,9.114 C8.05654636,9.12611446 8.27917371,9.02815842 8.426,8.85 C8.58009602,8.65624909 8.65894269,8.4133161 8.648,8.166 L8.648,7.888 C8.66161388,7.6421608 8.58238037,7.40017737 8.426,7.21 C8.26969633,7.04564274 8.05281302,6.95259968 7.826,6.95259968 C7.59918698,6.95259968 7.38230367,7.04564274 7.226,7.21 C7.07018451,7.40515255 6.99121391,7.65060173 7.004,7.9 L7,8.184 Z",
        id: "Shape",
        fill: "#FFFFFF"
      }), i.a.createElement("path", {
        d: "M7.836,9.5 C7.50459619,9.50558846 7.18711366,9.36691793 6.966,9.12 C6.73250023,8.8575235 6.60927635,8.51507572 6.622,8.164 L6.622,7.888 C6.61171647,7.54524268 6.73342436,7.21161986 6.962,6.956 C7.18447233,6.71170918 7.49958822,6.57247581 7.83,6.57247581 C8.16041178,6.57247581 8.47552767,6.71170918 8.698,6.956 C8.92976397,7.22084251 9.05141358,7.56432377 9.038,7.916 L9.038,8.184 C9.04828353,8.52675732 8.92657564,8.86038014 8.698,9.116 C8.48091388,9.36425895 8.16575327,9.50465532 7.836,9.5 Z M7.836,7.14 C7.66063064,7.13231371 7.4915603,7.20614355 7.378,7.34 C7.25159471,7.49985515 7.18825652,7.7005447 7.2,7.904 L7.2,8.184 C7.18982331,8.38363269 7.254751,8.57984272 7.382,8.734 C7.49662064,8.86874682 7.6673082,8.94263754 7.844,8.934 C8.01776422,8.9422811 8.18526528,8.86816558 8.296,8.734 C8.42169215,8.57222447 8.48488479,8.37057605 8.474,8.166 L8.474,7.888 C8.48789559,7.68644921 8.42501979,7.48710436 8.298,7.33 C8.17894663,7.19767561 8.00556498,7.12758516 7.828,7.14 L7.836,7.14 Z M5.116,8.92401238 C5.07946414,8.92443819 5.043738,8.91322999 5.014,8.892 L4.844,8.776 C4.76460616,8.72047742 4.7418667,8.6129023 4.792,8.53 L7.474,4.226 C7.50001594,4.18451207 7.541975,4.15557479 7.59,4.146 C7.63853247,4.13587559 7.6890948,4.14598806 7.73,4.174 L7.9,4.29 C7.97939384,4.34552258 8.0021333,4.4530977 7.952,4.536 L5.262,8.84 C5.23621041,8.88208057 5.19427335,8.91172573 5.146,8.922 L5.116,8.92401238 Z M4.98,6.4 C4.64790257,6.40617295 4.32957307,6.26745138 4.108,6.02 C3.87304718,5.75826595 3.74898445,5.41547992 3.762,5.064 L3.762,4.8 C3.75277101,4.45645338 3.8751071,4.12235424 4.104,3.866 C4.32585957,3.61990314 4.6416613,3.47941496 4.973,3.47941496 C5.3043387,3.47941496 5.62014043,3.61990314 5.842,3.866 C6.06956968,4.12909435 6.18955263,4.46833186 6.178,4.816 L6.178,5.09 C6.18718293,5.4297028 6.06791315,5.76037289 5.844,6.016 C5.62746769,6.26616061 5.3107852,6.40690839 4.98,6.4 Z M4.98,4.044 C4.80676165,4.03847682 4.64042208,4.1120784 4.528,4.244 C4.3952228,4.40625923 4.32877214,4.61275644 4.342,4.822 L4.342,5.088 C4.33383241,5.28491741 4.39864134,5.47791982 4.524,5.63 C4.63886762,5.76557608 4.81056379,5.83958305 4.988,5.83 C5.16038233,5.8370065 5.32612661,5.76301352 5.436,5.63 C5.56376004,5.46999412 5.6278679,5.26841052 5.616,5.064 L5.616,4.8 C5.62583002,4.59919422 5.56099998,4.40185441 5.434,4.246 C5.32155389,4.10772899 5.15000626,4.03123805 4.972,4.04 L4.98,4.044 Z",
        id: "Shape",
        fill: "#FFFFFF"
      })), i.a.createElement("g", {
        id: "Marco"
      }, i.a.createElement("rect", {
        id: "Rectangle",
        x: "0",
        y: "0",
        width: "20",
        height: "20"
      }))))))))));
    },
        No = t(19),
        Bo = t.n(No),
        To = t(9),
        Ao = t.n(To),
        zo = t(11),
        Ro = t.n(zo),
        Do = t(42),
        Zo = t.n(Do),
        qo = t(18),
        Uo = t.n(qo);

    function Ho(e, n) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, n) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var t = [],
            r = !0,
            a = !1,
            o = void 0;

        try {
          for (var i, l = e[Symbol.iterator](); !(r = (i = l.next()).done) && (t.push(i.value), !n || t.length !== n); r = !0) {
            ;
          }
        } catch (e) {
          a = !0, o = e;
        } finally {
          try {
            r || null == l.return || l.return();
          } finally {
            if (a) throw o;
          }
        }

        return t;
      }(e, n) || function (e, n) {
        if (!e) return;
        if ("string" == typeof e) return Vo(e, n);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === t && e.constructor && (t = e.constructor.name);
        if ("Map" === t || "Set" === t) return Array.from(e);
        if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Vo(e, n);
      }(e, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Vo(e, n) {
      (null == n || n > e.length) && (n = e.length);

      for (var t = 0, r = new Array(n); t < n; t++) {
        r[t] = e[t];
      }

      return r;
    }

    var Wo = Object(g.makeStyles)(function (e) {
      return {
        selected: {
          background: "rgba(0,0,0,0.10)",
          color: "#00377B"
        }
      };
    });
    Bo.a.defaultProps = {
      component: "div",
      value: "",
      name: "list",
      listitems: [],
      timeout: "auto"
    };

    var _o,
        Go,
        Yo,
        Qo,
        $o,
        Xo,
        Ko,
        Jo,
        ei,
        ni = function ni(e) {
      var n = e.name,
          t = e.component,
          r = e.value,
          a = e.listitems,
          o = e.onClick,
          l = e.timeout,
          c = Ho(i.a.useState(!1), 2),
          s = c[0],
          u = c[1],
          p = Wo(),
          d = function d() {
        u(!s);
      };

      return i.a.createElement(Bo.a, {
        component: t,
        "aria-labelledby": "list-".concat(n)
      }, i.a.createElement(Ao.a, {
        onClick: d
      }, i.a.createElement(Ro.a, {
        primary: r
      }), s ? i.a.createElement(Uo.a, null) : i.a.createElement(yr.a, null)), i.a.createElement(Zo.a, {
        in: s,
        timeout: l,
        unmountOnExit: !0
      }, i.a.createElement(Bo.a, {
        component: "div",
        disablePadding: !0
      }, a.map(function (e, n) {
        return i.a.createElement(Ao.a, {
          key: "list-".concat(n),
          onClick: function onClick() {
            r !== e && o(e), d();
          },
          className: r === e ? p.selected : ""
        }, "string" == typeof e ? i.a.createElement(Ro.a, {
          primary: e
        }) : i.a.createElement(i.a.Fragment, null, i.a.createElement(Ro.a, {
          primary: e.name
        }), " ", i.a.createElement(Ro.a, {
          primary: e.value
        })));
      }))));
    };

    function ti(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var ri = d.a.div(_o || (_o = ti(["\n    min-height: ", ";\n    display: flex;\n    border-bottom: 1px solid #eee;\n    flex-direction: column;\n    margin: 20px 20px 0px 20px;\n        label {\n            text-align: left;\n            display: block\n        }\n\n        button {\n            margin: 0px;\n            min-width: 93px;\n            padding: 0;\n            padding-left: 10px;\n            padding-right: 10px;\n            box-shadow: none;\n            min-height: 36px;\n            font-size: 14px;\n            max-height: 36px;\n            max-width: 93px;\n        }\n        .MuiListItem-gutters { \n            padding-left: 0px;\n            padding-right: 50%;\n            color: #4cc5f2\n        }\n        .MuiListItemText-root {\n            flex: none;\n            .MuiTypography-body1 {\n                font-size: 14px;\n                font-weight: bold;\n                letter-spacing: 0;\n                line-height: 1;\n            }\n        }\n\n        .MuiCollapse-container {\n            pointer-events: none;\n            .MuiListItem-gutters { \n                padding-right: 8px;\n                color: #565656;\n                font-size: 14px;\n            }\n\n            .MuiListItem-root {\n                justify-content: space-between;\n                padding-top: 4px;\n                padding-bottom: 4px;\n            }\n            .MuiListItemText-root {\n                flex: none\n                .MuiTypography-body1 {\n                    font-size: 12px;\n                    font-weight: normal;\n                }\n            }\n\n        }\n"])), function (e) {
      return "small" === e.type ? "80px" : "130px";
    }),
        ai = d.a.div(Go || (Go = ti(["\n    width: 100%; \n    margin-bottom: 10px;\n"]))),
        oi = d.a.div(Yo || (Yo = ti(["\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n"]))),
        ii = d.a.div(Qo || (Qo = ti(["\n    flex: 2;\n"]))),
        li = d.a.div($o || ($o = ti(["\n    flex: 1;\n    display: flex;\n    justify-content: flex-end\n"]))),
        ci = d.a.div(Xo || (Xo = ti(["\n    width: 100%;\n"]))),
        si = d.a.div(Ko || (Ko = ti(["\n    width: 120px;\n    height: 20px;\n    font-size: 12px;\n    color: white;\n    background: #FFAA32;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 11px;\n    margin-bottom: 5px;\n"]))),
        ui = d.a.div(Jo || (Jo = ti(["\n    width: 138px;\n    height: 20px;\n    font-size: 12px;\n    color: white;\n    background: #0D2974;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 11px;\n    margin-bottom: 5px;\n"]))),
        pi = d.a.div(ei || (ei = ti(["\n    height: 150px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: 00377B\n    \n"]))),
        di = function di(e) {
      var n = e.packages,
          t = e.onItemClick,
          r = e.isPromotion,
          a = e.isDiscount,
          o = e.showEmptypackageInfo,
          l = e.type,
          c = e.showDescription,
          s = e.toFixed,
          u = e.onDetailsClick;
      return function (e) {
        return e.length ? e.map(function (e, n) {
          var o = e.priceList[0].taxIncludedAmount ? e.priceList[0].taxIncludedAmount : e.priceList[0].value;
          return i.a.createElement(ri, {
            onClick: function onClick() {
              return t(e);
            },
            key: "package-".concat(n),
            type: l
          }, r(e) && i.a.createElement(si, null, i.a.createElement(Lo, null), " ¡PROMOCIÓN!"), a(e) && i.a.createElement(ui, null, i.a.createElement(Mo, null), " ¡EN DESCUENTO!"), i.a.createElement(ai, null, i.a.createElement(me, {
            text: e.name,
            fontColor: "#00377B"
          })), i.a.createElement(oi, null, i.a.createElement(ii, null, i.a.createElement(me, {
            text: e.description,
            fontColor: "".concat(c ? "#565656" : "#00377B"),
            style: {
              fontSize: "".concat(c ? "16px" : "18px")
            }
          })), i.a.createElement(li, null, i.a.createElement(R, {
            text: "$".concat(s > 0 ? o.toFixed(s) : o),
            variant: "rounded"
          }))), i.a.createElement(ci, {
            onClick: function onClick(e) {
              u && u(e), e && e.stopPropagation();
            }
          }, i.a.createElement(ni, {
            value: "VER DETALLES",
            listitems: e.resourceList && e.resourceList.length ? e.resourceList.map(function (e) {
              return {
                name: e.name,
                value: "data" === e.type ? "".concat(e.value, " ").concat(e.unit) : e.value
              };
            }) : [],
            onClick: function onClick(e) {
              e && e.stopPropagation();
            }
          })));
        }) : o ? i.a.createElement(pi, null, "No hay paquetes para mostrar") : null;
      }(n);
    };

    di.defaultProps = {
      packages: [],
      type: "normal",
      showDescription: !0,
      toFixed: 2
    };
    var fi,
        mi = di,
        hi = t(43),
        gi = t.n(hi);
    var bi = d.a.div(fi || (fi = function (e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }(['\ndisplay: flex;\nwidth: 100%;\noverflow: hidden;\nflex:1;\nflex-direction: column;\ntext-align: left;\nheight: 100%;\n\n  .signCanvas {\n    z-index: 5;\n    position: absolute;\n  }\n  .backDeactivate {\n    height: 70%;\n    background-color: #5a6a8d;\n    position: relative;\n    border: 25px solid #96a0b6;\n    display: flex;\n    justify-content: center;\n  }\n  .actionItems {\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    flex:1;\n  }\n  .footer {\n    border-top: 2px solid #96a0b6;\n    position: absolute;\n    bottom: 0px;\n    width: calc(100% - 80px);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 15%;\n      span {\n        color: white;\n        font-size: 12px;\n      }\n  }\n  .placeholder {\n    height: 80%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction:column;\n    margin: auto;\n      span {\n        color: #96a0b6;\n        font-size: 14px;\n        line-height: 20px;\n        margin: 15px;\n      }\n  }\n  .placeholder-items {\n    display: flex;\n    justify-content: space-around;\n    width: 50%;\n    margin: auto;\n    span {\n      color: #96a0b6;\n      font-size: 11px;\n      line-height: 14px;\n    }\n  }\n  .icon2 {\n    display: flex;\n  }\n  .ovalIcon{\n    color: #8792ab;\n    text-align: center;\n    display: flex;\n    width: 100px;\n    flex-direction: column;\n  }\n  .icon {\n    display: flex;\n    width: 100px;\n    flex-direction: column;\n    text-align: center;\n  }\n  .leftImg {\n    transform: rotate(-90deg);\n  }\n  .rightImg {\n    transform: "scale(1,-1)"\n  }\n  .transparentButton {\n    button {\n      box-shadow: none;\n    }\n  }\n'])));

    function yi(e) {
      return (yi = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function xi(e, n) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function vi(e, n) {
      return (vi = Object.setPrototypeOf || function (e, n) {
        return e.__proto__ = n, e;
      })(e, n);
    }

    function Ci(e) {
      var n = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var t,
            r = Oi(e);

        if (n) {
          var a = Oi(this).constructor;
          t = Reflect.construct(r, arguments, a);
        } else t = r.apply(this, arguments);

        return wi(this, t);
      };
    }

    function wi(e, n) {
      return !n || "object" !== yi(n) && "function" != typeof n ? Ei(e) : n;
    }

    function Ei(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function Oi(e) {
      return (Oi = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ji(e, n, t) {
      return n in e ? Object.defineProperty(e, n, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = t, e;
    }

    var ki,
        Pi,
        Si,
        Fi,
        Ii,
        Li,
        Mi = function (e) {
      !function (e, n) {
        if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(n && n.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), n && vi(e, n);
      }(o, e);
      var n,
          t,
          r,
          a = Ci(o);

      function o() {
        var e;
        return function (e, n) {
          if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, o), ji(Ei(e = a.call(this)), "onOrientation", function () {
          e.setState({
            start: !1
          }, function () {
            e.setState({
              start: !0
            }, function () {
              e.myInput.current && setTimeout(function () {
                this.setState({
                  width: this.myInput.current.clientWidth,
                  height: this.myInput.current.clientHeight - 18
                });
              }.bind(Ei(e)), 700);
            });
          });
        }), ji(Ei(e), "componentDidMount", function () {
          window.addEventListener("orientationchange", e.onOrientation), e.myInput.current && e.setState({
            width: e.myInput.current.clientWidth,
            height: e.myInput.current.clientHeight
          });
        }), ji(Ei(e), "handleSignature", function (n) {
          var t = e.signCanvas.getTrimmedCanvas();
          t = e.changeCanvasContentColor(t);
          var r = e.props.fileName || "signature",
              a = t.toDataURL("image/png");
          t.toBlob(function (e) {
            localStorage.setItem(r, URL.createObjectURL(e));
          }, "image/jpeg", .5), e.setState({
            signatureUrl: a
          });
        }), ji(Ei(e), "changeCanvasContentColor", function (e) {
          for (var n = e.getContext("2d"), t = n.getImageData(0, 0, e.width, e.height), r = t.data, a = 0; a < r.length; a++) {
            r[a] = 255 - r[a], r[a + 1] = 255 - r[a + 1], r[a + 2] = 255 - r[a + 2];
          }

          return n.putImageData(t, 0, 0), e;
        }), e.state = {
          width: 0,
          height: 0,
          start: !0,
          showInfo: !0,
          signatureUrl: "",
          formData: new FormData()
        }, e.myInput = i.a.createRef(), e;
      }

      return n = o, (t = [{
        key: "clear",
        value: function value() {
          this.signCanvas.clear(), this.setState({
            showInfo: !0,
            signatureUrl: ""
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e = this;
          return i.a.createElement(bi, null, i.a.createElement("div", {
            ref: this.myInput,
            className: "backDeactivate"
          }, i.a.createElement(gi.a, {
            ref: function ref(n) {
              e.signCanvas = n;
            },
            className: "signCanvas",
            penColor: "white",
            canvasProps: {
              width: this.state.width,
              height: this.state.height,
              className: "signCanvas"
            },
            onBegin: function onBegin() {
              return e.setState({
                showInfo: !1
              });
            },
            onEnd: function onEnd(n) {
              return e.handleSignature(n);
            }
          }), this.state.showInfo && i.a.createElement("div", {
            className: "placeholder"
          }, i.a.createElement("span", {
            className: "placeholder-title"
          }, this.props.heading), i.a.createElement("div", {
            className: "placeholder-items"
          }, i.a.createElement("div", {
            className: "icon"
          }, i.a.createElement("img", {
            className: "leftImg",
            src: this.props.leftImage,
            alt: ""
          }), i.a.createElement("span", null, this.props.leftTitle)), i.a.createElement("div", {
            className: "icon2"
          }, i.a.createElement("div", {
            className: "ovalIcon"
          }, "o")), i.a.createElement("div", {
            className: "icon"
          }, i.a.createElement("img", {
            className: "rightImg",
            src: this.props.rightImage,
            alt: ""
          }), i.a.createElement("span", null, this.props.rightTitle)))), i.a.createElement("div", {
            className: "footer"
          }, i.a.createElement("span", null, this.props.clientName), i.a.createElement("span", null, this.props.date))), i.a.createElement("section", {
            className: "actionItems"
          }, i.a.createElement("div", {
            className: "transparentButton"
          }, i.a.createElement(R, {
            variant: "rounded",
            text: this.props.clearButtonText || "BORRAR",
            disabled: this.props.buttonsDisabled && !this.state.signatureUrl,
            color: F.textColorWhite,
            textColor: F.textColorTeal,
            borderColor: F.textColorTeal,
            onClick: this.clear.bind(this)
          })), i.a.createElement("div", {
            className: "solidButton"
          }, i.a.createElement("div", null, i.a.createElement(R, {
            variant: "rounded",
            text: this.props.confirmButtonText || "CONFIRMAR",
            disabled: this.props.buttonsDisabled && !this.state.signatureUrl,
            color: F.textColorTeal,
            textColor: F.textColorWhite,
            onClick: function onClick() {
              return e.props.handleClick(e.state.signatureUrl);
            }
          })))));
        }
      }]) && xi(n.prototype, t), r && xi(n, r), o;
    }(o.Component),
        Ni = t(44),
        Bi = t.n(Ni);

    function Ti(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var Ai = d.a.div(ki || (ki = Ti(["\n  margin: 10px 0px;\n  width: 100%;\n  .autoComplete-list-container {\n    opacity: 0.5 !important;\n    background: red !important;\n  }\n"]))),
        zi = Object(g.withStyles)({
      root: {
        '& .MuiAutocomplete-option[data-focus="true"]': {
          backgroundColor: "blue !important"
        }
      }
    })(Bi.a),
        Ri = Object(g.withStyles)({
      root: {
        width: "100%",
        "& MuiFormLabel-root.Mui-error": {
          color: "#00377B"
        },
        "& input": {
          color: "#00377B",
          borderWidth: 1
        },
        "& textarea": {
          color: "#00377B"
        },
        "& input.Mui-disabled": {
          color: "#949494",
          borderWidth: 1
        },
        "& label.Mui-focused": {
          color: "#00377B"
        },
        "& .MuiInput-underline:after": {
          borderBottomColor: "#00377B"
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "#949494"
          },
          "& .Mui-focused fieldset": {
            borderColor: "#00377B"
          }
        }
      }
    })(u.a),
        Di = d.a.div(Pi || (Pi = Ti(["\n  svg {\n    color: red !important;\n  }\n"]))),
        Zi = d.a.div(Si || (Si = Ti(["\n  svg {\n    color: #37c846 !important;\n  }\n"]))),
        qi = d.a.div(Fi || (Fi = Ti(["\n  svg {\n    color: #b7b7b7 !important;\n  }\n"]))),
        Ui = d.a.div(Ii || (Ii = Ti(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  .MuiListItem-root {\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    svg {\n      opacity: 0.5;\n    }\n  }\n  &:hover {\n    svg {\n      opacity: 1;\n    }\n\n  }\n"]))),
        Hi = d.a.div(Li || (Li = Ti(["\n  display: flex;\n  align-items: center;\n"]))),
        Vi = t(45),
        Wi = t.n(Vi),
        _i = t(46),
        Gi = t.n(_i),
        Yi = function Yi() {
      return i.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "20",
        viewBox: "0 0 16 20",
        className: "mr-15"
      }, i.a.createElement("defs", null, i.a.createElement("style", null, ".a{fill:#1d1d1f;}")), i.a.createElement("path", {
        class: "a",
        d: "M12,12a2,2,0,1,1,2-2A2.006,2.006,0,0,1,12,12Zm6-1.8a6,6,0,1,0-12,0c0,2.34,1.95,5.44,6,9.14C16.05,15.64,18,12.54,18,10.2ZM12,2a7.955,7.955,0,0,1,8,8.2q0,4.98-8,11.8Q4.005,15.175,4,10.2A7.955,7.955,0,0,1,12,2Z",
        transform: "translate(-4 -2)"
      }));
    },
        Qi = t(47),
        $i = t.n(Qi);

    function Xi() {
      return (Xi = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function Ki(e, n) {
      var t = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        n && (r = r.filter(function (n) {
          return Object.getOwnPropertyDescriptor(e, n).enumerable;
        })), t.push.apply(t, r);
      }

      return t;
    }

    function Ji(e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2 ? Ki(Object(t), !0).forEach(function (n) {
          el(e, n, t[n]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Ki(Object(t)).forEach(function (n) {
          Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
        });
      }

      return e;
    }

    function el(e, n, t) {
      return n in e ? Object.defineProperty(e, n, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = t, e;
    }

    function nl(e, n) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, n) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var t = [],
            r = !0,
            a = !1,
            o = void 0;

        try {
          for (var i, l = e[Symbol.iterator](); !(r = (i = l.next()).done) && (t.push(i.value), !n || t.length !== n); r = !0) {
            ;
          }
        } catch (e) {
          a = !0, o = e;
        } finally {
          try {
            r || null == l.return || l.return();
          } finally {
            if (a) throw o;
          }
        }

        return t;
      }(e, n) || function (e, n) {
        if (!e) return;
        if ("string" == typeof e) return tl(e, n);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === t && e.constructor && (t = e.constructor.name);
        if ("Map" === t || "Set" === t) return Array.from(e);
        if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return tl(e, n);
      }(e, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function tl(e, n) {
      (null == n || n > e.length) && (n = e.length);

      for (var t = 0, r = new Array(n); t < n; t++) {
        r[t] = e[t];
      }

      return r;
    }

    function rl(e, n) {
      if (null == e) return {};

      var t,
          r,
          a = function (e, n) {
        if (null == e) return {};
        var t,
            r,
            a = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || (a[t] = e[t]);
        }

        return a;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
        }
      }

      return a;
    }

    var al = Object(g.makeStyles)({
      paper: {
        width: function width(e) {
          return e.optionsWidth || "100%";
        },
        transform: function transform(e) {
          return "translate(".concat(e.optionsOffset || "0px", ")");
        },
        "@media (min-width: 600px)": {
          width: function width(e) {
            return e.optionsBigWidth || "100%";
          }
        }
      }
    }),
        ol = function ol(e) {
      var n = e.disabled,
          t = e.id,
          r = e.label,
          a = (e.color, e.name),
          l = e.onChange,
          c = (e.variant, e.options),
          s = e.getOptionLabel,
          u = void 0 === s ? function (e) {
        return e.displayName ? e.displayName : e.name;
      } : s,
          p = e.textFieldProps,
          d = void 0 === p ? {} : p,
          f = e.showCustomIcons,
          m = void 0 !== f && f,
          h = e.helperText,
          g = void 0 === h ? "" : h,
          y = e.showSuccessIcon,
          x = void 0 === y || y,
          v = e.infoIcon,
          C = void 0 === v || v,
          w = e.locationAutoComplete,
          E = rl(e, ["disabled", "id", "label", "color", "name", "onChange", "variant", "options", "getOptionLabel", "textFieldProps", "showCustomIcons", "helperText", "showSuccessIcon", "infoIcon", "locationAutoComplete"]),
          O = nl(Object(o.useState)(!1), 2),
          j = O[0],
          k = O[1],
          P = al(E),
          S = function S(e) {
        var n, t;
        return w ? i.a.createElement(Ui, null, i.a.createElement(Ao.a, null, i.a.createElement(Hi, null, u(e) && i.a.createElement(Yi, null), u(e))), (null === (n = u(e)) || void 0 === n ? void 0 : n.toLowerCase()) === (null === (t = u(null == c ? void 0 : c[(null == c ? void 0 : c.length) - 1])) || void 0 === t ? void 0 : t.toLowerCase()) ? function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          return i.a.createElement("div", {
            className: "custom-option-autocomplete",
            style: {
              display: "block",
              background: "white",
              marginTop: e ? "-20px !important" : "10px"
            }
          }, e && i.a.createElement("p", null, null == E ? void 0 : E.noOptionsText), i.a.createElement("p", null, "¿No encuentras tu dirección?"), i.a.createElement("span", {
            style: {
              fontSize: "14px",
              color: "#00C8FF"
            }
          }, "Pulsa aquí para buscarla "), i.a.createElement("span", {
            onClick: function onClick(e) {
              E.customOptionOnClick();
            },
            className: "direction-button-link-bold"
          }, "PASO A PASO."));
        }(!u(e)) : null) : i.a.createElement(Ao.a, null, u(e));
      },
          F = function F(e) {
        return w ? Ji(Ji({}, e.InputProps), {}, {
          endAdornment: w ? i.a.createElement(qi, null, j ? i.a.createElement($i.a, null) : i.a.createElement(b, null)) : null
        }) : Ji({}, e.InputProps);
      };

      return i.a.createElement(Ai, null, i.a.createElement(zi, Xi({
        disabled: n,
        id: t,
        classes: E.optionsWidth && {
          paper: P.paper
        },
        autoHighlight: !0,
        options: c,
        renderInput: function renderInput(e) {
          return i.a.createElement(Ri, Xi({
            label: r,
            helperText: g
          }, d, e, (null == d ? void 0 : d.additionalProps) || {}, {
            variant: "outlined",
            onFocus: function onFocus() {
              return k(!0);
            },
            onBlur: function onBlur() {
              return k(!1);
            },
            InputProps: F(e)
          }));
        },
        name: a,
        onChange: l,
        getOptionLabel: u,
        onClose: function onClose() {},
        closeIcon: null,
        popupIcon: m && d.error ? i.a.createElement(Di, null, C ? i.a.createElement(Wi.a, null) : i.a.createElement(Gi.a, null)) : m && E.value && x ? i.a.createElement(Zi, null, i.a.createElement(Se.a, null)) : w ? null : i.a.createElement(Wt.a, null),
        renderOption: function renderOption(e) {
          return S(e);
        },
        filterOptions: function filterOptions(e, n) {
          return w ? null != e && e.length ? e : [""] : null == c ? void 0 : c.filter(function (e) {
            var t, r, a;
            return null === (t = u(e)) || void 0 === t || null === (r = t.toLowerCase()) || void 0 === r ? void 0 : r.includes(null == n || null === (a = n.inputValue) || void 0 === a ? void 0 : a.toLowerCase());
          });
        }
      }, E)));
    };

    ol.propTypes = {
      disabled: c.a.bool,
      id: c.a.string,
      getOptionLabel: c.a.func.isRequired,
      onChange: c.a.func.isRequired,
      options: c.a.arrayOf(c.a.object).isRequired,
      showCustomIcons: c.a.bool
    }, ol.defaultProps = {
      disabled: !1,
      getOptionLabel: function getOptionLabel(e) {
        return null != e && e.displayName ? null == e ? void 0 : e.displayName : null == e ? void 0 : e.name;
      },
      onChange: function onChange() {},
      options: [],
      showCustomIcons: !1,
      showSuccessIcon: !0,
      infoIcon: !0,
      locationAutoComplete: !1,
      customOptionOnClick: function customOptionOnClick() {}
    };
    var il = ol;

    function ll(e) {
      return (ll = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function cl(e, n) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, n) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var t = [],
            r = !0,
            a = !1,
            o = void 0;

        try {
          for (var i, l = e[Symbol.iterator](); !(r = (i = l.next()).done) && (t.push(i.value), !n || t.length !== n); r = !0) {
            ;
          }
        } catch (e) {
          a = !0, o = e;
        } finally {
          try {
            r || null == l.return || l.return();
          } finally {
            if (a) throw o;
          }
        }

        return t;
      }(e, n) || function (e, n) {
        if (!e) return;
        if ("string" == typeof e) return sl(e, n);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === t && e.constructor && (t = e.constructor.name);
        if ("Map" === t || "Set" === t) return Array.from(e);
        if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return sl(e, n);
      }(e, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function sl(e, n) {
      (null == n || n > e.length) && (n = e.length);

      for (var t = 0, r = new Array(n); t < n; t++) {
        r[t] = e[t];
      }

      return r;
    }

    function ul(e, n) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function pl(e, n) {
      return (pl = Object.setPrototypeOf || function (e, n) {
        return e.__proto__ = n, e;
      })(e, n);
    }

    function dl(e) {
      var n = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var t,
            r = ml(e);

        if (n) {
          var a = ml(this).constructor;
          t = Reflect.construct(r, arguments, a);
        } else t = r.apply(this, arguments);

        return fl(this, t);
      };
    }

    function fl(e, n) {
      return !n || "object" !== ll(n) && "function" != typeof n ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : n;
    }

    function ml(e) {
      return (ml = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var hl = function (e) {
      !function (e, n) {
        if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(n && n.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), n && pl(e, n);
      }(o, e);
      var n,
          t,
          r,
          a = dl(o);

      function o(e) {
        var n;
        return function (e, n) {
          if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, o), (n = a.call(this, e)).dependencies = {}, n.updateKeys = {}, Object.values(n.props.inputList).forEach(function (e) {
          e.dependencies && (n.dependencies[e.id] = e.dependencies, e.dependencies.forEach(function (e) {
            n.updateKeys[e] = Math.random();
          }));
        }), n;
      }

      return n = o, (t = [{
        key: "componentWillUpdate",
        value: function value(e) {
          var n = this;
          Object.entries(this.dependencies).forEach(function (t) {
            var r = cl(t, 2),
                a = r[0],
                o = r[1];
            n.props.selectedOptions[a] != e.selectedOptions[a] && o.forEach(function (e) {
              n.updateKeys[e] = Math.random();
            });
          });
        }
      }, {
        key: "checkDisabled",
        value: function value(e) {
          var n = this.props,
              t = n.inputList,
              r = n.selectedOptions,
              a = t.find(function (n) {
            return n.id === e;
          });
          return !!a.dependentOn && a.dependentOn.find(function (e) {
            return !r[e];
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              n = this.props,
              t = n.options,
              r = n.inputList,
              a = n.handleChange,
              o = n.selectedOptions,
              l = n.noOptionsText,
              c = n.getOptionLabel,
              s = n.getOptionSelected,
              u = n.errors,
              p = void 0 === u ? {} : u,
              d = n.errorProps,
              f = void 0 === d ? {} : d;
          return i.a.createElement(i.a.Fragment, null, r.map(function (n) {
            return i.a.createElement(il, {
              label: n.label,
              key: e.updateKeys[n.id] ? e.updateKeys[n.id] : n.id,
              disabled: !t[n.id] || e.checkDisabled(n.id),
              options: t[n.id] || [],
              onChange: function onChange(e, t) {
                return a(t, n.id);
              },
              getOptionLabel: c,
              getOptionSelected: function getOptionSelected(e) {
                return s(e, o[n.id]);
              },
              noOptionsText: l,
              textFieldProps: p[n.id] ? f : {},
              value: t[n.id].length ? t[n.id].find(function (e) {
                return e.name === o[n.id];
              }) : {}
            });
          }));
        }
      }]) && ul(n.prototype, t), r && ul(n, r), o;
    }(i.a.Component);

    hl.defaultProps = {
      inputList: [],
      options: {},
      selectedOptions: {},
      handleChange: function handleChange() {},
      getOptionLabel: function getOptionLabel(e) {
        return e.displayName ? e.displayName : e.name;
      },
      noOptionsText: "Sin opciones",
      getOptionSelected: function getOptionSelected(e, n) {
        return e.name === n;
      }
    }, hl.propTypes = {
      inputList: c.a.arrayOf(c.a.object).isRequired,
      options: c.a.object.isRequired,
      handleChange: c.a.func.isRequired,
      selectedOptions: c.a.object.isRequired,
      noOptionsText: c.a.string,
      getOptionLabel: c.a.func.isRequired,
      getOptionSelected: c.a.func.isRequired
    };
    var gl = hl;

    function bl() {
      return (bl = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var yl = function yl(e) {
      var n = e.radioProps,
          t = e.classes,
          r = e.name,
          a = e.handleChange,
          o = e.selected,
          l = e.options,
          c = e.disabled;
      return i.a.createElement(ba.RadioGroup, {
        value: o,
        name: r,
        "aria-label": "Options",
        onChange: a,
        className: t.radioGroup
      }, l.map(function (e, r) {
        return i.a.createElement(ba.FormControlLabel, {
          key: r,
          control: i.a.createElement(ba.Radio, bl({
            className: "".concat(t.radio, " ").concat(c ? t.disabledRadio : ""),
            classes: {
              checked: t.checked
            }
          }, n, {
            disabled: c
          })),
          classes: {
            label: t.label
          },
          value: e.value,
          label: (null == e ? void 0 : e.displayComponent) || "".concat(e.text)
        });
      }));
    };

    yl.propTypes = {
      radioProps: c.a.object,
      classes: c.a.object,
      name: c.a.string,
      handleChange: c.a.func,
      selected: c.a.oneOfType([c.a.string, c.a.number]),
      options: c.a.array,
      labelComponent: c.a.node,
      disabled: c.a.bool
    }, yl.defaultProps = {
      options: [],
      labelComponent: null,
      disabled: !1
    };

    var xl,
        vl,
        Cl,
        wl,
        El,
        Ol,
        jl,
        kl,
        Pl,
        Sl = Object(ba.withStyles)({
      radioGroup: {
        width: "100%"
      },
      radio: {
        color: "#565656",
        padding: "0 10px 0 14px"
      },
      label: {
        color: "#565656",
        fontSize: 16
      },
      checked: {
        color: "#00c8ff !important"
      },
      disabledRadio: {
        color: "#e6e6e6 !important"
      }
    })(yl),
        Fl = function Fl() {
      return i.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12.613",
        height: "10.689",
        viewBox: "0 0 12.613 10.689"
      }, i.a.createElement("defs", null, i.a.createElement("style", null, ".tvSmall{fill:#fafafa;}")), i.a.createElement("path", {
        className: "tvSmall",
        d: "M19042.416,17458.688a.285.285,0,0,1,0-.568h8.049a.285.285,0,0,1,0,.568Zm3.436-1.184a.351.351,0,0,1-.354-.348v-.287a.455.455,0,0,1,.008-.074h-4.7a.829.829,0,0,1-.8-.85v-7.094a.832.832,0,0,1,.8-.854h11a.833.833,0,0,1,.807.854v7.094a.832.832,0,0,1-.807.85h-4.457a.455.455,0,0,1,.008.074v.287a.353.353,0,0,1-.355.348Zm-5.312-8.652v7.094a.286.286,0,0,0,.273.283h11a.276.276,0,0,0,.264-.283v-7.094a.276.276,0,0,0-.268-.285h-11A.278.278,0,0,0,19040.539,17448.852Z",
        transform: "translate(-19040.002 -17447.998)"
      }));
    },
        Il = function Il() {
      return i.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14.463",
        height: "10.828",
        viewBox: "0 0 14.463 10.828"
      }, i.a.createElement("defs", null, i.a.createElement("style", null, "{.tabInternetPromotionA{fill:#fafafa;}")), i.a.createElement("path", {
        className: "tabInternetPromotionA",
        d: "M19046.4,17458.242a.967.967,0,0,1,.205-1.045.936.936,0,0,1,1.031-.211.96.96,0,0,1-.359,1.844h0A.949.949,0,0,1,19046.4,17458.242Zm-2.9-3.059a.456.456,0,0,1-.25-.762,5.135,5.135,0,0,1,7.977,0,.455.455,0,0,1-.344.754.432.432,0,0,1-.338-.16,4.253,4.253,0,0,0-6.613,0,.445.445,0,0,1-.352.174A.552.552,0,0,1,19043.494,17455.184Zm-3.121-2.994a.447.447,0,0,1-.35-.3.463.463,0,0,1,.094-.455,9.1,9.1,0,0,1,14.23,0,.479.479,0,0,1,.113.346.458.458,0,0,1-.166.318.467.467,0,0,1-.291.094.481.481,0,0,1-.342-.164,8.206,8.206,0,0,0-12.859,0,.456.456,0,0,1-.354.172A.336.336,0,0,1,19040.373,17452.189Z",
        transform: "translate(-19040 -17448.002)"
      }));
    };

    function Ll(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var Ml = d.a.div(xl || (xl = Ll(["\n    margin: 0 17px;\n    min-height: ", ";\n    box-shadow: 0px 2px 2px #0000003D;\n    border-radius: 2px;\n    background: #FFFFFF;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 18px;\n    border-radius: 2px;\n    .MuiListItem-gutters { \n        padding-left: 0px;\n        color: #00C8FF\n    }\n    .MuiList-padding {\n        padding-top: 0px; \n        padding-bottom: 0px;\n    }\n    .MuiList-root {\n        width: 100%;\n    }\n    .MuiListItem-root { \n        padding-top: 0px; \n        padding-bottom: 0px;\n    }\n    .MuiListItemText-root {\n        flex: none;\n        .MuiTypography-body1 {\n            font-size: 14px;\n            font-weight: bold;\n            letter-spacing: 0;\n            line-height: 1;\n        }\n    }\n    .MuiCollapse-container {\n        pointer-events: none;\n        padding-top: 16px;\n        border-top: none;\n        padding-bottom: 10px;\n        .MuiListItem-gutters { \n            padding-right: 8px;\n            color: #565656;\n            font-size: 14px;\n        }\n        .MuiListItem-root {\n            justify-content: space-between;\n            padding-top: 4px;\n            padding-bottom: 4px;\n        }\n        .MuiListItemText-root {\n            flex: none\n            .MuiTypography-body1 {\n                font-size: 12px;\n                font-weight: normal;\n            }\n        }\n    }\n    @media (min-width: 768px) {\n        min-width: 480px;\n        max-width: 480px;\n    }\n"])), function (e) {
      return e.styled ? "130px" : "110px";
    }),
        Nl = d.a.div(vl || (vl = Ll(["\n    height: 20px;\n    background: #FFAA32;\n    display: flex;\n    padding: 0 10px;\n    align-items: center;\n    justify-content: space-between;\n    border-top-left-radius: 2px;\n    border-top-right-radius: 2px;\n     label {\n         font-size: 11px;\n         font-weight: 600;\n         color: #FFFFFF;\n     }\n     svg {\n         fill: #FFFFFF\n     }\n"]))),
        Bl = d.a.div(Cl || (Cl = Ll(["\nheight: 20px;\nbackground: #00377D;\ndisplay: flex;\npadding: 0 10px;\nalign-items: center;\njustify-content: space-between;\nborder-top-left-radius: 2px;\nborder-top-right-radius: 2px;\n label {\n     font-size: 11px;\n     font-weight: 600;\n     color: #FFFFFF;\n }\n svg {\n     fill: #FFFFFF\n }\n"]))),
        Tl = d.a.div(wl || (wl = Ll(["\nheight: 30px;\nbackground: #00377D;\ndisplay: flex;\npadding: 0 10px;\nalign-items: center;\njustify-content: space-between;\nborder-top-left-radius: 2px;\nborder-top-right-radius: 2px;\n label {\n     font-size: 12px;\n     font-weight: 700;\n     color: #FFFFFF;\n }\n svg {\n     fill: #FFFFFF\n }\n"]))),
        Al = d.a.div(El || (El = Ll(["\n    margin: 10px 10px 5px 10px;\n    display: flex;\n    label {\n        color: #00377B;\n        font-size: 18px;\n    }\n"]))),
        zl = d.a.div(Ol || (Ol = Ll(["\n    width: 100%;\n    display: flex;\n    min-height: 44px;\n    padding-left: 10px;\n    label {\n        font-size: 16px;\n    }\n"]))),
        Rl = d.a.div(jl || (jl = Ll(["\n    max-height: 36px;\n    position: absolute;\n    right: 10px;\n    top: -10px;\n    button {\n        height: 36px;\n        padding: 0;\n        margin: 0;\n        max-width: 93px;\n        max-height: 36px;\n        min-width: 93px;\n        min-height: 36px;\n        box-shadow: none;\n        background-color: #00C8FF \n    }\n"]))),
        Dl = d.a.div(kl || (kl = Ll(["\n    padding: 0 10px;\n    display: flex;\n    justify-content: space-between;\n    position relative;\n    margin-bottom: 20px;\n"]))),
        Zl = d.a.div(Pl || (Pl = Ll(["\n    height: 150px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: 00377B\n    \n"]))),
        ql = (t(50), function (e) {
      switch (e) {
        case "bundle":
          return i.a.createElement("div", {
            className: "promotion-bundle"
          }, i.a.createElement(Fl, null), i.a.createElement(Il, null));

        case "tv":
          return i.a.createElement(Fl, null);

        case "internet":
          return i.a.createElement(Il, null);
      }
    }),
        Ul = function Ul(e) {
      var n = e.packages,
          t = e.onItemClick,
          r = e.showEmptypackageInfo,
          a = e.showDescription,
          o = e.packageType,
          l = e.onDetailsClick,
          c = e.customFixed,
          s = e.textTransform,
          u = function u(e) {
        return e || "$";
      };

      return function (e) {
        return e.length ? e.map(function (e, n) {
          var r;
          return i.a.createElement(Ml, {
            className: "packageItem",
            onClick: function onClick() {
              return t(e);
            },
            styled: e.isDiscount || e.isPromotion,
            description: e.description,
            key: "package-".concat(n)
          }, e.isPromotion && i.a.createElement(Nl, null, i.a.createElement(me, {
            text: "¡PROMOCIÓN!"
          }), ql(o)), e.isDiscount && i.a.createElement(Bl, null, i.a.createElement(me, {
            text: "¡EN DESCUENTO!"
          }), ql(o)), e.subclassification && i.a.createElement(Tl, {
            className: "subclassification-wrapper"
          }, i.a.createElement(me, {
            text: null === (r = e.subclassification) || void 0 === r ? void 0 : r.toUpperCase()
          }), e.subclassificationType ? ql(e.subclassificationType) : null), i.a.createElement(Al, {
            className: "package-name"
          }, i.a.createElement(me, {
            style: {
              paddingBottom: e.description ? "0px" : "15px"
            },
            text: e.name,
            fontColor: "#00377B"
          })), e.description ? i.a.createElement(zl, {
            className: "package-description"
          }, i.a.createElement(me, {
            text: e.description,
            fontColor: "".concat(a ? "#565656" : "#00377B"),
            style: {
              fontSize: "".concat(a ? "16px" : "18px")
            }
          })) : null, i.a.createElement(Dl, {
            className: "package-details",
            onClick: function onClick(e) {
              l && l(), e && e.stopPropagation();
            }
          }, i.a.createElement(ni, {
            value: "VER DETALLES",
            listitems: e.additionalInfo.length ? e.additionalInfo.map(function (e) {
              return {
                name: e.name,
                value: "data" === e.type ? "".concat(e.value, " ").concat(e.unit) : e.value
              };
            }) : [],
            onClick: function onClick(e) {
              e && e.stopPropagation();
            }
          }), i.a.createElement(Rl, null, i.a.createElement(R, {
            onClick: function onClick(n) {
              n.stopPropagation(), t(e);
            },
            textTransform: s,
            text: c ? "".concat(u(e.currency)).concat(Number(e.price).toFixed(2)) : "".concat(u(e.currency)).concat(e.price),
            variant: "rounded"
          }))));
        }) : r ? i.a.createElement(Zl, null, "No hay paquetes para mostrar") : null;
      }(n);
    };

    Ul.defaultProps = {
      onItemClick: function onItemClick() {},
      packages: [],
      showEmptypackageInfo: !1,
      showDescription: !0,
      packageType: "bundle",
      customFixed: !0,
      textTransform: !1
    };
    var Hl,
        Vl,
        Wl = Ul;

    function _l(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var Gl = d()(ba.Paper)(Hl || (Hl = _l(["\n  background-color: ", " !important;\n  min-height:76px;\n  width:100%;\n  display:flex;\n  align-items:center;\n  justify-content: center;\n  box-shadow: 0px 2px 2px #0000003D;\n  border-radius: 2px;\n  flex-direction: column;\n  .addonName {\n    display: flex;\n    flex: 1;\n  }\n  .addonPrice {\n    display: flex;\n    min-width: 63px;\n  }\n"])), function (e) {
      return e.color;
    }),
        Yl = d.a.div(Vl || (Vl = _l(["\n  position: relative;\n  margin-right: 10px;\n  svg {\n    position: absolute;\n    right: 10px;\n  }\n"]))),
        Ql = Object(ba.makeStyles)(function () {
      return {
        checkbox: {
          color: "#DCDCDC",
          "& .MuiRadio-root": {
            color: "#DCDCDC"
          }
        },
        checkboxContainer: {
          display: "flex",
          alignItems: "center",
          width: "100%"
        },
        price: {
          paddingRight: 11,
          display: "flex",
          alignItems: "center"
        },
        formControl: {
          marginRight: 11
        },
        dropdown: {
          padding: 13
        },
        outlined: {
          padding: "0 !important"
        }
      };
    }),
        $l = t(48),
        Xl = t.n($l),
        Kl = function Kl(e) {
      var n,
          t,
          r,
          a,
          o,
          l = e.description,
          c = e.addonInfo,
          s = e.onClick,
          u = e.checked,
          p = e.selectedAddons,
          d = e.clearSelection,
          f = e.quantityOptions,
          m = Ql(),
          h = c.length && c.length > 1;
      return i.a.createElement(Gl, null, h ? i.a.createElement(i.a.Fragment, null, i.a.createElement("div", {
        className: m.checkboxContainer
      }, i.a.createElement(ft.a, {
        className: m.checkbox,
        onChange: function onChange(e) {
          return !e.target.checked && d(l);
        }
      }), i.a.createElement("div", {
        className: "addonName"
      }, i.a.createElement(me, {
        text: l,
        fontColor: "#787878",
        style: {
          flex: 1
        }
      }))), i.a.createElement("div", {
        className: m.checkboxContainer,
        style: {
          flexDirection: "column",
          paddingLeft: "40px",
          width: "calc(100% - 40px)"
        }
      }, c.map(function (e) {
        var n;
        return i.a.createElement("div", {
          className: m.checkboxContainer,
          style: {
            marginBottom: "10px"
          }
        }, i.a.createElement(Xl.a, {
          checked: !!p.find(function (n) {
            var t;
            return n.prodId === (null == e || null === (t = e.addon) || void 0 === t ? void 0 : t.prodId);
          }),
          onChange: e.onClick,
          value: e.description,
          className: m.checkbox
        }), i.a.createElement(me, {
          text: e.description,
          fontColor: "#787878",
          style: {
            flex: 1
          }
        }), i.a.createElement("span", {
          className: m.price
        }, e.showQuantity ? i.a.createElement(Yl, {
          className: "addonQtySelect"
        }, i.a.createElement($t, {
          options: f || [],
          onChange: e.onQuantitySelection,
          value: null !== (n = e.selectedQuantity) && void 0 !== n ? n : 1
        })) : null, i.a.createElement("span", {
          className: "addonPrice"
        }, i.a.createElement(me, {
          text: e.price,
          fontWeight: "bold",
          fontColor: "#787878",
          style: {
            fontSize: "20px",
            minWidth: "63px",
            textAlign: "right"
          }
        }))));
      }))) : i.a.createElement("div", {
        className: m.checkboxContainer
      }, i.a.createElement(ft.a, {
        className: m.checkbox,
        onChange: s,
        checked: u
      }), i.a.createElement("div", {
        className: "addonName"
      }, i.a.createElement(me, {
        text: l,
        fontColor: "#787878",
        style: {
          flex: 1
        }
      })), i.a.createElement("span", {
        className: m.price
      }, null !== (n = c[0]) && void 0 !== n && n.showQuantity ? i.a.createElement(Yl, {
        className: "addonQtySelect"
      }, i.a.createElement($t, {
        options: f || [],
        onChange: null === (t = c[0]) || void 0 === t ? void 0 : t.onQuantitySelection,
        value: null !== (r = null === (a = c[0]) || void 0 === a ? void 0 : a.selectedQuantity) && void 0 !== r ? r : 1
      })) : null, i.a.createElement("span", {
        className: "addonPrice"
      }, i.a.createElement(me, {
        text: null === (o = c[0]) || void 0 === o ? void 0 : o.price,
        fontWeight: "bold",
        fontColor: "#787878",
        style: {
          fontSize: "20px",
          minWidth: "63px",
          textAlign: "right"
        }
      })))));
    };

    Kl.defaultProps = {
      description: "",
      addonInfo: [],
      onClick: function onClick() {},
      checked: !1,
      selectedAddons: [],
      clearSelection: function clearSelection() {},
      quantityOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    }, Kl.propTypes = {
      description: c.a.string,
      addonInfo: c.a.array,
      onClick: c.a.func,
      checked: c.a.bool,
      selectedAddons: c.a.array,
      clearSelection: c.a.func,
      quantityOptions: c.a.array
    };
    var Jl,
        ec,
        nc,
        tc,
        rc,
        ac,
        oc,
        ic = Kl;

    function lc(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var cc = {};
    cc.Header = d.a.div(Jl || (Jl = lc(["\n    color: #00377B;\n    font-size: 18px;\n    @media screen and (max-width: 700px) {\n        font-size: 18px;\n    }"]))), cc.Modal = d.a.div(ec || (ec = lc(["\n    position: fixed;\n    display: ", ";\n    background: #0000008c;\n    height: 100%;\n    width: 100%;\n    z-index: 300;\n    left: 0;\n    top: 0;\n    align-items: center;\n    justify-content: center;\n"])), function (e) {
      return e.isOpen ? "flex" : "none";
    }), cc.Content = d.a.div(nc || (nc = lc(["\n    padding: 16px;\n    background: #fff;\n    text-align: left;\n    z-index: 3;\n    border-radius: 5px;\n    word-break: break-word;\n    width: calc(100% - 32px);\n    position: absolute;\n    bottom: 0;\n    border-radius: 15px 15px 0px 0px;\n    @media only screen  and (min-width : 768px) {\n        width: 50%;\n      };\n"]))), cc.CloseSection = d.a.div(tc || (tc = lc(["\n    display: flex;\n    justify-content: flex-end;\n"]))), cc.Close = d.a.span(rc || (rc = lc(["\n    color: ", ";\n    float: right;\n    font-size: 30px;\n    &:hover, &:focus {\n        color: black;\n        text-decoration: none;\n        cursor: pointer;\n    }\n"])), function (e) {
      return e.darkCloseBtn ? "#A0A0A0" : "#1ecfff";
    }), cc.ButtonSection = d.a.div(ac || (ac = lc(["\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 20px;\n"]))), cc.ButtonWrapper = d.a.div(oc || (oc = lc(["\n    display: flex;\n    justify-content: space-between;\n    button {\n        margin: 5px 10px;\n        box-shadow: none;\n    }\n\n"])));
    var sc = cc;

    function uc(e) {
      return (uc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function pc(e, n) {
      if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
    }

    function dc(e, n) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function fc(e, n) {
      return (fc = Object.setPrototypeOf || function (e, n) {
        return e.__proto__ = n, e;
      })(e, n);
    }

    function mc(e) {
      var n = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var t,
            r = bc(e);

        if (n) {
          var a = bc(this).constructor;
          t = Reflect.construct(r, arguments, a);
        } else t = r.apply(this, arguments);

        return hc(this, t);
      };
    }

    function hc(e, n) {
      return !n || "object" !== uc(n) && "function" != typeof n ? gc(e) : n;
    }

    function gc(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function bc(e) {
      return (bc = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function yc(e, n, t) {
      return n in e ? Object.defineProperty(e, n, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = t, e;
    }

    var xc = function (e) {
      !function (e, n) {
        if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(n && n.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), n && fc(e, n);
      }(o, e);
      var n,
          t,
          r,
          a = mc(o);

      function o() {
        var e;
        pc(this, o);

        for (var n = arguments.length, t = new Array(n), r = 0; r < n; r++) {
          t[r] = arguments[r];
        }

        return yc(gc(e = a.call.apply(a, [this].concat(t))), "onOk", function () {
          e.props.onOk();
        }), yc(gc(e), "onCancel", function () {
          e.props.onCancel();
        }), yc(gc(e), "onClose", function () {
          e.props.onClose && e.props.onClose();
        }), yc(gc(e), "closeModal", function (n) {
          "Modal_Background" === n.target.getAttribute("name") && e.props.onClose && e.props.onClose();
        }), e;
      }

      return n = o, (t = [{
        key: "componentDidMount",
        value: function value() {
          this.props.onOpen && this.props.onOpen();
        }
      }, {
        key: "render",
        value: function value() {
          return i.a.createElement(sc.Modal, {
            isOpen: this.props.visibility,
            name: "Modal_Background",
            onClick: this.closeModal
          }, i.a.createElement(sc.Content, {
            style: this.props.style ? this.props.style : {}
          }, this.props.showClose && i.a.createElement(sc.CloseSection, null, i.a.createElement(sc.Close, {
            darkCloseBtn: this.props.darkCloseBtn,
            onClick: this.onClose
          }, "×")), this.props.heading && i.a.createElement(sc.Header, {
            className: "popupTitle"
          }, this.props.heading), this.props.children, this.props.footer ? this.props.footer : i.a.createElement(sc.ButtonSection, null, i.a.createElement(sc.ButtonWrapper, null, this.props.cancelBtn && i.a.createElement(R, {
            text: this.props.cancelBtn,
            onClick: this.onCancel,
            style: this.props.cancelBtnStyles,
            color: "transparent"
          }), this.props.okBtn && i.a.createElement(R, {
            text: this.props.okBtn,
            onClick: this.onOk,
            style: this.props.okBtnStyles,
            variant: "rounded"
          })))));
        }
      }]) && dc(n.prototype, t), r && dc(n, r), o;
    }(o.Component);

    xc.propTypes = {
      children: c.a.node.isRequired,
      heading: c.a.string,
      okBtn: c.a.string,
      cancelBtn: c.a.string,
      okBtnStyles: c.a.object,
      cancelBtnStyles: c.a.object,
      onOk: c.a.func,
      onCancel: c.a.func,
      onClose: c.a.func,
      footer: c.a.node
    }, xc.defaultProps = {
      visibility: !1,
      showClose: !0,
      heading: "",
      okBtn: "",
      cancelBtn: ""
    };
    var vc,
        Cc,
        wc,
        Ec,
        Oc,
        jc,
        kc = xc,
        Pc = t(49),
        Sc = t.n(Pc);

    function Fc(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var Ic = d.a.div(vc || (vc = Fc(["\n  width: 120px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  height: 21px;\n  svg {\n    color: #00c8ff;\n  }\n"]))),
        Lc = d.a.span(Cc || (Cc = Fc(["\n  color: #00c8ff;\n  text-decoration: underline;\n  flex: 1;\n  z-index: 2;\n  text-align: left;\n  margin-left: 10px;\n"]))),
        Mc = d.a.div(wc || (wc = Fc(["\n  height: 122px;\n  width: 222px;\n  position: absolute;\n  right: 0;\n  top: 25px;\n  background: #ffffff;\n  box-shadow: 0px 2px 2px #0000003d;\n  border-radius: 2px;\n  opacity: 1;\n  z-index: 100;\n"]))),
        Nc = d.a.div(Ec || (Ec = Fc(["\n  height: 20px;\n  width: 100%;\n  background: ", "\n  color: #555555;\n  padding: 10px 0px;\n  text-align: left;\n  span {\n      margin-left: 13px;\n  }\n"])), function (e) {
      return e.selected ? "#DCDCDC" : "#ffffff";
    }),
        Bc = d.a.div(Oc || (Oc = Fc(["\n  width: 120px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  height: 21px;\n"]))),
        Tc = d.a.div(jc || (jc = Fc(["\n  position: absolute;\n  right: 0;\n  z-index: 0;\n  padding-top: 4px;\n"])));

    function Ac(e, n) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, n) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var t = [],
            r = !0,
            a = !1,
            o = void 0;

        try {
          for (var i, l = e[Symbol.iterator](); !(r = (i = l.next()).done) && (t.push(i.value), !n || t.length !== n); r = !0) {
            ;
          }
        } catch (e) {
          a = !0, o = e;
        } finally {
          try {
            r || null == l.return || l.return();
          } finally {
            if (a) throw o;
          }
        }

        return t;
      }(e, n) || function (e, n) {
        if (!e) return;
        if ("string" == typeof e) return zc(e, n);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === t && e.constructor && (t = e.constructor.name);
        if ("Map" === t || "Set" === t) return Array.from(e);
        if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return zc(e, n);
      }(e, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function zc(e, n) {
      (null == n || n > e.length) && (n = e.length);

      for (var t = 0, r = new Array(n); t < n; t++) {
        r[t] = e[t];
      }

      return r;
    }

    var Rc = i.a.forwardRef(function (e, n) {
      var t = e.listItems,
          r = e.callbacks,
          a = e.show,
          l = e.toggleShow,
          c = e.controlled,
          s = Ac(Object(o.useState)(!1), 2),
          u = s[0],
          p = s[1],
          d = Ac(Object(o.useState)(""), 2),
          f = d[0],
          m = d[1],
          h = u || a ? Uo.a : yr.a,
          g = c ? a : u;
      return i.a.createElement(Ic, {
        ref: n
      }, i.a.createElement(Bc, {
        onClick: function onClick(e) {
          e.stopPropagation(), c ? l(!a) : p(!u);
        }
      }, i.a.createElement(Sc.a, null), i.a.createElement(Lc, null, "Ordenar"), i.a.createElement(Tc, {
        onClick: function onClick(e) {
          e.stopPropagation();
        }
      }, i.a.createElement(h, null))), g && i.a.createElement(Mc, null, t.map(function (e, n) {
        return i.a.createElement(Nc, {
          key: n,
          onClick: function onClick() {
            var e = r[n];
            "function" == typeof e && e(), m(n);
          },
          selected: n === f
        }, i.a.createElement("span", null, e));
      })));
    });
    Rc.defaultProps = {
      listItems: [],
      callbacks: [],
      show: !1,
      toggleShow: function toggleShow() {},
      controlled: !1
    };
    var Dc,
        Zc,
        qc,
        Uc = Rc;

    function Hc(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var Vc = d.a.button(Dc || (Dc = Hc(["\n  width: fit-content;\n  min-height: ", ";\n  background-color: ", ";\n  color: ", ";\n  outline: none;\n  border: none;\n  margin: ", ";\n  border-radius: ", "\n  font-weight: 600;\n  padding: ", ";\n  border: ", "\n  box-shadow: ", ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: ", ";\n  cursor: pointer;\n  font-size: 14px;\n"])), function (e) {
      return "transparent" === e.color ? "20px" : "40px";
    }, function (e) {
      return e.color ? e.color : F.secondaryCyan;
    }, function (e) {
      return e.textColor || F.bgColorPrimary;
    }, function (e) {
      return "transparent" === e.color ? "".concat(e.marginTop, "px 0px") : "10px";
    }, function (e) {
      return "rounded" === e.variant ? "25px" : "0px";
    }, function (e) {
      return "transparent" === e.color ? "0px" : "10px 18px";
    }, function (e) {
      return e.borderColor ? "1px solid ".concat(e.borderColor) : "none";
    }, function (e) {
      return "transparent" !== e.color ? "0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)" : "none";
    }, function (e) {
      return "transparent" === e.color ? "20px" : "120px";
    }),
        Wc = d.a.span(Zc || (Zc = Hc(["\nwidth: 22px;\nheight: 22px;\nbackground-color: ", ";\nborder-radius: 15px;\nline-height: 27px;\nmargin-left: 7.5px;\nright: 10px;\n.loader{\n  width: 13px!important;\n  height: 13px!important;\n  color: #ffff;\n  svg{\n    width: 13px;\n    height: 13px;\n    padding: 0px;\n  }\n}\nsvg{\n  width: 20px;\n  height: 20px;\n  padding-top: 1px;\n}\n"])), function (e) {
      return e.isProcessing ? F.loaderIconBg : e.isSuccess ? F.successIconBg : e.isError ? F.errorBtnRed : F.loaderIconBg;
    }),
        _c = d.a.img(qc || (qc = Hc(["\n    height: 22px;\n    width: 19px\n"])));

    function Gc() {
      return (Gc = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function Yc(e, n) {
      if (null == e) return {};

      var t,
          r,
          a = function (e, n) {
        if (null == e) return {};
        var t,
            r,
            a = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || (a[t] = e[t]);
        }

        return a;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          t = o[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
        }
      }

      return a;
    }

    var Qc = function Qc(e, n, t, r) {
      return e ? F.disabledBlue : n ? F.isProcessingsecondaryCyan : !n && t ? F.successGreen : !r || n || t ? void 0 : F.errorBtnRed;
    },
        $c = function $c(e) {
      var n = e.onClick,
          t = e.text,
          r = e.textTransform,
          a = e.variant,
          o = e.disabled,
          l = e.color,
          c = e.isProcessing,
          s = e.isSuccess,
          u = e.showStatus,
          p = e.errorIcon,
          d = Yc(e, ["onClick", "text", "textTransform", "variant", "disabled", "color", "isProcessing", "isSuccess", "showStatus", "errorIcon"]);
      return i.a.createElement(Vc, Gc({
        onClick: n,
        variant: a,
        color: Qc(o, c, s, u) || l,
        disabled: o,
        isSuccess: s,
        isProcessing: c,
        isError: !c && !s,
        "data-testid": "loaderButton"
      }, d), r ? t : t.toUpperCase(), u && i.a.createElement(Wc, {
        isProcessing: c,
        isSuccess: s,
        isError: !c && !s,
        "data-testid": "icon"
      }, function (e, n, t) {
        return e ? i.a.createElement(X.a, {
          disableShrink: !0,
          className: "loader",
          thickness: 6,
          "data-testid": "circularProgress"
        }) : !e && n ? i.a.createElement(Oe.a, {
          "data-testid": "checkIcon"
        }) : e || n ? void 0 : i.a.createElement(_c, {
          src: t,
          alt: "error-icon"
        });
      }(c, s, p)));
    };

    $c.defaultProps = {
      onClick: function onClick() {},
      text: "",
      variant: "normal",
      disabled: !1,
      color: F.secondaryCyan,
      marginTop: 5,
      isProcessing: !1,
      isSuccess: !1,
      showStatus: !1,
      errorIcon: "/images/ico_location-error.svg"
    }, $c.propTypes = {
      onClick: c.a.func,
      text: c.a.string,
      variant: c.a.oneOf(["rounded", "normal"])
    };
    var Xc,
        Kc,
        Jc,
        es,
        ns,
        ts,
        rs,
        as,
        os,
        is,
        ls,
        cs,
        ss = $c;

    function us(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var ps,
        ds,
        fs,
        ms,
        hs,
        gs,
        bs = Object(p.css)(Xc || (Xc = us(["\nfont-family: Roboto;\nfont-style: normal;\n"]))),
        ys = Object(p.keyframes)(Kc || (Kc = us(["\n  from {\n    transform: scale(.25);\n    opacity: 0;\n  }\n\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n"]))),
        xs = Object(p.keyframes)(Jc || (Jc = us(["\n  from {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  to {\n    transform: scale(.25);\n    opacity: 0;\n  }\n"]))),
        vs = Object(p.css)(es || (es = us(["\nanimation: ", " .1s linear;\n"])), function (e) {
      return e.visibility ? ys : xs;
    }),
        Cs = d.a.div(ns || (ns = us(["\nposition : fixed;\nleft : 0;\ntop: 0;\nz-index: 500;\nwidth : 100%;\nheight : 100%;\nvisibility : ", ";\n", "\n"])), function (e) {
      return e.visibility ? "visible" : "hidden";
    }, function (e) {
      return e.animation ? vs : null;
    }),
        ws = d.a.div(ts || (ts = us(["\nwidth : 100%;\nheight : 100%;\nposition:absolute;\nbackground:", " ;\nopacity: 0.8;\n"])), function (e) {
      return e.transparentBg ? "transparent" : "rgb(35 35 36)";
    }),
        Es = d.a.div(rs || (rs = us(["\ndisplay :flex;\nalign-items : center;\njustify-content : center;\nheight : 100%;\nbox-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24);\nborder-radius: 2px;\npadding: 0px 12px;\nposition : relative;\nz-index : 999;\n"]))),
        Os = d.a.div(as || (as = us(["\nwidth : 650px;\nbackground : #fff;\ntext-align : center;\npadding : 24px 12px;\nbox-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24);\nbutton { \n    display : inline;\n    margin : 36px 0px 12px;\n}\n"]))),
        js = d.a.h4(os || (os = us(["\nfont-weight: normal;\nfont-size: 24px;\nline-height: 28px;\ntext-align: center;\ncolor : #00377D;\nmargin :0px 0px 30px;\n"]))),
        ks = d.a.img(is || (is = us(["\nwidth : 160px;\nheight : auto;\nmargin-bottom:30px;\n"]))),
        Ps = d.a.div(ls || (ls = us(["\n", ";\nfont-weight: bold;\nfont-size: 16px;\nline-height: 18px;\n/* identical to box height */\ntext-align: center;\ncolor: #565656;\nmargin-bottom : 12px;\n"])), bs),
        Ss = d.a.p(cs || (cs = us(["\n", ";\nfont-weight: normal;\nfont-size: 16px;\nline-height: 18px;\ntext-align: center;\ncolor: #565656;\nmargin:0pc;\n"])), bs);

    function Fs(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var Is = d.a.div(ps || (ps = Fs(["\ndisplay: flex !important;\njustify-content: center;\nwidth: 100%;\n"]))),
        Ls = Object(p.keyframes)(ds || (ds = Fs(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"]))),
        Ms = d.a.div(fs || (fs = Fs([" \n  background-color: #0F83A3;\n  padding: 5px; /* Padding around the spinner */\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  margin-left: 8px; /* Space between the text and the spinner container */\n"]))),
        Ns = d.a.div(ms || (ms = Fs(["\n  display: inline-block;\n  border: 3px solid #f3f3f3;\n  border-left:3px solid #0F83A3;\n  border-top: 3px solid #0F83A3;\n  background-color: #0F83A3;\n  border-radius: 50%;\n  width: 12px;\n  height: 12px;\n  animation: ", " 2s linear infinite;\n"])), Ls),
        Bs = d.a.button(hs || (hs = Fs(["\n  display: flex !important;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  padding-left: 25px;\n  padding-right: 20px;\n  background-color: #00C8FF;\n  color: white;\n  border: none;\n  border-radius: 25px;\n  font-size: 14px;\n  font-weight:600;\n  cursor: pointer;\n  min-height: 40px;\n  min-width: 130px;\n\n  &:hover {\n    background-color: #2980b9;\n  }\n"]))),
        Ts = d.a.span(gs || (gs = Fs(["\n  font-family: Roboto;\n  font-size: 14px;\n  font-weight: 500;\n"])));

    var As,
        zs,
        Rs = function Rs(e) {
      var n = e.text,
          t = e.onClick;
      return i.a.createElement(Is, null, i.a.createElement(Bs, {
        onClick: t
      }, i.a.createElement(Ts, null, n.toUpperCase()), i.a.createElement(Ms, null, i.a.createElement(Ns, null))));
    };

    function Ds(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var Zs = d.a.div(As || (As = Ds(["\nheight : 36px\nwidth : 36px;\nborder-radius : 100%;\nbackground: #FFFFFF;\nposition : absolute;\ntop : 10px;\nleft : 92px;\nbox-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);\nz-index : 9999;\ncursor : pointer;\n@media (max-width:1000px){\n    left : 12px;\n}\nimg{\n    width: 100%;\n    height: 100%;\n    padding: 9px;\n    box-sizing: border-box;\n}\n"]))),
        qs = d.a.img(zs || (zs = Ds([""]))),
        Us = function Us(e) {
      var n = e.onBackClick,
          t = e.className,
          r = e.backButtonImage;
      return i.a.createElement(Zs, {
        onClick: function onClick() {
          return n();
        },
        className: t
      }, i.a.createElement(qs, {
        src: r,
        alt: "Back Button"
      }));
    };

    function Hs(e, n) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, n) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var t = [],
            r = !0,
            a = !1,
            o = void 0;

        try {
          for (var i, l = e[Symbol.iterator](); !(r = (i = l.next()).done) && (t.push(i.value), !n || t.length !== n); r = !0) {
            ;
          }
        } catch (e) {
          a = !0, o = e;
        } finally {
          try {
            r || null == l.return || l.return();
          } finally {
            if (a) throw o;
          }
        }

        return t;
      }(e, n) || function (e, n) {
        if (!e) return;
        if ("string" == typeof e) return Vs(e, n);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === t && e.constructor && (t = e.constructor.name);
        if ("Map" === t || "Set" === t) return Array.from(e);
        if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Vs(e, n);
      }(e, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Vs(e, n) {
      (null == n || n > e.length) && (n = e.length);

      for (var t = 0, r = new Array(n); t < n; t++) {
        r[t] = e[t];
      }

      return r;
    }

    var Ws = function Ws(e) {
      var n = e.popUpShow,
          t = e.getLocation,
          r = e.imageURL,
          a = e.buttonText,
          l = e.popUpTitle,
          c = e.pouUpSubtile,
          s = e.poupBottomText,
          u = e.classSeltctor,
          p = void 0 === u ? null : u,
          d = e.showAnimation,
          f = void 0 === d || d,
          m = e.backButtonImage,
          h = e.transparentBg,
          g = e.onBackClick,
          b = e.buttonSpinner,
          y = void 0 !== b && b,
          x = Hs(Object(o.useState)(null), 2),
          v = x[0],
          C = x[1];
      Object(o.useEffect)(function () {
        if (y) {
          var e = setTimeout(function () {
            w();
          }, 5e3);
          return C(e), function () {
            return clearTimeout(e);
          };
        }
      }, [y]);

      var w = function w() {
        y && v && clearTimeout(v), function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return new Promise(function (n, t) {
            navigator.geolocation.getCurrentPosition(n, t, e);
          });
        }().then(function (e) {
          var n = e.coords,
              r = n.latitude,
              a = n.longitude,
              o = n.accuracy;
          t({
            access: !0,
            installationCoordinates: {
              latitude: r,
              longitude: a,
              accuracy: o
            }
          });
        }).catch(function (e) {
          1 === e.code && t({
            access: !1
          });
        });
      };

      return i.a.createElement(Cs, {
        visibility: n,
        className: p,
        animation: f
      }, i.a.createElement(ws, {
        transparentBg: h
      }), i.a.createElement(Us, {
        onBackClick: function onBackClick() {
          return g();
        },
        backButtonImage: m
      }), i.a.createElement(Es, null, i.a.createElement(Os, null, i.a.createElement(js, null, l || "Verificación de cobertura Tigo Hogar en tu zona"), i.a.createElement(ks, {
        src: r
      }), i.a.createElement(Ps, null, " ", c || "Revisaremos si hay cobertura en tu ubicación actual"), i.a.createElement(Ss, null, s || 'Si recibís una solicitud de ubicación, por favor elegí la opción "Permitir".'), y ? i.a.createElement(Rs, {
        text: a || "CONTINUAR",
        onClick: function onClick() {
          w();
        }
      }) : i.a.createElement(R, {
        text: a || "CONTINUAR",
        variant: "rounded",
        onClick: function onClick() {
          w();
        }
      }))));
    };
  }]);
});